// Translation catalogs. English is the default/fallback. Add keys here and
// provide all four languages (en, pt, es, it). Keys are flat, dot-namespaced.
export const LOCALES = {
  en: {
    "oidc.signingIn": "Signing you in to {app}…",
    "pub.login.continue": "Continue",
    "pub.login.change": "change",
    "pub.login.badCode": "Invalid code.",
    "pub.login.expired": "The sign-in session expired. Start again.",
    "pub.signOut": "Sign out",
    "pub.verified": "Verified",
    "pub.unverified": "Not verified",
    "pub.email": "E-mail",
    "pub.phone": "Mobile",
    "pub.biometric": "My biometric",
    "pub.enrolled": "Enrolled",
    "pub.home.title": "My details",
    "pub.home.subtitle": "The data we proved belongs to you.",
    "pub.login.title": "Sign in",
    "pub.login.subtitle": "Access your details and your biometric.",
    "pub.login.face": "Sign in with my face",
    "pub.login.faceWaiting": "Waiting for the capture…",
    "pub.login.or": "or",
    "pub.login.email": "E-mail",
    "pub.login.password": "Password",
    "pub.login.mfa": "Authenticator code",
    "pub.login.submit": "Sign in",
    "pub.login.register": "Create my account",
    "pub.login.invalid": "Invalid e-mail, password or code.",
    "pub.login.faceUnavailable": "Face sign-in is unavailable right now.",
    "pub.login.faceFailed": "We could not identify you. Try again.",
    "pub.login.notPortal": "This face does not belong to a portal account.",
    "pub.reg.title": "Create my account",
    "pub.reg.subtitle": "We confirm your e-mail and mobile, you set the password and MFA, and finally enroll your face.",
    "pub.reg.back": "Back to sign in",
    "pub.reg.stepData": "Details",
    "pub.reg.stepCodes": "Verification",
    "pub.reg.stepPassword": "Password",
    "pub.reg.stepMfa": "MFA",
    "pub.reg.firstName": "First name",
    "pub.reg.lastName": "Last name",
    "pub.reg.email": "E-mail",
    "pub.reg.phone": "Mobile (WhatsApp)",
    "pub.reg.sendCodes": "Send codes",
    "pub.reg.codesHelp": "We sent a different code to each channel. Confirm both.",
    "pub.reg.codeSent": "Code sent to {to}",
    "pub.reg.codeNotSent": "Could not send to {to}",
    "pub.reg.confirm": "Confirm",
    "pub.reg.password": "Password",
    "pub.reg.password2": "Repeat the password",
    "pub.reg.setPassword": "Set password",
    "pub.reg.mfaHelp": "Scan the QR in your authenticator app and type the generated code.",
    "pub.reg.finish": "Finish and enroll my face",
    "pub.reg.emailTaken": "That e-mail already has an account.",
    "pub.reg.badPhone": "Invalid phone.",
    "pub.reg.rate": "Too many attempts. Wait a few minutes.",
    "pub.reg.startFailed": "Could not start the registration.",
    "pub.reg.codeWrong": "Wrong code.",
    "pub.reg.codeExpired": "Code expired.",
    "pub.reg.codeFailed": "Could not confirm.",
    "pub.reg.mismatch": "The passwords do not match.",
    "pub.reg.passwordFailed": "Password refused by the policy.",
    "pub.reg.mfaWrong": "Invalid authenticator code.",
    "pub.enroll.title": "Enroll your face",
    "pub.enroll.body": "Your account only becomes active after the face enrollment. Open the capture, follow the on-screen instructions and come back here.",
    "pub.enroll.cta": "Open the capture",
    "pub.enroll.again": "Open the capture again",
    "pub.enroll.waiting": "Waiting for the capture to finish…",
    "pub.enroll.failed": "Could not start the capture.",
    "bio.via.admin": "Verified by admin",
    "bio.via.document": "Verified by document",
    "bio.via.code": "Verified by code",
    "bio.via.legacy": "Verified (legacy — predates the rule)",
    "bio.identVerified": "Verified",
    "bio.identUnverified": "Not verified — not exposed to consumers",
    "profile.title": "My details",
    "profile.subtitle": "Confirm you own your e-mail and phone. Every change needs a code sent to the contact itself.",
    "profile.email": "E-mail",
    "profile.phone": "Phone (WhatsApp)",
    "profile.verified": "Verified",
    "profile.unverified": "Not verified",
    "profile.verify": "Verify",
    "profile.change": "Change",
    "profile.sendCode": "Send code",
    "profile.confirm": "Confirm",
    "profile.resend": "Resend",
    "profile.codeSent": "Code sent to {to}. It expires in {ttl} minutes.",
    "profile.emailHelp": "We will send a code to this e-mail. It only takes effect after you confirm.",
    "profile.phoneHelp": "We will send a code by WhatsApp. It only takes effect after you confirm.",
    "profile.codeWrong": "Wrong code.",
    "profile.codeExpired": "Code expired — send a new one.",
    "profile.codeBlocked": "Too many attempts. Send a new code.",
    "profile.sendFailed": "Could not send the code.",
    "profile.verifyFailed": "Could not confirm.",
    "profile.notSent": "Could not deliver the code through this channel.",
    "search.title": "Search",
    "search.placeholder": "Search the whole system…",
    "search.hint": "Name, e-mail, CPF, phone, company, app or session id. Esc to close.",
    "search.enter": "Enter",
    "search.found": "{n} result(s) for “{q}”",
    "search.empty": "Nothing found. Sensitive values (e-mail, CPF, phone) are encrypted and only match by their exact value.",
    "search.type.biometric": "Biometrics",
    "search.type.account": "Accounts",
    "search.type.session": "Verifications",
    "search.type.company": "Companies",
    "search.type.client_app": "Client apps",
    "search.type.person": "People",
    "search.type.alert": "Alerts",
    "globalConfig.docPhotoMatch": "Printed photo × signed photo",
    "globalConfig.docPhotoMatchHelp": "The QR photo is signed (tamper-proof) but tiny (~45x61), which degrades recognition. The PDF also carries a high-resolution copy, but unsigned. This is the minimum pixel correlation between the two for the printed photo to be accepted and used for the face match. Higher = stricter (a swapped photo never passes); lower = tolerates print/compression differences.",
    "bio.docPhotoSrc": "Photo used",
    "bio.docPhotoVisible": "printed, high-resolution (validated against the signed one)",
    "bio.docPhotoQr": "from the QR (signed)",
    "globalConfig.change": "Change",
    "globalConfig.modelTitle": "Change the recognition model",
    "globalConfig.modelWarn": "This change invalidates EVERY enrolled biometric.",
    "globalConfig.modelWarnBody": "The model generates the facial signature: changing it changes the vector space, so no existing template can be compared any more. Everyone must re-enroll, the pre-filter (ANN) must be retrained, and authentications will fail until then.",
    "globalConfig.modelCurrent": "Current model",
    "globalConfig.modelNew": "New model",
    "globalConfig.modelEnrollments": "Enrollments invalidated",
    "globalConfig.modelPeople": "People affected",
    "globalConfig.modelGold": "Gold biometrics",
    "globalConfig.modelType": "To confirm, type",
    "globalConfig.modelApply": "Change model",
    "globalConfig.modelFailed": "Could not change the model.",
    "bio.removeIdentity": "Remove identity",
    "bio.removeIdentityBody": "Remove {id} from this biometric? The person will no longer be found by this identity.",
    "bio.docSigner": "Signed by",
    "bio.docCert": "Certificate",
    "bio.docThumb": "Thumbprint",
    "bio.docPubKey": "Public key",
    "bio.downloadDoc": "Download document",
    "bio.reactivate": "Restore previous enrollment",
    "bio.newEnrollLink": "Generate enrollment link",
    "bio.enrollLinkHelp": "Open this link (or scan the QR) on the phone to redo the biometric enrollment.",
    "bio.inactive": "inactive",
    "bio.reviewTitle": "Document awaiting review",
    "bio.reviewBody": "The similarity between the document photo and the enrolled face landed in the review band.",
    "bio.approve": "Approve",
    "bio.reject": "Reject",
    "globalConfig.docBandsHelp": "Decision bands for the similarity between the DOCUMENT photo and the enrolled biometric: below the 1st threshold the document is refused; between the two it goes to an admin for manual review; above the 2nd it grants the Gold tier automatically.",
    "globalConfig.bandDeny": "Deny",
    "globalConfig.bandReview": "Review",
    "globalConfig.bandAllow": "Allow",
    "doc.reason.reviewPending": "Sent for admin review — the face match was not conclusive.",
    "alerts.document_review": "Document awaiting manual review",
    "bio.typeToConfirm": "To confirm, type",
    "bio.deenrollTitle": "Remove biometric enrollment",
    "bio.deenrollBody": "Removes this person’s face template — they can no longer authenticate until enrolling again.",
    "bio.addIdentity": "Add identity",
    "bio.addIdentityHelp": "Link an e-mail, CPF, phone or external id to this biometric. Each identity is unique across the whole system.",
    "sessions.bioMatch": "Biometric match",
    "sessions.bioIdentified": "Identified",
    "alerts.duplicate_identity": "Same identity on two biometrics",
    "doc.upload": "Upload a document...",
    "bio.docPhoto": "Document photo",
    "bio.noDocPhoto": "No photo",
    "bio.docName": "Full name",
    "bio.docCpf": "CPF",
    "bio.docBirth": "Birth date",
    "bio.revealData": "Show full data",
    "bio.hideData": "Hide data",
    "bio.docAttempts": "Document read attempts",
    "bio.date": "Date",
    "bio.docFile": "File",
    "bio.docResult": "Result",
    "bio.docSim": "Similarity",
    "bio.docBy": "By",
    "globalConfig.docFace": "Document × face (Gold)",
    "globalConfig.docFaceHelp": "Minimum similarity between the DOCUMENT photo and the enrolled biometric to grant the Gold tier. Higher = stricter (prevents someone else’s document), but may reject old/low-quality document photos.",
    "doc.reason.faceMismatch": "The document photo does not match the enrolled face.",
    "doc.reason.photoUnavailable": "Could not read the document photo.",
    "doc.reason.docNoFace": "No usable face in the document photo.",
    "doc.reason.noEnrollment": "Enroll the face before verifying a document.",
    "clientAppForm.genConfig": "Generate example config (.env)",
    "clientAppForm.genConfigTitle": "Example config (relying party)",
    "clientAppForm.genConfigHint": "Fill SEC_FACE_OIDC_CLIENT_SECRET with the app secret (shown on create/rotate).",
    "clientAppForm.cfgError": "Failed to generate the config.",
    "clientAppForm.copy": "Copy",
    "clientAppForm.copied": "Copied!",
    "common.close": "Close",
    "clientAppForm.minTier": "Minimum tier (biometrics)",
    "clientAppForm.minTierHelp": "Minimum trust tier required to authenticate by biometrics in this app.",
    "oidc.tierTitle": "Verification level too low",
    "oidc.tierBody": "This app requires the {req} level, but your biometric is {cur}.",
    "oidc.tierHow": "How to level up",
    "oidc.tierSilver": "Silver: ask an administrator to confirm your biometric.",
    "oidc.tierGold": "Gold: upload a valid national document (driver license) on your account for verification.",
    "bio.tier": "Trust tier",
    "bio.tierHelp": "Bronze: initial. Silver: human-confirmed. Gold: verified valid national document.",
    "bio.bronze": "Bronze",
    "bio.silver": "Silver",
    "bio.gold": "Gold",
    "bio.confirmSilver": "Confirm (Silver)",
    "bio.revertBronze": "Revert to Bronze",
    "bio.goldDoc": "Document",
    "bio.goldExpiry": "Expiry",
    "doc.verifyGold": "Verify document (Gold)",
    "doc.hint": "Upload the digital driver license/document (PDF or QR image). Offline verification; accepts authentic documents expired at most 6 months ago.",
    "doc.gold": "Document verified — Gold tier granted.",
    "doc.reason.notAuthentic": "Document is not authentic (signature check failed).",
    "doc.reason.sandbox": "Sandbox/sample document — not accepted.",
    "doc.reason.expired": "Document expired more than 6 months ago.",
    "doc.reason.noExpiry": "Could not read the expiry date.",
    "doc.reason.parseFailed": "Could not read the document.",
    "doc.reason.unavailable": "Document verification is unavailable.",
    "doc.reason.empty": "Empty file.",
    "nav.alerts": "Alerts",
    "globalConfig.dupAlert": "Duplicate-biometric alert",
    "globalConfig.dupAlertHelp": "Above this value two ENROLLED biometrics of different people raise a Super-Admin alert (possibly the same person in two records). Higher = fewer alerts (only near-identical look-alikes).",
    "alerts.title": "Security alerts",
    "alerts.subtitle": "Fraud attempts per account and possible duplicate biometrics.",
    "alerts.tab.open": "Open",
    "alerts.tab.dismissed": "Dismissed",
    "alerts.tab.resolved": "Resolved",
    "alerts.tab.all": "All",
    "alerts.empty": "No alerts.",
    "alerts.error": "Error",
    "alerts.account": "Account",
    "alerts.kind.fraud": "Fraud attempt",
    "alerts.kind.duplicate": "Possible duplicate",
    "alerts.kind.blacklist": "Blacklisted use",
    "alerts.blockTitle": "Block account",
    "alerts.blockBody": "The account will be deactivated and can no longer sign in. Confirm?",
    "alerts.block": "Block account",
    "alerts.notify": "Notify owner",
    "alerts.mergeTitle": "Merge biometrics",
    "alerts.mergeKeepA": "Keep {a} and remove {b}?",
    "alerts.mergeKeep": "Keep",
    "alerts.dismiss": "Dismiss",
    "alerts.cancel": "Cancel",
    "alerts.confirm": "Confirm",
    "bio.governance": "Governance",
    "bio.enabledLabel": "Biometric enabled",
    "bio.enabledHelp": "Disable to block use in authentication without deleting the enrollment.",
    "bio.enabled": "Enabled",
    "bio.disabled": "Disabled",
    "bio.blacklist": "Blacklist",
    "bio.blacklistHelp": "Deny all use, or just alert the Super Admin on every use.",
    "bio.blNone": "Normal",
    "bio.blDeny": "Deny all use",
    "bio.blAlert": "Alert only",
    "bio.hardDeleteTitle": "Delete biometric",
    "bio.hardDeleteBody": "Permanently deletes this unused biometric (no enrollment, no usage history). Irreversible.",
    "bio.hardDelete": "Delete (hard-delete)",
    "account.faceHelp2": "Generate a link for this person to enroll their face, or link the account to an existing biometric. They can then sign in by face on the login screen.",
    "face.link.linkedTo": "Linked to",
    "face.link.enrolled": "enrolled",
    "face.link.notEnrolled": "no template",
    "face.link.unlink": "Unlink",
    "face.link.none": "No biometrics linked to this account.",
    "face.link.pickCta": "Link to existing biometric",
    "face.link.pickTitle": "Link to existing biometric",
    "face.link.searchPh": "Search by name or identity…",
    "face.link.noResults": "No people found.",
    "face.link.failed": "Operation failed.",
    "account.faceTitle": "Facial biometrics",
    "account.faceHelp": "Generate a link (with QR) for this person to enroll their face. They can then sign in with their face on the login screen.",
    "face.enroll.generate": "Generate face enrollment link",
    "face.enroll.regenerate": "Update face enrollment",
    "login.mfaInvalid": "Invalid code. Please try again.",
    "globalConfig.secOidc": "OIDC face login — e-mail confirmation",
    "globalConfig.oidcNote": "On external-app face login (OIDC), when the 1:N match is AMBIGUOUS we require an e-mail confirmation (code). These two values define what counts as 'ambiguous'.",
    "globalConfig.oidcConf": "Confidence margin",
    "globalConfig.oidcConfHelp": "How far the best match must exceed the authentication threshold to be accepted WITHOUT an e-mail confirmation. Higher = asks for e-mail more often (safer, less convenient).",
    "globalConfig.oidcSep": "Top-1 vs top-2 gap",
    "globalConfig.oidcSepHelp": "Minimum distance between the two most similar faces. If two candidates are too close, it is ambiguous → e-mail is required. Higher = stricter against look-alikes.",
    "oidc.scope.openid": "Identity (unique identifier)",
    "oidc.scope.profile": "Profile name",
    "oidc.scope.email": "E-mail address",
    "oidc.loadError": "Could not load the request.",
    "oidc.invalidRequest": "Invalid request.",
    "oidc.noEmail": "No e-mail on file for confirmation.",
    "oidc.otpSendFailed": "Failed to send the code.",
    "oidc.otpInvalid": "Invalid or expired code.",
    "oidc.unexpected": "Unexpected server response.",
    "oidc.confirmFirst": "Confirm your identity by e-mail first.",
    "oidc.completeFailed": "Could not complete.",
    "oidc.failedTitle": "Authentication not completed",
    "oidc.failedBody": "The face verification was not approved. You can return to the app and try again.",
    "oidc.backToApp": "Back to the app",
    "oidc.title": "Authorize access",
    "oidc.intro": "the app",
    "oidc.client": "client",
    "oidc.introTail": "wants to access your biometrically verified identity.",
    "oidc.confirmTitle": "Identity confirmation",
    "oidc.confirmBody": "For your security, we need to confirm your identity by e-mail",
    "oidc.sending": "Sending…",
    "oidc.sendCode": "Send code by e-mail",
    "oidc.confirm": "Confirm",
    "oidc.confirmed": "Identity confirmed by e-mail.",
    "oidc.willShare": "Will be shared",
    "oidc.deny": "Deny",
    "oidc.authorize": "Authorize",
    "oidc.alreadyConsented": "You have authorized this app before.",
    "oidc.revokeNote": "You can revoke this access at any time.",
    "globalConfig.defaultIs": "default",
    "globalConfig.secLiveness": "Liveness",
    "globalConfig.secMatch": "Face recognition (match thresholds)",
    "globalConfig.secAnn": "1:N search pre-filter (ANN)",
    "globalConfig.flashCut": "Flashmark gate",
    "globalConfig.flashCutHelp": "Minimum correlation (0–1) between the screen color flashes and the reflection on the face to count as LIVE. Below this the session fails as a spoof (photo/screen). Higher = stronger against screens but more sensitive in very bright rooms.",
    "globalConfig.cosineNote": "Cosine similarity values (0 to 1). Higher = stricter (fewer false accepts, but more legitimate people rejected). Leave blank to use the default.",
    "globalConfig.authSim": "Face login (1:1 & 1:N)",
    "globalConfig.authSimHelp": "Cutoff to authenticate by biometrics — both your own face login (1:N among system users) and 1:1 app authentication. The most security-sensitive knob: raising it lowers the risk of accepting the wrong person (FAR); lowering it eases access.",
    "globalConfig.kycSim": "KYC — selfie × document",
    "globalConfig.kycSimHelp": "Cutoff to consider the live selfie the same person as the document photo. Usually LOWER than login, since matching a printed/old photo to a live face is harder (print, age, lighting).",
    "globalConfig.samePerson": "'Same person' gate (capture)",
    "globalConfig.samePersonHelp": "During capture, requires the cropped face, the full frame and the gesture photo to be the SAME person. Below this the session fails (face swap / different people in the video). Too high may reject legitimate captures at varied angles.",
    "globalConfig.matchSim": "Auto-link (people registry)",
    "globalConfig.matchSimHelp": "In the People registry, cutoff to auto-link a new capture to an existing person in the same company. Higher = creates more separate people; lower = groups more (risk of merging different people).",
    "globalConfig.dupSim": "Duplicate photo",
    "globalConfig.dupSimHelp": "Above this value two photos are treated as the SAME image (not merely the same person) and the duplicate is not stored. Deliberately high; lowering it may discard valid different photos of the same person.",
    "globalConfig.recognizer": "Recognition model (ArcFace)",
    "globalConfig.recognizerDefault": "default (buffalo_l)",
    "globalConfig.recognizerL": "most accurate (auth)",
    "globalConfig.recognizerSc": "lighter/faster",
    "globalConfig.recognizerHelp": "Model that generates the facial signature. CHANGING IT INVALIDATES every existing enrollment (the vector space changes) — everyone must re-enroll and the pre-filter must be retrained. Only change with a migration plan.",
    "globalConfig.annNote": "Speeds up 1:N search by filtering the base through a coarse index before comparing (and decrypting) record by record. Does not affect the match decision, only performance and search coverage.",
    "globalConfig.nprobe": "Centroids probed (nprobe)",
    "globalConfig.nprobeHelp": "How many index 'buckets' the search opens. Higher = more candidates compared (higher recall, but more decryptions and slower); lower = faster, with a risk of skipping the true match.",
    "globalConfig.annMin": "Min enrollments to train",
    "globalConfig.annMinHelp": "Below this count the pre-filter is NOT trained and the search does a full scan (recall-safe). Training the index only makes sense once the base is large enough.",
    "globalConfig.retrainGrowth": "Growth to retrain",
    "globalConfig.retrainGrowthHelp": "Base growth fraction (e.g. 0.25 = +25%) since the last training for the automatic retrain (in the reaper) to fire. Higher = retrains less often.",
    "globalConfig.retrainDelta": "New enrollments to retrain",
    "globalConfig.retrainDeltaHelp": "Beyond the percentage, requires at least this many new templates since the last training before retraining. Avoids costly retrains for small changes.",
    "login.face.button": "Sign in with your face",
    "login.face.starting": "Starting…",
    "login.face.failed": "Face verification was not approved.",
    "login.face.unavailable": "Face login unavailable right now.",
    "face.enroll.title": "Facial biometrics",
    "face.enroll.cta": "Enroll my face",
    "face.enroll.manage": "My face",
    "face.enroll.hint": "Open the link (or scan the QR) to enroll your face. Then you can sign in with your face on the login screen.",
    "face.enroll.reHint": "Open the link to update your face enrollment. Then you can sign in with your face on the login screen.",
    "face.enroll.generating": "Generating link…",
    "face.enroll.failed": "Failed to generate the enrollment link.",
    "face.enroll.open": "Open enrollment",
    "bio.prefilterOn": "Pre-filter",
    "bio.analyzed": "analyzed",
    "bio.fewer": "fewer exact compares",
    "bio.prefilterOff": "Full scan",
    "bio.records": "records",
    "bio.prefilterUntrained": "pre-filter not trained yet",
    "bio.notFound": "Person not found.",
    "bio.loadFailed": "Failed to load.",
    "bio.back": "Back to biometrics",
    "bio.notEnrolled": "Not enrolled",
    "bio.authCount": "Authentications",
    "bio.readings": "Readings",
    "bio.lastAuth": "Last",
    "bio.authentications": "Recent authentications",
    "bio.noSessions": "No sessions yet.",
    "bio.session": "Session",
    "bio.date": "Date",
    "bio.mode": "Mode",
    "bio.result": "Result",
    "bio.score": "Score",
    "bio.match": "Match",
    "bio.noMatch": "No match",
    "bio.dangerZone": "Danger zone",
    "bio.noActions": "No actions available.",
    "bio.searchByPhoto": "Search by photo",
    "bio.searching": "Searching…",
    "bio.errNoFace": "No usable face in the uploaded photo.",
    "bio.errSearchFailed": "Photo search failed.",
    "bio.sortedBySimilarity": "Ranked by facial similarity",
    "bio.matches": "match(es)",
    "bio.clear": "clear",
    "bio.similarity": "Similarity",
    "bio.noMatches": "No similar people found.",
    // Live wall (liveness video wall)
    "nav.wall": "Wall",
    "wall.title": "Live wall",
    "wall.screens": "Screens",
    "wall.cameras": "Cameras",
    "wall.both": "Screens + Cameras",
    "wall.emptyBoth": "No live sessions.",
    "nav.eventWall": "Event wall",
    "nav.health": "Health",
    "nav.jobsQueue": "Jobs Queue",
    "nav.reviewQueue": "Review",
    "nav.coldSync": "Cold sync",
    "nav.coldStorage": "Cold Storage",
    "health.title": "Health",
    "health.subtitle": "Live capture health per participant.",
    "health.problems": "{n} with problems",
    "health.refresh": "Refresh",
    "health.loading": "Loading…",
    "health.empty": "No live sessions.",
    "health.audio": "Audio",
    "eventwall.title": "Event wall",
    "eventwall.event": "Event",
    "eventwall.noEvents": "No live events",
    "eventwall.presets": "Presets",
    "eventwall.presetTop": "Top 10 (position)",
    "eventwall.presetCombo": "Top 8 (Screen + Camera)",
    "eventwall.presetAll": "All",
    "eventwall.presetsHint": "Custom presets coming soon.",
    "eventwall.empty": "No live participants in this event.",
    "eventwall.countries": "Countries",
    "eventwall.participants": "Participants",
    "eventwall.performance": "PERFORMANCE",
    "eventwall.live": "(LIVE)",
    "eventwall.score": "Score",
    "eventwall.solved": "Solved Challenges",
    "eventwall.lastSubmit": "Last Submit",
    "eventwall.points": "POINTS",
    "eventwall.challenges": "CHALLENGES",
    "eventwall.overallProgress": "OVERALL PROGRESS",
    "eventwall.officialTime": "OFFICIAL TIME",
    "eventwall.category": "Last submit category",
    "eventwall.ago": "ago",
    "eventwall.pts": "pts",
    "eventwall.castObs": "Show this on the OBS output",
    "eventwall.castObsActive": "Live on OBS",
    "eventwall.castHint": "The cast button sends the preset (with the current Screens/Cameras choice) to the OBS output live.",
    "recording.obsEnable": "Enable OBS URL",
    "recording.obsHint": "Public OBS Browser output of the Event wall — no login, restricted to the client IP(s) below.",
    "recording.obsIps": "OBS client IP(s)",
    "recording.obsUrl": "OBS Browser URL",
    "recording.obsUrlHint": "Paste into an OBS 'Browser' source. Append ?kind=camera or ?preset=all to change the view.",
    "wall.screen": "Screen",
    "wall.camera": "Camera",
    "wall.live": "Live",
    "wall.offline": "Offline",
    "wall.listen": "Listen",
    "wall.mute": "Mute",
    "wall.expand": "Open full view",
    "wall.refresh": "Refresh",
    "wall.loading": "Loading…",
    "wall.participant": "participant",
    "wall.liveCount": "{n} live",
    "wall.emptyScreens": "No live sessions sharing a screen.",
    "wall.emptyCameras": "No live sessions sharing a camera.",
    "wall.unsupported": "This browser can't decode the live wall. Use Chrome or Edge.",
    // Login — shared
    "login.email": "E-mail",
    "login.email.placeholder": "you@example.com",
    "login.password": "Password",
    "login.password.placeholder": "Enter your password",
    "login.submit": "Sign in",
    "login.continue": "Continue",
    "login.back": "← Back",
    "login.or": "or",
    "login.newPassword": "New password",
    "login.confirmPassword": "Confirm password",
    "login.saveAndEnter": "Save and continue",
    // Login — contestant
    "login.contestant.title": "Contestant access",
    "login.contestant.subtitle": "Sign in with your e-mail and password.",
    "login.contestant.help": "Trouble signing in? Contact your exam liveness.",
    "sessionAuth.title": "Exam access",
    "sessionAuth.subtitle": "Enter the session token provided to start your exam.",
    "sessionAuth.token": "Session token",
    "sessionAuth.token.placeholder": "Paste your session token",
    "sessionAuth.submit": "Enter",
    "sessionAuth.invalid": "Invalid or expired session token.",
    "sessionAuth.help": "Trouble accessing? Contact your exam liveness.",
    "login.setPassword.title": "Set a new password",
    "login.setPassword.subtitle": "You must change your password on first access.",
    // Login — liveness (system)
    "login.system.title": "Access the system",
    "login.system.emailSubtitle": "Enter the e-mail registered in the system.",
    "login.system.emailHelp": "If you don't remember your registered e-mail, reach us at",
    "login.system.passwordSubtitle": "Enter your account password to continue.",
    "login.oidc": "Sign in with Office 365",
    "login.mfa.subtitle": "Enter the 6-digit code sent to your e-mail.",
    "login.mfa.submit": "Validate code",
    "login.mfa.notReceived": "Didn't get the code?",
    "login.mfa.resend": "Resend",
    "login.change.title": "Change password",
    "login.change.subtitle": "Your password must be changed before continuing.",
    "login.change.newPlaceholder": "Enter the new password",
    "login.change.confirmPlaceholder": "Confirm the new password",
    "login.pw.min8": "At least 8 characters",
    "login.pw.upper": "Uppercase letter",
    "login.pw.lower": "Lowercase letter",
    "login.pw.special": "Special character",
    "login.pw.match": "Passwords match",
    // Errors
    "error.invalidCredentials": "Invalid credentials.",
    "error.wrongPassword": "Incorrect password. Try again.",
    "error.passwordsMismatch": "Passwords do not match.",
    "error.changePassword": "Could not change the password.",
    "error.mfaIncomplete": "Enter the full 6-digit code.",
    // Navigation / shell
    "nav.dashboard": "Dashboard",
    "nav.console": "Console",
    "nav.admin": "Admin",
    "nav.contestants": "Contestants",
    "nav.accounts": "Accounts",
    "nav.clientApps": "Client Apps",
    "nav.verifications": "Verifications",
    "nav.people": "People",
    "nav.biometrics": "Biometrics",
    "bio.title": "Biometric identities",
    "bio.subtitle": "Global biometric people, linked identities, per-company consent, enrollment & LGPD.",
    "bio.search": "Search by name or identity…",
    "bio.name": "Name",
    "bio.identities": "Identities",
    "bio.enrolled": "Enrolled",
    "bio.companies": "Companies",
    "bio.status": "Status",
    "bio.yes": "Yes",
    "bio.no": "No",
    "bio.purged": "Purged (LGPD)",
    "bio.empty": "No biometric people yet.",
    "bio.add": "Add",
    "bio.identityValue": "value",
    "bio.consentOn": "Consent granted",
    "bio.consentOff": "No consent",
    "bio.enrollments": "Enrollments",
    "bio.encrypted": "encrypted",
    "bio.plaintext": "plaintext",
    "bio.sessions": "Recent sessions",
    "bio.deenroll": "De-enroll (remove template)",
    "bio.lgpd": "LGPD remove",
    "bio.lgpdTitle": "LGPD removal",
    "bio.lgpdBody": "This encrypts and retains a minimal record, e-mails the recovery key to the subject, then permanently deletes the server key. Irreversible.",
    "bio.escrowEmail": "Subject e-mail (escrow key)",
    "bio.cancel": "Cancel",
    "bio.confirm": "Confirm",
    "bio.error": "Error",
    "bio.newPerson": "Nuevo enlace de registro",
    "bio.company": "Seleccionar empresa…",
    "bio.createLink": "Crear enlace",
    "bio.creating": "Creando…",
    "bio.linkReady": "Comparte este enlace con la persona para registrar su biometría:",
    "bio.copy": "Copiar",
    "bio.copied": "¡Copiado!",
    "bio.openLink": "Abrir",
    "bio.done": "Hecho",
    "bio.sendEmail": "Enviar a correo…",
    "bio.send": "Enviar",
    "bio.sent": "¡Enviado!",
    "bio.newPerson": "New enrollment link",
    "bio.company": "Select company…",
    "bio.createLink": "Create link",
    "bio.creating": "Creating…",
    "bio.linkReady": "Share this link with the person to enroll their biometrics:",
    "bio.copy": "Copy",
    "bio.copied": "Copied!",
    "bio.openLink": "Open",
    "bio.done": "Done",
    "bio.sendEmail": "Send to e-mail…",
    "bio.send": "Send",
    "bio.sent": "Sent!",
    "nav.global": "Global",
    "account.listSubtitle": "System users (institution admins and livenesss).",
    "account.empty": "No accounts yet.",
    "account.new": "New account",
    "account.edit": "Edit account",
    "account.newSubtitle": "Create or edit a system user (admin / liveness).",
    "account.removeTitle": "Remove account",
    "account.registered": "Account created",
    "account.role": "Role",
    "account.role.institution_admin": "Institution admin",
    "account.role.liveness": "Liveness",
    "account.role.super": "Super Admin",
    "account.loadError": "Could not load the account.",
    "account.saveError": "Could not save the account.",
    "nav.exams": "Exams",
    "nav.events": "Events",
    "nav.examsEvents": "Exams / Events",
    "nav.configuration": "Configuration",
    "nav.companies": "Companies",
    "nav.settings": "Settings",
    "nav.ai": "AI",
    "nav.jobs": "Jobs",
    "ai.title": "AI",
    "ai.subtitle": "Ollama server for detection refinement",
    "ai.ollamaUrl": "Ollama URL",
    "ai.visionModel": "Vision model",
    "ai.enabled": "Ollama refinement",
    "ai.enabledHelp": "When off, detections run on the local models alone (no LLM refinement).",
    "ai.testConnectivity": "Test connectivity",
    "ai.testOk": "Connection OK",
    "ai.testFailed": "Connection failed",
    "ai.modelsFound": "Models available",
    "ai.modelPresent": "Selected model is installed",
    "ai.modelMissing": "Selected model NOT found on server",
    "common.close": "Close",
    "common.saved": "Saved",
    "nav.logout": "Sign out",
    // Dashboard
    "dash.title": "Dashboard",
    "dash.subtitle": "Live analytics for your institution's sessions.",
    "dash.realtime": "Real time",
    "dash.now": "now",
    "dash.activeSessions": "Active sessions",
    "dash.sessionsByTarget": "Sessions per event / exam",
    "dash.modeExam": "Exam",
    "dash.modeEvent": "Event",
    "dash.noSessions": "No live sessions right now.",
    "dash.liveOrigin": "Live visitors",
    "dash.cities": "city(ies)",
    "dash.sessions": "Sessions",
    "dash.byProfile": "by profile city",
    "dash.withoutCoords": "without coordinates",
    "dash.devices": "Devices",
    "dash.throughput": "Throughput",
    "dash.throughputHint": "average · last 1 min",
    "dash.traffic": "Server traffic",
    "dash.perMinute": "Per minute · last 30 min",
    "dash.perSecond": "Per second · last 60s",
    "dash.healthTitle": "Session health",
    "dash.healthHint": "top 10 connected · problems first",
    "dash.participant": "Participant",
    "dash.target": "Event / exam",
    "dash.status": "Status",
    "dash.healthy": "Healthy",
    "dash.unhealthy": "Unhealthy",
    "dash.recordingFailure": "Recording failure",
    "dash.rate": "Rate",
    "dash.total": "Total",
    "dash.source.screen": "Screen",
    "dash.source.camera": "Camera",
    "dash.source.audio": "Audio",
    "dash.sourceOk": "Streaming",
    "dash.sourceBad": "Not streaming",
    "dash.sourceNa": "Not required",
    "dash.countriesCities": "Countries and cities",
    "dash.countryCity": "Country / city",
    "dash.noCountryData": "No country data yet.",
    "dash.topIps": "Top IPs",
    "dash.ip": "IP",
    "dash.location": "Location",
    "dash.noIps": "No IPs yet.",
    // Common
    "common.name": "Name",
    "common.firstName": "First name",
    "common.lastName": "Last name",
    "common.phone": "Phone",
    "common.language": "Language",
    "common.country": "Country",
    "common.state": "State",
    "common.state.placeholder": "State / region",
    "common.city": "City",
    "common.city.placeholder": "City",
    "recording.scope": "Scope",
    "recording.scope.national": "National",
    "recording.scope.international": "International",
    "common.company": "Company",
    "common.selectCompany": "Select the company...",
    "common.actions": "Actions",
    "common.edit": "Edit",
    "common.remove": "Remove",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.create": "Create",
    "common.back": "Back",
    "common.add": "Add",
    "common.confirmRemove": "Are you sure you want to remove",
    // Contestants
    "contestant.new": "New Contestant",
    "contestant.listSubtitle": "Register and manage your institution's contestants.",
    "contestant.edit": "Edit Contestant",
    "contestant.empty": "No contestant registered.",
    "contestant.removeTitle": "Remove contestant?",
    "contestant.newSubtitle": "Register a contestant. An initial password is generated and shown once.",
    "contestant.editSubtitle": "Edit the contestant's data. The password is not changed here.",
    "contestant.registered": "Contestant registered",
    "contestant.saveNote": "Note the initial password — it will not be shown again.",
    "contestant.initialPassword": "Initial password",
    "contestant.copy": "Copy",
    "contestant.copied": "Copied!",
    "contestant.done": "Done",
    "contestant.password": "Password",
    "contestant.policy.blocked": "Password blocked",
    "contestant.policy.mustChange": "Change on access",
    "contestant.policy.free": "Free",
    "contestant.mustChange": "Require password change on first access",
    "contestant.cannotChange": "Do not allow the contestant to change the password",
    "contestant.exclusive": "The two options are mutually exclusive.",
    "contestant.policyLabel": "Password policy",
    "contestant.emailPlaceholder": "contestant@example.com",
    "error.loadContestant": "Could not load the contestant.",
    "error.saveContestant": "Could not save the contestant. Check the data.",
    "recording.empty": "Nothing registered.",
    "recording.start": "Start",
    "recording.end": "End",
    "recording.duration": "Duration",
    "duration.day": "day",
    "duration.days": "days",
    "duration.hour": "hour",
    "duration.hours": "hours",
    "duration.minute": "minute",
    "duration.minutes": "minutes",
    "duration.and": "and",
    "console.title": "Liveness Console",
    "console.subtitle": "Sessions monitored by your institution.",
    "console.all": "All",
    "console.onlyLive": "Live only",
    "console.refresh": "Refresh",
    "console.empty": "No sessions at the moment.",
    "console.emptyLive": "No live sessions at the moment.",
    "console.participant": "Participant",
    "console.event": "Event",
    "console.system": "System",
    "console.status": "Status",
    "console.start": "Start",
    "console.examTime": "Exam time",
    "console.traffic": "Traffic",
    "console.trafficHint": "Total transferred over the session's ingestion streams",
    "console.trafficRateHint": "Current rate",
    "console.files": "Files",
    "console.filesHint": "Total size of the recorded files (camera, screen, audio)",
    "console.live": "Live",
    "console.reconnect": "Force client reconnect",
    "console.telemetry": "Telemetry (client console + internal events)",
    "console.review": "Review",
    "console.reviewLiveness": "Liveness review",
    "console.noLiveness": "No liveness capture for this session",
    "console.disconnected": "Disconnected",
    "console.waitingStart": "Waiting to start",
    "console.recordingFailure": "Recording failure",
    "console.warning": "Warning",
    "console.transportWebrtc": "WebRTC (LiveKit, legacy)",
    "console.transportWebcodecs": "WebCodecs over WebSocket",
    "console.reconnectTitle": "Force reconnect",
    "console.reconnectBody": "The client of {name} will reconnect silently (re-acquires microphone/camera and restarts sending). A brief ~1-2s gap occurs in the recording. Continue?",
    "console.reconnectConfirm": "Reconnect",
    "console.reconnectError": "Could not request the reconnection.",
    "console.reconnectRequested": "Reconnect requested — the client will reconnect shortly.",
    "console.participantFallback": "participant",
    "console.sessionScope": "session",
    "console.kindClientDisconnected": "participant connection dropped",
    "console.kindStorageStalled": "recording is not being stored",
    "console.kindStreamMissing": "required stream not started",
    "console.kindVideoFrozen": "video frozen (still image)",
    "console.kindNoInput": "no media sent by the participant",
    "recording.requirements": "Requirements",
    "recording.camera": "Camera",
    "recording.audio": "Audio",
    "recording.screen": "Screen",
    "recording.requirementsLabel": "Recording requirements",
    "recording.requiresCamera": "Requires camera",
    "recording.requiresAudio": "Requires audio",
    "recording.requireLiveness": "Require liveness (identity capture)",
    "recording.requireLivenessHint": "Before sharing screen/audio the contestant must pass an on-camera liveness capture (recorded), regardless of whether a camera is required.",
    "recording.livenessAllowNoGeo": "Allow the contestant to decline geolocation",
    "recording.livenessAiThreshold": "Liveness AI threshold (%)",
    "recording.livenessAiThresholdHint": "AI probability at/above which the liveness and gesture checks pass. Separate from the anti-cheat threshold.",
    "recording.requiresScreen": "Requires screen",
    "recording.allowExternalCamera": "Allow external camera (phone)",
    "recording.requiresExternalCamera": "Requires external camera",
    "recording.antiCheat": "Anti-cheat analysis",
    "recording.analyzeRecordings": "Analyze recordings (extra person, absence, AI on screen)",
    "recording.detectExtraPerson": "Extra person",
    "recording.detectAbsence": "Absence",
    "recording.detectAiOnScreen": "AI on screen",
    "recording.maxCameras": "Max cameras (except external)",
    "recording.monitorTabSwitch": "Flag tab/window switching (single-tab exam)",
    "recording.sectionRecord": "What to record",
    "recording.sectionMonitor": "What to monitor / analyze",
    "recording.absenceSeconds": "Absence threshold (seconds off-camera before flagging)",
    "recording.aiThreshold": "AI confirmation threshold (%)",
    "recording.aiThresholdHint": "AI probability at/above which a detection is auto-confirmed; below it, it waits for liveness review. 0 confirms everything.",
    "capture.addCamera": "Add camera",
    "capture.noMoreCameras": "No additional camera detected on this device.",
    "review.findings.title": "Automated analysis",
    "review.findings.empty": "No automated findings.",
    "review.finding.multi_person": "Multiple people on camera",
    "review.finding.absent": "Student left the camera",
    "review.finding.returned": "Student returned to the camera",
    "review.finding.ai_on_screen": "AI assistant on screen",
    "review.finding.tab_switch": "Switched tab/window away from the exam",
    "review.finding.confidence": "confidence",
    "recording.durationLabel": "Duration (minutes) — 0 = undefined",
    "recording.maxScreens": "Max screens",
    "recording.logo": "Logo (auto-resized to 200×200, transparent background)",
    "recording.formSubtitle": "Configure the data and the recording requirements.",
    "recording.allowedIps": "Allowed IPs / subnets",
    "recording.allowedIps.placeholder": "e.g. 192.168.0.0/24",
    "recording.allowedIps.hint": "Leave empty to allow any address. The contestant may only access from these.",
    "recording.removeTitle": "Remove?",
    "recording.loadError": "Could not load the record.",
    "recording.saveError": "Could not save. Check the data.",
    "recording.contestants": "Contestants",
    "recording.contestants.empty": "No one enrolled yet.",
    "recording.selectContestant": "Select a contestant...",
    "recording.enroll": "Enroll",
    "recording.enrollment.expired": "expired",
    "recording.enrollment.renew": "Renew",
    "recording.schedule.title": "Access schedule",
    "recording.schedule.add": "Add schedule",
    "recording.schedule.empty": "No schedule — access spans the whole event period.",
    "recording.schedule.hint": "No schedule: access is open during the whole event period. With schedules: access opens 15 minutes before each slot and ends exactly at its end.",
    "recording.profile": "Recording profile",
    "recording.profile.default": "Company default",
    "nav.profiles": "Recording profiles",
    "nav.recording": "Recording",
    "nav.simulation": "Simulation",
    "sim.title": "Capacity simulation",
    "sim.subtitle": "What a cohort costs on a recording profile — measured, not estimated.",
    "sim.profile": "Recording profile",
    "sim.clients": "Participants",
    "sim.minutes": "Recording time (minutes)",
    "sim.run": "Simulate",
    "sim.measuring": "Encoding a probe with this profile's settings…",
    "sim.idle": "Idle",
    "sim.busy": "Busy",
    "sim.idleHint": "a still screen — what real sessions closely resemble",
    "sim.busyHint": "a picture changing every frame — the worst case worth planning for",
    "sim.uplink": "Ingest bandwidth",
    "sim.storage": "Storage",
    "sim.perClient": "per participant",
    "sim.total": "total",
    "sim.perHour": "per participant-hour",
    "sim.sockets": "WebSockets",
    "sim.sources": "Sources per participant",
    "sim.measured": "Measured on this server",
    "sim.notMeasured": "Could not run the probe — figures unavailable",
    "sim.rangeWhy": "Everything is a range because the traffic is decided by what the participants' screens show, which no measurement here can know. Real sessions have measured close to the idle end.",
    "sim.detail": "Measured per source",
    "sim.uplinkCol": "Uplink",
    "sim.storedCol": "Stored",
    "sim.error": "Could not simulate.",
    "nav.apiTokens": "API tokens",
    "nav.agents": "Agents",
    "agent.title": "Agents",
    "agent.subtitle": "Machines serving this deployment.",
    "agent.name": "Agent",
    "agent.status.label": "Status",
    "agent.status.online": "Online",
    "agent.status.offline": "Offline",
    "agent.status.draining": "Draining",
    "agent.kind.websocket": "WebSocket (ingest)",
    "agent.kind.encoder": "Encoder",
    "agent.kind.all_in_one": "All-in-one",
    "agent.ip": "IP",
    "agent.cpu": "CPU",
    "agent.memory": "Memory",
    "agent.disk": "Disk free",
    "agent.sessions": "Sessions",
    "agent.traffic": "Traffic",
    "agent.heartbeat": "Heartbeat",
    "agent.empty": "No agents registered.",
    "agent.error": "Could not load the agents.",
    "agent.secondsAgo": "{n}s ago",
    "agent.minutesAgo": "{n}m ago",
    "nav.webhooks": "Webhooks",
    "webhook.title": "Webhooks",
    "webhook.subtitle": "Send event alerts (online/offline, session start/end, health, markers) to external systems.",
    "webhook.new": "New webhook",
    "webhook.edit": "Edit webhook",
    "webhook.empty": "No webhooks yet.",
    "webhook.events": "Events",
    "webhook.allEvents": "All events",
    "webhook.eventsHint": "Leave all unchecked to receive every event.",
    "webhook.secret": "Signing secret",
    "webhook.secretHint": "Each delivery is signed with HMAC-SHA256 (X-Webhook-Signature header).",
    "webhook.urlHint": "POST target. Payload: {event, email, session_id, timestamp, session_health}.",
    "webhook.enabled": "Enabled",
    "webhook.create": "Create webhook",
    "webhook.rotate": "Rotate secret",
    "webhook.rotateConfirm": "Rotate the signing secret? The current one stops working immediately.",
    "webhook.test": "Send test event",
    "webhook.testOk": "Delivered",
    "webhook.testFail": "Failed",
    "webhook.namePlaceholder": "e.g. VPN gateway",
    "webhook.nameRequired": "Name is required.",
    "webhook.urlRequired": "URL is required.",
    "webhook.loadError": "Could not load the webhook.",
    "webhook.saveError": "Could not save the webhook.",
    "common.copy": "Copy",
    "apiToken.title": "API tokens",
    "apiToken.subtitle": "Credentials for external systems to call the public API (X-Api-Token).",
    "apiToken.new": "New token",
    "apiToken.edit": "Edit token",
    "apiToken.create": "Create token",
    "apiToken.empty": "No API tokens yet.",
    "apiToken.namePlaceholder": "e.g. Liveness system",
    "apiToken.nameRequired": "Enter a name.",
    "apiToken.token": "Token (X-Api-Token)",
    "apiToken.tokenHint": "Send it in the X-Api-Token header. Keep it secret.",
    "apiToken.show": "Show",
    "apiToken.hide": "Hide",
    "apiToken.ipAcl": "Source IP allowlist",
    "apiToken.ipAclHint": "IPs or CIDRs, comma-separated. Empty = any IP.",
    "apiToken.anyIp": "any IP",
    "apiToken.rateLimit": "Rate limit (requests per minute)",
    "apiToken.rateLimitHint": "0 = no limit.",
    "apiToken.noLimit": "no limit",
    "apiToken.enabled": "Enabled",
    "apiToken.permissions": "Permissions",
    "apiToken.permissionsHint": "Which integration endpoint families this token may call.",
    "apiToken.permExam": "Exam API (/api/integration/exam/*)",
    "apiToken.permEvent": "Event API (/api/integration/event/*)",
    "apiToken.usage": "Usage — add_marker",
    "apiToken.usageHint": "Adds a marker at the timestamp (a flag, a note, anything) and creates a mosaic export from 60s before to 60s after.",
    "apiToken.rotate": "Rotate",
    "apiToken.rotateConfirm": "Generate a new token? The current one stops working immediately.",
    "apiToken.loadError": "Error loading the token.",
    "apiToken.saveError": "Error saving.",
    "apiToken.examplesTitle": "Exam integration API — request examples",
    "apiToken.examplesIntro": "Authenticate every request with the X-Api-Token header. Base URL:",
    "apiToken.eventsExamplesTitle": "Events integration API — request examples",
    "apiToken.markerExamplesTitle": "Marker integration API — request examples",
    "apiToken.markerExamplesIntro": "Authenticate with the X-Api-Token header. Endpoint:",
    "apiToken.exampleListDesc": "List the available exams for this company.",
    "apiToken.exampleStartDesc": "Start an exam session for a student. Creates the student if needed and returns a session token — the student signs in at /session_auth with only that token (no e-mail/password). An existing student's password is never changed.",
    "apiToken.exampleStatusDesc": "Get a student's exam session status by e-mail.",
    "apiToken.exampleStopDesc": "End an open exam session by e-mail (or session_id).",
    "apiToken.copy": "Copy",
    "apiToken.copied": "Copied!",
    "apiToken.parameters": "Parameters",
    "apiToken.responses": "Responses",
    "apiToken.request": "Request",
    "apiToken.required": "required",
    "apiToken.paramName": "Name",
    "apiToken.paramDesc": "Description",
    "apiToken.opListSummary": "List available exams",
    "apiToken.opStartSummary": "Start an exam session",
    "apiToken.opStatusSummary": "Student session status",
    "apiToken.opStopSummary": "End an exam session",
    "apiToken.opMarkerSummary": "Add a marker (+ ±60s mosaic export)",
    "apiToken.pMarkerTarget": "The target session, by its UUID or the participant's e-mail (resolves the session active at that moment).",
    "apiToken.pMarkerTimestamp": "ISO-8601 instant of the marker (e.g. 2026-07-08T20:58:45Z).",
    "apiToken.pMarkerDescription": "Free-text note shown on the marker.",
    "apiToken.pToken": "API token issued for your company.",
    "apiToken.pEmail": "Student's e-mail.",
    "apiToken.pName": "Student's full name (or use first_name / last_name).",
    "apiToken.pExam": "The exam to run — its id (exam_id) OR its name (exam_name).",
    "apiToken.pStatusEmail": "E-mail of the student to query.",
    "apiToken.pStopTarget": "session_id, or the student's email (optionally narrowed by exam_id / exam_name).",
    "apiToken.rOk": "Success.",
    "apiToken.rCreated": "Session created (200 if an open session was reused).",
    "apiToken.rBadRequest": "Missing required fields.",
    "apiToken.rExamNotFound": "Exam not found for this token's company.",
    "apiToken.rUnauthorized": "Missing or invalid token.",
    "apiToken.rSessionNotFound": "No open exam session found.",
    "profile.new": "New profile",
    "profile.edit": "Edit profile",
    "profile.subtitle": "Recording profiles reused by exams and events.",
    "profile.empty": "No profile registered yet.",
    "profile.maxMonitors": "Max monitors",
    "profile.maxCameras": "Max cameras",
    "profile.audioEnabled": "Audio enabled",
    "profile.allowExternalCamera": "Allow external camera (phone)",
    "profile.videoFps": "Video FPS",
    "profile.sampleRate": "Audio sample rate (kHz)",
    "profile.cameraRes": "Camera max resolution",
    "profile.screenRes": "Screen max resolution",
    "profile.segment": "Segment length (minutes)",
    "recording.exam.singular": "Exam",
    "recording.exam.new": "New Exam",
    "recording.exam.edit": "Edit Exam",
    "recording.exam.listSubtitle": "Register exams and their recording requirements.",
    "recording.event.singular": "Event",
    "recording.event.new": "New Event",
    "recording.event.edit": "Edit Event",
    "recording.event.listSubtitle": "Register events and their recording requirements.",
    "company.listSubtitle": "Manage the companies registered in the system.",
    "company.new": "New Company",
    "company.edit": "Edit Company",
    "company.newSubtitle": "Fill in the data to register a new company.",
    "company.editSubtitle": "Change the company's data and settings.",
    "company.empty": "No company registered.",
    "company.deleteTitle": "Delete company?",
    "company.namePlaceholder": "Company name",
    "company.canSetLang": "Contestant can choose the language",
    "company.canSetLang.desc": "If disabled, the contestant's language is always the company's.",
    "company.createdAt": "Created at",
    "company.tab.data": "Data",
    "company.tab.policy": "Password Policy",
    "error.loadCompany": "Error loading company.",
    "error.saveCompany": "Error saving company.",
    "policy.title": "Password Policy",
    "policy.minLength": "Minimum length",
    "policy.requireUpper": "Require uppercase letter",
    "policy.requireLower": "Require lowercase letter",
    "policy.requireSpecial": "Require special character",
    "policy.blacklist": "Blocked words",
    "policy.blacklistPlaceholder": "e.g. admin",
    "policy.saved": "Password policy saved successfully.",
    "error.savePolicy": "Error saving the password policy.",
    "settings.saved": "Settings saved successfully.",
    "error.saveSettings": "Error saving settings.",
    "settings.saving": "Saving...",
    "settings.save": "Save Settings",
    "settings.title": "General Settings",
    "settings.subtitle": "Configure the general system parameters",
    "common.loading": "Loading...",
    "oidc.completing": "Completing login...",
    "oidc.failed": "Login failed",
    "oidc.wait": "Please wait, validating SSO authentication.",
    "oidc.backToLogin": "Back to login",
    "error.oidcInvalid": "Invalid OIDC response.",
    "error.oidcFailed": "Failed to complete SSO login.",
    "contestant.home.title": "Your exams & events",
    "contestant.home.subtitle": "Select one to begin.",
    "contestant.home.empty": "No exam or event is available right now.",
    "capture.consent": "I have read and agree to be monitored",
    "capture.start": "Start recording",
    "capture.recording": "Recording…",
    "capture.reconnecting": "Reconnecting…",
    "capture.audioAlertTitle": "Enable audio alerts",
    "capture.audioAlertBody": "This screen plays an audible alarm if any of your media (screen, camera or microphone) disconnects during the exam. Your browser needs your permission to play sound.",
    "capture.audioAlertEnable": "Enable audio",
    "capture.audioAlertLater": "Not now",
    "capture.finish": "Finish recording",
    "capture.ending": "Finishing…",
    "capture.pause": "Pause recording",
    "capture.pausing": "Pausing…",
    "capture.addScreen": "Add screen",
    "capture.enable": "Enable",
    "capture.active": "Active",
    "capture.micActive": "Microphone active",
    "capture.required": "Required",
    "capture.gate": "Add all required resources and accept monitoring to start.",
    "watchdog.restartTitle": "Re-share to resume recording",
    "watchdog.restartBody": "Your screen or camera stopped sending to the server (the browser can no longer read the source). Click below to re-acquire the sources and resume — a screen-share picker will appear. No page reload needed.",
    "watchdog.restartNow": "Re-share and resume",
    "watchdog.dismiss": "Dismiss",
    "capture.externalCamera": "External camera",
    "capture.addExternalCamera": "Add external camera",
    "capture.extCamDown": "The external camera is disconnected. Reconnect it to keep being monitored.",
    "capture.extCamRequiredDown": "This exam REQUIRES an external phone camera and it is not connected. Connect it now.",
    "capture.extCamReconnect": "Reconnect camera",
    "capture.externalHint": "Use your phone as an extra camera by scanning a QR code.",
    "capture.externalNeedRecording": "Start recording to add an external camera.",
    "capture.externalChoose": "How should the phone camera be used?",
    "capture.externalPrimary": "Main camera",
    "capture.externalSecondary": "Secondary camera",
    "capture.externalScan": "Scan this QR code with your phone and allow camera access.",
    "capture.externalWaiting": "Waiting for the phone to connect…",
    "capture.externalConnected": "External camera connected",
    "capture.close": "Close",
    "pair.title": "External camera",
    "pair.live": "Live",
    "pair.connecting": "Connecting…",
    "pair.streaming": "Your camera is streaming to the session.",
    "pair.switch": "Switch camera",
    "pair.keepOpen": "Keep this page open during the exam.",
    "pair.denied": "Camera permission denied. Allow it and try again.",
    "pair.retry": "Try again",
    "pair.expired": "This link is invalid or has expired. Ask for a new QR code.",
    "pair.error": "Could not connect. Please try again.",
    "pair.unsupported": "This phone's browser can't be used as a camera. iPhones aren't supported (all iOS browsers, including Chrome, lack the required capture). Please use an Android phone with Google Chrome and scan the QR code again.",
    "pair.ended": "Session ended — you can close this page.",
    "error.captureLoad": "Could not load this exam/event.",
    "error.mediaDenied": "Permission denied or device unavailable.",
    "capture.unsupportedTitle": "Browser not supported",
    "capture.unsupportedBody": "This browser can't capture with the required video engine. Please use the latest Google Chrome or Microsoft Edge to take this exam.",
    // --- added: SecFace liveness/admin screens ---
    "biometric.title": "Biometric API — people and photos",
    "biometric.introAuth": "Authenticate with the header",
    "biometric.introAt": "at",
    "biometric.introScopePre": "Requires the",
    "biometric.scopeName": "Biometric API",
    "biometric.introScopePost": "scope in the token; IP allowlist and rate limit are enforced, and every call is recorded in the audit trail.",
    "biometric.addSummary": "Create/update a person",
    "biometric.addDesc": "Upsert: looks up by document (document_type + document) and then by e-mail intersection; if not found, creates. Fields are merged (e-mails are unioned; empty fields never erase values). Requires at least one e-mail or a document.",
    "biometric.pEmails": "List of the person's e-mails (also accepts a single \"email\").",
    "biometric.pDocumentType": "Document type (e.g. cpf, rg, passport). Required when document is sent.",
    "biometric.pDocument": "Document number.",
    "biometric.pMobilePhone": "Mobile phone.",
    "biometric.rCreated": "Person created.",
    "biometric.rUpdated": "Person already existed — data merged/updated.",
    "biometric.rBadRequest": "No e-mail and no document, or document without document_type.",
    "biometric.rForbidden": "Token without the biometric scope, or IP outside the allowlist.",
    "biometric.rRateLimited": "Requests-per-minute limit reached.",
    "biometric.photoSummary": "Add a reference photo",
    "biometric.photoDesc": "Send the photo in \"photo\" (multipart file or base64/data-URI in the JSON). The image usually comes from a document (ID, driver's license…): the face is detected and ONLY the photo-area crop (3:4, with hair/shoulder margins) is stored — never the full document. A photo the person already has (identical or near-identical) returns 204 and nothing is stored.",
    "biometric.pPersonId": "The person's id (returned by /people/add).",
    "biometric.pPhoto": "File (multipart/form-data) or base64/data-URI string (JSON).",
    "biometric.rPhotoStored": "Photo cropped and stored.",
    "biometric.rPhotoDuplicate": "The person already has this photo (duplicate) — nothing stored.",
    "biometric.rNoFace": "No face found in the image (reason: no_face).",
    "biometric.rInvalidImage": "Invalid/corrupted image or missing photo field.",
    "biometric.rPersonNotFound": "Person not found (or belongs to another company).",
    "apiTokenForm.biometricScope": "Biometric API (/biometric/*)",
    "apiTokenForm.biometricScopeAria": "Biometric API",
    "account.resetMfa": "Reset MFA",
    "common.country.placeholder": "BR, US, ES, IT...",
    "clientApps.title": "Client apps",
    "clientApps.subtitle": "Systems that integrate liveness verification via API (client_id / client_secret).",
    "clientApps.new": "New client",
    "clientApps.empty": "No clients registered.",
    "clientApps.clientId": "Client ID",
    "clientApps.active": "Active",
    "clientApps.inactive": "Inactive",
    "clientApps.deleteTitle": "Remove client",
    "clientApps.deleteBodyPrefix": "Remove",
    "clientApps.deleteBodySuffix": "? Calls using these credentials will stop working.",
    "clientAppForm.credentialsTitle": "Client credentials",
    "clientAppForm.secretWarnPrefix": "Save the",
    "clientAppForm.secretWarnSuffix": "now — it is shown only once and cannot be recovered.",
    "clientAppForm.clientSecret": "Client Secret",
    "clientAppForm.done": "Done",
    "clientAppForm.loadError": "Could not load the client.",
    "clientAppForm.saveError": "Failed to save.",
    "clientAppForm.rotateError": "Failed to rotate the secret.",
    "clientAppForm.editTitle": "Edit client",
    "clientAppForm.newTitle": "New client",
    "clientAppForm.rotateSecret": "Rotate secret",
    "clientAppForm.webhookUrl": "Webhook URL",
    "clientAppForm.webhookUrlHelpPrefix": "Receives the",
    "clientAppForm.webhookUrlHelpSuffix": "event (signed). Empty disables push (use polling).",
    "clientAppForm.webhookSecret": "Webhook Secret (HMAC)",
    "clientAppForm.webhookSecretPlaceholder": "minimum 16 characters",
    "clientAppForm.webhookSecretHelpPrefix": "Key used to sign the webhook:",
    "clientAppForm.webhookSecretHelpCode": "X-SecFace-Signature: sha256=<HMAC-SHA256 of the body>",
    "clientAppForm.webhookSecretHelpSuffix": "Set this same value in the client system to validate the signature. Empty keeps the current one.",
    "clientAppForm.redirectUris": "Allowed redirect URIs",
    "clientAppForm.redirectUrisPlaceholder": "https://app.example.com/callback https://…",
    "clientAppForm.redirectUrisHelp": "One per line. The redirect_uri of /start must start with one of them.",
    "clientAppForm.emailReports": "E-mail reports to the client",
    "clientAppForm.emailReportsHelp": "When enabled, on every approved liveness session the signed PDF is e-mailed to the recipients below and to the validated person.",
    "clientAppForm.reportEmails": "Recipient e-mails",
    "clientAppForm.reportEmailsPlaceholder": "one per line or comma-separated",
    "clientAppForm.reportEmailsHelp": "Recipients that receive the report of each approved verification.",
    "clientAppForm.policyNotePrefix": "Company default policy. Leave as",
    "clientAppForm.policyNoteInherit": "Inherit",
    "clientAppForm.policyNoteMiddle": "/ empty to use the global default. The client can override per session at",
    "clientAppForm.aiThreshold": "AI threshold (%)",
    "clientAppForm.inheritGlobal": "Inherit global",
    "clientAppForm.requireGeo": "Require geolocation",
    "clientAppForm.requireGesture": "Require gesture",
    "clientAppForm.yes": "Yes",
    "clientAppForm.no": "No",
    "globalConfig.loadError": "Could not load the global configuration.",
    "globalConfig.saveError": "Failed to save.",
    "globalConfig.title": "Global configuration",
    "globalConfig.subtitle": "Global defaults for the liveness policy (lowest precedence level).",
    "globalConfig.precedence": "client > company (ClientApp) > global",
    "globalConfig.aiThreshold": "AI threshold (%)",
    "globalConfig.aiThresholdHelp": "Identification/liveness cutoff when neither the client nor the ClientApp sets it.",
    "globalConfig.sessionTtl": "Session TTL (seconds)",
    "globalConfig.sessionTtlHelp": "Validity of a session after /start.",
    "globalConfig.requireGeo": "Require geolocation by default",
    "globalConfig.requireGeoAria": "Require geolocation",
    "globalConfig.requireGesture": "Require gesture challenge by default",
    "globalConfig.requireGestureAria": "Require gesture",
    "liveness.title": "Identity verification",
    "liveness.intro": "This exam requires an identity (liveness) verification before you share your screen. Complete the two steps below to continue.",
    "liveness.stepLocation": "Location",
    "liveness.geoRequiredHint": "Required to continue.",
    "liveness.geoOptionalHint": "It will be requested; you may decline.",
    "liveness.geoNotProvided": "Location not provided",
    "liveness.geoEnabled": "Location enabled",
    "liveness.requesting": "Requesting…",
    "liveness.enableGeo": "Enable geolocation",
    "liveness.declineGeo": "Don't provide location",
    "liveness.faceCapture": "Face capture",
    "liveness.captureHint": "Bring your face close to the circle, look at the camera and keep your eyes open. The entire process is recorded.",
    "liveness.startCapture": "Start face capture",
    "liveness.unsupportedTitle": "Unsupported browser",
    "liveness.unsupportedBody": "This browser does not support the required video capture (WebCodecs). Copy the link below and open it in another up-to-date browser (Chrome or Edge, on desktop or Android).",
    "common.copied": "Copied",
    "liveness.declineTitle": "Don't provide location?",
    "liveness.declineBody": "Are you sure you don't want to provide your location? The refusal is recorded in your verification.",
    "liveness.cancel": "Cancel",
    "liveness.confirmDecline": "Yes, don't provide",
    "liveness.geoRequired": "You must allow your exact location to continue. Grant the permission and try again.",
    "liveness.geoValidateFailed": "Unable to validate the location.",
    "liveness.geoNoContinue": "Unable to continue without the location.",
    "liveness.cannotContinue": "Unable to continue.",
    "liveness.startingCamera": "Starting the camera…",
    "liveness.cameraDenied": "Allow camera access to continue.",
    "liveness.cameraFailed": "Unable to start the camera.",
    "liveness.tooManyInterruptions": "Too many connection interruptions. Check your internet and try again.",
    "liveness.connectionInterrupted": "Connection interrupted — restarting the verification…",
    "liveness.hdrGesture": "Gesture challenge",
    "liveness.hdrMotion": "Approach",
    "liveness.hdrFlash": "Light check",
    "liveness.altCapture": "capture",
    "liveness.retry": "Try again",
    "liveness.checking": "Validating…",
    "liveness.verifying": "Checking…",
    "liveness.completeFailed": "Failed to complete the verification.",
    "liveness.gestureHold": "Perfect! Hold the gesture…",
    "liveness.gesturePrompt": "Make the requested gesture",
    "liveness.lookAtScreen": "Look at the screen",
    "liveness.fitFaceInCircle": "Fit your face into the circle",
    "liveness.fitFaceInSmallerCircle": "Now fit your face into the smaller circle",
    "liveness.holdStill": "Hold your face still… {n}s",
    "liveness.guidance.no_face": "Position your face inside the circle",
    "liveness.guidance.multiple_faces": "Only you should appear on camera",
    "liveness.guidance.too_far": "Bring your face closer to the camera",
    "liveness.guidance.fill_oval": "Move your face closer to fill the circle",
    "liveness.guidance.too_close": "Move your face back a little",
    "liveness.guidance.not_frontal": "Look directly at the camera",
    "liveness.guidance.off_center": "Center your face in the circle",
    "liveness.guidance.blurry": "Improve the lighting and hold still — the image isn't sharp",
    "liveness.guidance.low_confidence": "Face not detected clearly",
    "liveness.guidance.ok": "Perfect! Keep holding your face…",
    "liveness.guidance.detector_unavailable": "Checking…",
    "liveness.guidance.decode_failed": "Adjusting the camera…",
    "liveness.guidance.flash_fill_oval": "Move closer and fit your face in the larger circle",
    "liveness.guidance.flash_hold_fit": "Fitted! Hold still…",
    "liveness.guidance.flash_hold": "Keep your face in the circle until the flashes stop",
    "gesture.instr.v_over_eye": "Make a \"V\" (index and middle fingers) and bring your hand in front of your face, with the fingers over one of your eyes.",
    "gesture.instr.open_palm": "Raise one open hand next to your face, with the fingers well spread apart (splayed).",
    "gesture.instr.thumbs_up": "Make a \"thumbs-up\" gesture (thumb pointing up) near your face.",
    "gesture.instr.hand_on_cheek": "Rest the palm of one hand on one of your cheeks.",
    "people.title": "People",
    "people.matchCount": "{n} match(es) by similarity",
    "people.peopleCount": "{n} person(s)",
    "people.searchPlaceholder": "Name, document, e-mail…",
    "people.searchByPhoto": "Search by photo",
    "people.errNoFace": "No usable face in the uploaded photo.",
    "people.errSearchFailed": "Photo search failed.",
    "people.sortedBySimilarity": "Results sorted by facial similarity.",
    "people.facesMatchCount": "{f} face(s) detected · {n} match(es)",
    "people.extractedFaces": "Faces extracted from the image",
    "people.faceHint": "Face {i} — {n} match(es)",
    "people.nMatches": "{n} match",
    "people.faceNoMatch": "No match for the selected face.",
    "people.identity": "Identity",
    "people.createdAt": "Registered on",
    "people.noPhotos": "No reference photos.",
    "people.linkedSessions": "Linked verifications",
    "people.noSessions": "No linked verifications.",
    "common.email": "E-mail",
    "people.clear": "clear",
    "people.empty": "No people found.",
    "people.colSimilarity": "Similarity",
    "people.colPerson": "Person",
    "people.colDocument": "Document",
    "people.colPhotos": "Photos",
    "people.colValidations": "Validations",
    "status.passed": "Approved",
    "status.failed": "Denied",
    "status.pending": "Pending",
    "status.expired": "Expired",
    "sessions.title": "Verifications",
    "sessions.refresh": "Refresh",
    "sessions.loadedCount": "{n} loaded",
    "sessions.filterAll": "All",
    "sessions.searchPlaceholder": "Name, e-mail, session…",
    "sessions.empty": "No verification found.",
    "sessions.colDate": "Date",
    "sessions.colParticipant": "Participant",
    "sessions.colSession": "Session",
    "sessions.colStatus": "Status",
    "sessions.colApproved": "Approved",
    "sessions.yes": "Yes",
    "sessions.no": "No",
    "sessions.deepFlaggedTip": "Deep PAD flagged this session",
    "sessionDetail.title": "Liveness",
    "sessionDetail.notFound": "Verification not found.",
    "sessionDetail.loadFailed": "Failed to load the verification.",
    "sessionDetail.padLabel": "PAD",
    "sessionDetail.padOk": "OK",
    "sessionDetail.padFlagged": "FLAGGED",
    "sessionDetail.padError": "error",
    "sessionDetail.padAnalyzing": "analyzing",
    "sessionDetail.photoFace": "Face",
    "sessionDetail.photoFull": "Full frame",
    "sessionDetail.photoGesture": "Gesture",
    "sessionDetail.completedAt": "Completed at",
    "sessionDetail.geolocation": "Geolocation",
    "sessionDetail.geoNotProvided": "not provided",
    "sessionDetail.location": "Location",
    "sessionDetail.viaGeo": "via geolocation",
    "sessionDetail.viaIp": "via IP",
    "sessionDetail.localDetection": "Local detection",
    "sessionDetail.detShort": "det",
    "sessionDetail.frontality": "frontality",
    "sessionDetail.depth": "Depth",
    "sessionDetail.flashmark": "Flashmark",
    "sessionDetail.aiLiveness": "AI Liveness",
    "sessionDetail.aiProbability": "Liveness (AI)",
    "sessionDetail.aiVerdict": "AI verdict",
    "sessionDetail.padAnalysis": "PAD analysis",
    "sessionDetail.aiGesture": "AI Gesture",
    "sessionDetail.gestureChallenge": "Gesture challenge",
    "sessionDetail.aiProbabilityGesture": "Correct gesture (AI)",
    "sessionDetail.samePerson": "same person",
    "sessionDetail.aiVerdictGesture": "AI verdict gesture",
    "sessionDetail.padAnalysisGesture": "PAD analysis gesture",
    "sessionDetail.session": "Session",
    "sessionDetail.client": "Company",
    "sessionDetail.created": "Created",
    "sessionDetail.attempts": "Attempts",
    "sessionDetail.language": "Language",
    "reason.REAL_3D": "3D — live-face parallax",
    "reason.FLAT_SPOOF": "flat surface — possible spoof",
    "reason.LIVE": "face reflected the light pattern",
    "reason.SPOOF": "face did not reflect the flash",
    "reason.inconclusive": "inconclusive",
    "reason.geo_required": "geolocation required",
    "reason.local:no_face": "no face detected",
    "reason.local:multiple_faces": "multiple faces detected",
    "reason.local:not_frontal": "face not frontal",
    "reason.local:too_close": "face too close",
    "reason.local:fill_oval": "face too small in the oval",
    "reason.local:off_center": "face off-center",
    "reason.local:blurry": "blurry image",
    "reason.local:low_confidence": "low detection confidence",
    "reason.local:decode_failed": "failed to decode image",
    "reason.local:detector_unavailable": "detector unavailable",
    "reason.local:ok": "ok",
    // --- added: SecFace liveness/admin screens ---
    "report.download": "Download signed PDF report",
    // --- added: SecFace liveness/admin screens ---
    "video.watch": "View video",
    "video.download": "Download video",
    "video.hide": "Hide video",
    "video.title": "Recorded liveness session",
    "video.unavailable": "Recording unavailable for this session.",
    // --- added: SecFace liveness/admin screens ---
    "sessions.colReport": "Report",
    // --- added: SecFace liveness/admin screens ---
    "sessions.colSigned": "Signed",
    // --- added: SecFace liveness/admin screens ---
    "sessions.filterStatus": "Status",
    // --- added: SecFace liveness/admin screens ---
    "sessions.signedWaiting": "Awaiting PAD",
    "sessions.signedError": "Error",
    "sessions.copyId": "Copy session ID",
  },
  pt: {
    "oidc.signingIn": "Entrando em {app}…",
    "pub.login.continue": "Continuar",
    "pub.login.change": "trocar",
    "pub.login.badCode": "Código inválido.",
    "pub.login.expired": "A sessão de login expirou. Comece de novo.",
    "pub.signOut": "Sair",
    "pub.verified": "Verificado",
    "pub.unverified": "Não verificado",
    "pub.email": "E-mail",
    "pub.phone": "Celular",
    "pub.biometric": "Minha biometria",
    "pub.enrolled": "Cadastrada",
    "pub.home.title": "Meus dados",
    "pub.home.subtitle": "Os dados que provamos pertencerem a você.",
    "pub.login.title": "Entrar",
    "pub.login.subtitle": "Acesse seus dados e sua biometria.",
    "pub.login.face": "Entrar com meu rosto",
    "pub.login.faceWaiting": "Aguardando a captura…",
    "pub.login.or": "ou",
    "pub.login.email": "E-mail",
    "pub.login.password": "Senha",
    "pub.login.mfa": "Código do autenticador",
    "pub.login.submit": "Entrar",
    "pub.login.register": "Criar minha conta",
    "pub.login.invalid": "E-mail, senha ou código inválidos.",
    "pub.login.faceUnavailable": "Login facial indisponível no momento.",
    "pub.login.faceFailed": "Não foi possível identificar você. Tente novamente.",
    "pub.login.notPortal": "Este rosto não pertence a uma conta do portal.",
    "pub.reg.title": "Criar minha conta",
    "pub.reg.subtitle": "Confirmamos seu e-mail e seu celular, você define a senha e o MFA, e por fim cadastra seu rosto.",
    "pub.reg.back": "Voltar ao login",
    "pub.reg.stepData": "Dados",
    "pub.reg.stepCodes": "Verificação",
    "pub.reg.stepPassword": "Senha",
    "pub.reg.stepMfa": "MFA",
    "pub.reg.firstName": "Nome",
    "pub.reg.lastName": "Sobrenome",
    "pub.reg.email": "E-mail",
    "pub.reg.phone": "Celular (WhatsApp)",
    "pub.reg.sendCodes": "Enviar códigos",
    "pub.reg.codesHelp": "Enviamos um código diferente para cada canal. Confirme os dois.",
    "pub.reg.codeSent": "Código enviado para {to}",
    "pub.reg.codeNotSent": "Não foi possível enviar para {to}",
    "pub.reg.confirm": "Confirmar",
    "pub.reg.password": "Senha",
    "pub.reg.password2": "Repita a senha",
    "pub.reg.setPassword": "Definir senha",
    "pub.reg.mfaHelp": "Escaneie o QR no seu app autenticador e digite o código gerado.",
    "pub.reg.finish": "Concluir e cadastrar meu rosto",
    "pub.reg.emailTaken": "Este e-mail já tem conta.",
    "pub.reg.badPhone": "Telefone inválido.",
    "pub.reg.rate": "Muitas tentativas. Aguarde alguns minutos.",
    "pub.reg.startFailed": "Não foi possível iniciar o cadastro.",
    "pub.reg.codeWrong": "Código incorreto.",
    "pub.reg.codeExpired": "Código expirado.",
    "pub.reg.codeFailed": "Não foi possível confirmar.",
    "pub.reg.mismatch": "As senhas não conferem.",
    "pub.reg.passwordFailed": "Senha recusada pela política.",
    "pub.reg.mfaWrong": "Código do autenticador inválido.",
    "pub.enroll.title": "Cadastre seu rosto",
    "pub.enroll.body": "Sua conta só fica ativa depois do cadastro facial. Abra a captura, siga as instruções na tela e volte aqui.",
    "pub.enroll.cta": "Abrir a captura",
    "pub.enroll.again": "Abrir a captura novamente",
    "pub.enroll.waiting": "Aguardando a conclusão da captura…",
    "pub.enroll.failed": "Não foi possível iniciar a captura.",
    "bio.via.admin": "Verificada pelo admin",
    "bio.via.document": "Verificada por documento",
    "bio.via.code": "Verificada por código",
    "bio.via.legacy": "Verificada (legado — anterior à regra)",
    "bio.identVerified": "Verificada",
    "bio.identUnverified": "Não verificada — não é exposta aos consumidores",
    "profile.title": "Meus dados",
    "profile.subtitle": "Confirme a posse do seu e-mail e telefone. Toda alteração exige um código enviado para o próprio contato.",
    "profile.email": "E-mail",
    "profile.phone": "Telefone (WhatsApp)",
    "profile.verified": "Verificado",
    "profile.unverified": "Não verificado",
    "profile.verify": "Verificar",
    "profile.change": "Alterar",
    "profile.sendCode": "Enviar código",
    "profile.confirm": "Confirmar",
    "profile.resend": "Reenviar",
    "profile.codeSent": "Código enviado para {to}. Expira em {ttl} minutos.",
    "profile.emailHelp": "Enviaremos um código para este e-mail. Ele só passa a valer depois que você confirmar.",
    "profile.phoneHelp": "Enviaremos um código por WhatsApp. Ele só passa a valer depois que você confirmar.",
    "profile.codeWrong": "Código incorreto.",
    "profile.codeExpired": "Código expirado — envie outro.",
    "profile.codeBlocked": "Tentativas demais. Envie um novo código.",
    "profile.sendFailed": "Falha ao enviar o código.",
    "profile.verifyFailed": "Não foi possível confirmar.",
    "profile.notSent": "Não foi possível entregar o código neste canal.",
    "search.title": "Busca",
    "search.placeholder": "Buscar em todo o sistema…",
    "search.hint": "Nome, e-mail, CPF, telefone, empresa, app ou id de sessão. Esc para fechar.",
    "search.enter": "Enter",
    "search.found": "{n} resultado(s) para “{q}”",
    "search.empty": "Nada encontrado. Valores sensíveis (e-mail, CPF, telefone) são cifrados e só casam pelo valor exato.",
    "search.type.biometric": "Biometrias",
    "search.type.account": "Contas",
    "search.type.session": "Verificações",
    "search.type.company": "Empresas",
    "search.type.client_app": "Client apps",
    "search.type.person": "Pessoas",
    "search.type.alert": "Alertas",
    "globalConfig.docPhotoMatch": "Foto impressa × foto assinada",
    "globalConfig.docPhotoMatchHelp": "A foto do QR é assinada (à prova de adulteração) mas minúscula (~45x61), o que degrada o reconhecimento. O PDF também traz uma cópia em alta resolução, porém sem assinatura. Este é o mínimo de correlação de pixels entre as duas para aceitar a foto impressa e usá-la no match facial. Maior = mais rígido (uma foto trocada nunca passa); menor = aceita variações de impressão/compressão.",
    "bio.docPhotoSrc": "Foto usada",
    "bio.docPhotoVisible": "impressa em alta resolução (validada contra a assinada)",
    "bio.docPhotoQr": "do QR (assinada)",
    "globalConfig.change": "Alterar",
    "globalConfig.modelTitle": "Alterar o modelo de reconhecimento",
    "globalConfig.modelWarn": "Esta alteração invalida TODAS as biometrias cadastradas.",
    "globalConfig.modelWarnBody": "O modelo gera a assinatura facial: trocá-lo muda o espaço vetorial, então nenhum template existente pode mais ser comparado. Todas as pessoas precisarão se recadastrar, o pré-filtro (ANN) terá de ser re-treinado e as autenticações falharão até lá.",
    "globalConfig.modelCurrent": "Modelo atual",
    "globalConfig.modelNew": "Novo modelo",
    "globalConfig.modelEnrollments": "Cadastros invalidados",
    "globalConfig.modelPeople": "Pessoas afetadas",
    "globalConfig.modelGold": "Biometrias Ouro",
    "globalConfig.modelType": "Para confirmar, digite",
    "globalConfig.modelApply": "Alterar modelo",
    "globalConfig.modelFailed": "Não foi possível alterar o modelo.",
    "bio.removeIdentity": "Remover identidade",
    "bio.removeIdentityBody": "Remover {id} desta biometria? A pessoa deixa de ser encontrada por esta identidade.",
    "bio.docSigner": "Assinado por",
    "bio.docCert": "Certificado",
    "bio.docThumb": "Thumbprint",
    "bio.docPubKey": "Chave pública",
    "bio.downloadDoc": "Baixar documento",
    "bio.reactivate": "Reativar cadastro anterior",
    "bio.newEnrollLink": "Gerar link de cadastro",
    "bio.enrollLinkHelp": "Abra este link (ou escaneie o QR) no celular para refazer o cadastro biométrico.",
    "bio.inactive": "inativo",
    "bio.reviewTitle": "Documento aguardando revisão",
    "bio.reviewBody": "A similaridade entre a foto do documento e o rosto cadastrado ficou na faixa de revisão.",
    "bio.approve": "Aprovar",
    "bio.reject": "Rejeitar",
    "globalConfig.docBandsHelp": "Faixas de decisão da similaridade entre a FOTO do documento e a biometria cadastrada: abaixo do 1º limiar o documento é recusado; entre os dois vai para revisão manual de um admin; acima do 2º concede o nível Ouro automaticamente.",
    "globalConfig.bandDeny": "Recusar",
    "globalConfig.bandReview": "Revisar",
    "globalConfig.bandAllow": "Permitir",
    "doc.reason.reviewPending": "Enviado para revisão de um admin — o match facial não foi conclusivo.",
    "alerts.document_review": "Documento aguardando revisão manual",
    "bio.typeToConfirm": "Para confirmar, digite",
    "bio.deenrollTitle": "Remover cadastro biométrico",
    "bio.deenrollBody": "Remove o template facial desta pessoa — ela deixa de autenticar até se cadastrar novamente.",
    "bio.addIdentity": "Adicionar identidade",
    "bio.addIdentityHelp": "Vincule um e-mail, CPF, telefone ou id externo a esta biometria. Cada identidade é única em todo o sistema.",
    "sessions.bioMatch": "Match biométrico",
    "sessions.bioIdentified": "Identificado",
    "alerts.duplicate_identity": "Mesma identidade em duas biometrias",
    "doc.upload": "Enviar um documento...",
    "bio.docPhoto": "Foto do documento",
    "bio.noDocPhoto": "Sem foto",
    "bio.docName": "Nome completo",
    "bio.docCpf": "CPF",
    "bio.docBirth": "Data de nascimento",
    "bio.revealData": "Ver dados completos",
    "bio.hideData": "Ocultar dados",
    "bio.docAttempts": "Tentativas de leitura de documento",
    "bio.date": "Data",
    "bio.docFile": "Arquivo",
    "bio.docResult": "Resultado",
    "bio.docSim": "Similaridade",
    "bio.docBy": "Por",
    "globalConfig.docFace": "Documento × rosto (Ouro)",
    "globalConfig.docFaceHelp": "Similaridade mínima entre a FOTO do documento e a biometria cadastrada para conceder o nível Ouro. Maior = mais rígido (evita documento de outra pessoa), porém pode reprovar fotos de documento antigas/baixa qualidade.",
    "doc.reason.faceMismatch": "A foto do documento não corresponde ao rosto cadastrado.",
    "doc.reason.photoUnavailable": "Não foi possível ler a foto do documento.",
    "doc.reason.docNoFace": "Nenhum rosto utilizável na foto do documento.",
    "doc.reason.noEnrollment": "Cadastre o rosto antes de verificar um documento.",
    "clientAppForm.genConfig": "Gerar config de exemplo (.env)",
    "clientAppForm.genConfigTitle": "Configuração de exemplo (RP)",
    "clientAppForm.genConfigHint": "Preencha o SEC_FACE_OIDC_CLIENT_SECRET com o segredo do app (mostrado ao criar/rotacionar).",
    "clientAppForm.cfgError": "Falha ao gerar a configuração.",
    "clientAppForm.copy": "Copiar",
    "clientAppForm.copied": "Copiado!",
    "common.close": "Fechar",
    "clientAppForm.minTier": "Nível mínimo (biometria)",
    "clientAppForm.minTierHelp": "Nível de confiança mínimo exigido para autenticar por biometria neste app.",
    "oidc.tierTitle": "Nível de verificação insuficiente",
    "oidc.tierBody": "Este aplicativo exige o nível {req}, mas sua biometria está em {cur}.",
    "oidc.tierHow": "Como subir de nível",
    "oidc.tierSilver": "Prata: peça a um administrador para confirmar sua biometria.",
    "oidc.tierGold": "Ouro: envie um documento nacional válido (CNH) na sua conta para verificação.",
    "bio.tier": "Nível de confiança",
    "bio.tierHelp": "Bronze: inicial. Prata: confirmada por um humano. Ouro: documento nacional válido verificado.",
    "bio.bronze": "Bronze",
    "bio.silver": "Prata",
    "bio.gold": "Ouro",
    "bio.confirmSilver": "Confirmar (Prata)",
    "bio.revertBronze": "Reverter para Bronze",
    "bio.goldDoc": "Documento",
    "bio.goldExpiry": "Validade",
    "doc.verifyGold": "Verificar documento (Ouro)",
    "doc.hint": "Envie a CNH/documento digital (PDF ou imagem do QR). Verificação offline; aceita documentos autênticos vencidos há no máximo 6 meses.",
    "doc.gold": "Documento verificado — nível Ouro concedido.",
    "doc.reason.notAuthentic": "Documento não é autêntico (falha na assinatura).",
    "doc.reason.sandbox": "Documento de teste/sandbox — não aceito.",
    "doc.reason.expired": "Documento vencido há mais de 6 meses.",
    "doc.reason.noExpiry": "Não foi possível ler a validade.",
    "doc.reason.parseFailed": "Não foi possível ler o documento.",
    "doc.reason.unavailable": "Verificação de documento indisponível.",
    "doc.reason.empty": "Arquivo vazio.",
    "nav.alerts": "Alertas",
    "globalConfig.dupAlert": "Alerta de biometria duplicada",
    "globalConfig.dupAlertHelp": "Acima deste valor duas biometrias CADASTRADAS de pessoas diferentes geram um alerta ao Super Admin (possível mesma pessoa em dois registros). Maior = menos alertas (só sósias quase idênticos).",
    "alerts.title": "Alertas de segurança",
    "alerts.subtitle": "Tentativas de fraude por conta e possíveis biometrias duplicadas.",
    "alerts.tab.open": "Abertos",
    "alerts.tab.dismissed": "Descartados",
    "alerts.tab.resolved": "Resolvidos",
    "alerts.tab.all": "Todos",
    "alerts.empty": "Nenhum alerta.",
    "alerts.error": "Erro",
    "alerts.account": "Conta",
    "alerts.kind.fraud": "Tentativa de fraude",
    "alerts.kind.duplicate": "Possível duplicata",
    "alerts.kind.blacklist": "Uso em blacklist",
    "alerts.blockTitle": "Bloquear conta",
    "alerts.blockBody": "A conta será desativada e não poderá mais acessar. Confirmar?",
    "alerts.block": "Bloquear conta",
    "alerts.notify": "Avisar proprietário",
    "alerts.mergeTitle": "Mesclar biometrias",
    "alerts.mergeKeepA": "Manter {a} e remover {b}?",
    "alerts.mergeKeep": "Manter",
    "alerts.dismiss": "Descartar",
    "alerts.cancel": "Cancelar",
    "alerts.confirm": "Confirmar",
    "bio.governance": "Governança",
    "bio.enabledLabel": "Biometria habilitada",
    "bio.enabledHelp": "Desabilite para impedir o uso em autenticação sem apagar o cadastro.",
    "bio.enabled": "Habilitada",
    "bio.disabled": "Desabilitada",
    "bio.blacklist": "Blacklist",
    "bio.blacklistHelp": "Negar todo uso, ou apenas alertar o Super Admin a cada uso.",
    "bio.blNone": "Normal",
    "bio.blDeny": "Negar todo uso",
    "bio.blAlert": "Somente alertar",
    "bio.hardDeleteTitle": "Remover biometria",
    "bio.hardDeleteBody": "Remove permanentemente esta biometria não utilizada (sem cadastro e sem histórico de uso). Ação irreversível.",
    "bio.hardDelete": "Remover (hard-delete)",
    "account.faceHelp2": "Gere um link para esta pessoa cadastrar o rosto, ou vincule a conta a uma biometria já existente. Depois ela poderá entrar pelo rosto na tela de login.",
    "face.link.linkedTo": "Vinculado a",
    "face.link.enrolled": "cadastrado",
    "face.link.notEnrolled": "sem template",
    "face.link.unlink": "Desvincular",
    "face.link.none": "Nenhuma biometria vinculada a esta conta.",
    "face.link.pickCta": "Vincular a biometria existente",
    "face.link.pickTitle": "Vincular a biometria existente",
    "face.link.searchPh": "Buscar por nome ou identidade…",
    "face.link.noResults": "Nenhuma pessoa encontrada.",
    "face.link.failed": "Falha na operação.",
    "account.faceTitle": "Biometria facial",
    "account.faceHelp": "Gere um link (com QR) para esta pessoa cadastrar o rosto. Depois ela poderá entrar pelo rosto na tela de login.",
    "face.enroll.generate": "Gerar link de cadastro facial",
    "face.enroll.regenerate": "Atualizar cadastro facial",
    "login.mfaInvalid": "Código inválido. Tente novamente.",
    "globalConfig.secOidc": "Login facial OIDC — confirmação por e-mail",
    "globalConfig.oidcNote": "No login facial de apps externos (OIDC), quando o match 1:N fica AMBÍGUO exigimos uma confirmação por e-mail (código). Estes dois valores definem o que conta como 'ambíguo'.",
    "globalConfig.oidcConf": "Margem de confiança",
    "globalConfig.oidcConfHelp": "Quanto o melhor match precisa superar o limiar de autenticação para ser aceito SEM confirmação por e-mail. Maior = exige e-mail com mais frequência (mais seguro, menos cômodo).",
    "globalConfig.oidcSep": "Separação 1º–2º",
    "globalConfig.oidcSepHelp": "Distância mínima entre o 1º e o 2º rostos mais parecidos. Se dois candidatos ficam próximos demais, é ambíguo → pede e-mail. Maior = mais rígido contra sósias.",
    "oidc.scope.openid": "Identidade (identificador único)",
    "oidc.scope.profile": "Nome do perfil",
    "oidc.scope.email": "Endereço de e-mail",
    "oidc.loadError": "Não foi possível carregar a solicitação.",
    "oidc.invalidRequest": "Solicitação inválida.",
    "oidc.noEmail": "Sem e-mail cadastrado para confirmação.",
    "oidc.otpSendFailed": "Falha ao enviar o código.",
    "oidc.otpInvalid": "Código inválido ou expirado.",
    "oidc.unexpected": "Resposta inesperada do servidor.",
    "oidc.confirmFirst": "Confirme sua identidade por e-mail primeiro.",
    "oidc.completeFailed": "Não foi possível concluir.",
    "oidc.failedTitle": "Autenticação não concluída",
    "oidc.failedBody": "A verificação facial não foi aprovada. Você pode retornar ao aplicativo e tentar novamente.",
    "oidc.backToApp": "Voltar ao aplicativo",
    "oidc.title": "Autorizar acesso",
    "oidc.intro": "o aplicativo",
    "oidc.client": "cliente",
    "oidc.introTail": "quer acessar sua identidade verificada por biometria.",
    "oidc.confirmTitle": "Confirmação de identidade",
    "oidc.confirmBody": "Para sua segurança, precisamos confirmar sua identidade por e-mail",
    "oidc.sending": "Enviando…",
    "oidc.sendCode": "Enviar código por e-mail",
    "oidc.confirm": "Confirmar",
    "oidc.confirmed": "Identidade confirmada por e-mail.",
    "oidc.willShare": "Serão compartilhados",
    "oidc.deny": "Recusar",
    "oidc.authorize": "Autorizar",
    "oidc.alreadyConsented": "Você já autorizou este aplicativo anteriormente.",
    "oidc.revokeNote": "Você pode revogar este acesso a qualquer momento.",
    "globalConfig.defaultIs": "padrão",
    "globalConfig.secLiveness": "Vivacidade (liveness)",
    "globalConfig.secMatch": "Reconhecimento facial (limiares de match)",
    "globalConfig.secAnn": "Pré-filtro de busca 1:N (ANN)",
    "globalConfig.flashCut": "Gate do Flashmark",
    "globalConfig.flashCutHelp": "Correlação mínima (0–1) entre os flashes coloridos da tela e o reflexo no rosto para considerar VIVO. Abaixo disso a sessão é reprovada como spoof (foto/tela). Maior = mais rígido contra telas, porém mais sensível a ambientes muito claros.",
    "globalConfig.cosineNote": "Valores de similaridade de cosseno (0 a 1). Maior = mais rígido (menos falsos positivos, porém mais rejeições de pessoas legítimas). Deixe em branco para usar o padrão.",
    "globalConfig.authSim": "Login facial (1:1 e 1:N)",
    "globalConfig.authSimHelp": "Corte para autenticar por biometria — tanto o login facial próprio (1:N entre usuários do sistema) quanto a autenticação 1:1 de aplicativos. É o parâmetro mais sensível de segurança: subir reduz o risco de aceitar a pessoa errada (FAR), descer facilita o acesso.",
    "globalConfig.kycSim": "KYC — selfie × documento",
    "globalConfig.kycSimHelp": "Corte para considerar que a selfie ao vivo é a mesma pessoa da foto do documento. Costuma ser MENOR que o login, pois comparar foto impressa/antiga com rosto ao vivo é mais difícil (impressão, idade, iluminação).",
    "globalConfig.samePerson": "Gate 'mesma pessoa' (captura)",
    "globalConfig.samePersonHelp": "Durante a captura, exige que o rosto recortado, o quadro completo e a foto do gesto sejam a MESMA pessoa. Abaixo deste valor a sessão é reprovada (troca de rosto / pessoas diferentes no vídeo). Subir demais pode reprovar capturas legítimas com ângulos variados.",
    "globalConfig.matchSim": "Vínculo automático (registro de pessoas)",
    "globalConfig.matchSimHelp": "No registro de Pessoas, corte para vincular automaticamente uma nova captura a uma pessoa já existente na mesma empresa. Maior = cria mais pessoas separadas; menor = agrupa mais (risco de juntar pessoas diferentes).",
    "globalConfig.dupSim": "Foto duplicada",
    "globalConfig.dupSimHelp": "Acima deste valor duas fotos são tratadas como a MESMA imagem (não apenas a mesma pessoa) e a duplicata não é armazenada. Bem alto de propósito; baixar pode descartar fotos diferentes válidas da mesma pessoa.",
    "globalConfig.recognizer": "Modelo de reconhecimento (ArcFace)",
    "globalConfig.recognizerDefault": "padrão (buffalo_l)",
    "globalConfig.recognizerL": "mais preciso (autenticação)",
    "globalConfig.recognizerSc": "mais leve/rápido",
    "globalConfig.recognizerHelp": "Modelo que gera a assinatura facial. TROCAR INVALIDA todos os cadastros existentes (o espaço vetorial muda) — será preciso recadastrar todo mundo e re-treinar o pré-filtro. Só altere com um plano de migração.",
    "globalConfig.annNote": "Acelera a busca 1:N filtrando a base por um índice grosseiro antes de comparar (e descriptografar) registro a registro. Não afeta a decisão de match, só o desempenho e a cobertura da busca.",
    "globalConfig.nprobe": "Centróides consultados (nprobe)",
    "globalConfig.nprobeHelp": "Quantos 'baldes' do índice a busca abre. Maior = mais candidatos comparados (recall maior, porém mais descriptografias e mais lento); menor = mais rápido, com risco de pular o verdadeiro match.",
    "globalConfig.annMin": "Mínimo de cadastros para treinar",
    "globalConfig.annMinHelp": "Abaixo desta quantidade o pré-filtro NÃO é treinado e a busca faz varredura completa (seguro para recall). Só faz sentido treinar o índice quando a base é grande o bastante.",
    "globalConfig.retrainGrowth": "Crescimento para re-treinar",
    "globalConfig.retrainGrowthHelp": "Fração de crescimento da base (ex.: 0.25 = +25%) desde o último treino para o re-treino automático (no reaper) disparar. Maior = re-treina com menos frequência.",
    "globalConfig.retrainDelta": "Novos cadastros para re-treinar",
    "globalConfig.retrainDeltaHelp": "Além do percentual, exige pelo menos esta quantidade de novos templates desde o último treino antes de re-treinar. Evita re-treinos caros por variações pequenas.",
    "login.face.button": "Entrar com o rosto",
    "login.face.starting": "Iniciando…",
    "login.face.failed": "A verificação facial não foi aprovada.",
    "login.face.unavailable": "Login facial indisponível no momento.",
    "face.enroll.title": "Biometria facial",
    "face.enroll.cta": "Cadastrar meu rosto",
    "face.enroll.manage": "Meu rosto",
    "face.enroll.hint": "Abra o link (ou aponte a câmera para o QR) para cadastrar seu rosto. Depois você poderá entrar pelo rosto na tela de login.",
    "face.enroll.reHint": "Abra o link para atualizar o cadastro do seu rosto. Depois você poderá entrar pelo rosto na tela de login.",
    "face.enroll.generating": "Gerando link…",
    "face.enroll.failed": "Falha ao gerar o link de cadastro.",
    "face.enroll.open": "Abrir cadastro",
    "bio.prefilterOn": "Pré-filtro",
    "bio.analyzed": "analisados",
    "bio.fewer": "menos comparações exatas",
    "bio.prefilterOff": "Varredura completa",
    "bio.records": "registros",
    "bio.prefilterUntrained": "pré-filtro ainda não treinado",
    "bio.notFound": "Pessoa não encontrada.",
    "bio.loadFailed": "Falha ao carregar.",
    "bio.back": "Voltar para biometria",
    "bio.notEnrolled": "Sem cadastro",
    "bio.authCount": "Autenticações",
    "bio.readings": "Leituras",
    "bio.lastAuth": "Última",
    "bio.authentications": "Autenticações recentes",
    "bio.noSessions": "Nenhuma sessão ainda.",
    "bio.session": "Sessão",
    "bio.date": "Data",
    "bio.mode": "Modo",
    "bio.result": "Resultado",
    "bio.score": "Score",
    "bio.match": "Correspondência",
    "bio.noMatch": "Sem correspondência",
    "bio.dangerZone": "Zona de risco",
    "bio.noActions": "Nenhuma ação disponível.",
    "bio.searchByPhoto": "Buscar por foto",
    "bio.searching": "Buscando…",
    "bio.errNoFace": "Nenhum rosto utilizável na foto enviada.",
    "bio.errSearchFailed": "Falha na busca por foto.",
    "bio.sortedBySimilarity": "Ordenado por similaridade facial",
    "bio.matches": "correspondência(s)",
    "bio.clear": "limpar",
    "bio.similarity": "Similaridade",
    "bio.noMatches": "Nenhuma pessoa similar encontrada.",
    // Mural ao vivo (video wall do liveness)
    "nav.wall": "Mural",
    "wall.title": "Mural ao vivo",
    "wall.screens": "Telas",
    "wall.cameras": "Câmeras",
    "wall.both": "Telas + Câmeras",
    "wall.emptyBoth": "Nenhuma sessão ao vivo.",
    "nav.eventWall": "Mural do evento",
    "nav.health": "Saúde",
    "nav.jobsQueue": "Fila de Jobs",
    "nav.reviewQueue": "Revisão",
    "nav.coldSync": "Sincronização",
    "nav.coldStorage": "Cold Storage",
    "health.title": "Saúde",
    "health.subtitle": "Saúde da captura ao vivo por participante.",
    "health.problems": "{n} com problemas",
    "health.refresh": "Atualizar",
    "health.loading": "Carregando…",
    "health.empty": "Nenhuma sessão ao vivo.",
    "health.audio": "Áudio",
    "eventwall.title": "Mural do evento",
    "eventwall.event": "Evento",
    "eventwall.noEvents": "Nenhum evento ao vivo",
    "eventwall.presets": "Presets",
    "eventwall.presetTop": "Top 10 (posição)",
    "eventwall.presetCombo": "Top 8 (Tela + Câmera)",
    "eventwall.presetAll": "Todos",
    "eventwall.presetsHint": "Presets personalizados em breve.",
    "eventwall.empty": "Nenhum participante ao vivo neste evento.",
    "eventwall.countries": "Países",
    "eventwall.participants": "Participantes",
    "eventwall.performance": "DESEMPENHO",
    "eventwall.live": "(AO VIVO)",
    "eventwall.score": "Pontuação",
    "eventwall.solved": "Desafios Resolvidos",
    "eventwall.lastSubmit": "Último Submit",
    "eventwall.points": "PONTOS",
    "eventwall.challenges": "DESAFIOS",
    "eventwall.overallProgress": "PROGRESSO GERAL",
    "eventwall.officialTime": "HORÁRIO OFICIAL",
    "eventwall.category": "Categoria do último submit",
    "eventwall.ago": "atrás",
    "eventwall.pts": "pts",
    "eventwall.castObs": "Exibir isto na saída do OBS",
    "eventwall.castObsActive": "Ao vivo no OBS",
    "eventwall.castHint": "O botão de transmitir envia o preset (com a escolha atual Telas/Câmeras) para a saída do OBS em tempo real.",
    "recording.obsEnable": "Habilitar URL do OBS",
    "recording.obsHint": "Saída pública do Mural do evento para o OBS Browser — sem login, restrita ao(s) IP(s) do cliente abaixo.",
    "recording.obsIps": "IP(s) do cliente OBS",
    "recording.obsUrl": "URL do OBS Browser",
    "recording.obsUrlHint": "Cole numa fonte 'Navegador' do OBS. Acrescente ?kind=camera ou ?preset=all para mudar a visão.",
    "wall.screen": "Tela",
    "wall.camera": "Câmera",
    "wall.live": "Ao vivo",
    "wall.offline": "Offline",
    "wall.listen": "Ouvir",
    "wall.mute": "Silenciar",
    "wall.expand": "Abrir em tela cheia",
    "wall.refresh": "Atualizar",
    "wall.loading": "Carregando…",
    "wall.participant": "participante",
    "wall.liveCount": "{n} ao vivo",
    "wall.emptyScreens": "Nenhuma sessão ao vivo compartilhando tela.",
    "wall.emptyCameras": "Nenhuma sessão ao vivo compartilhando câmera.",
    "wall.unsupported": "Este navegador não decodifica o mural ao vivo. Use Chrome ou Edge.",
    "login.email": "E-mail",
    "login.email.placeholder": "voce@exemplo.com",
    "login.password": "Senha",
    "login.password.placeholder": "Digite sua senha",
    "login.submit": "Entrar",
    "login.continue": "Continuar",
    "login.back": "← Voltar",
    "login.or": "ou",
    "login.newPassword": "Nova senha",
    "login.confirmPassword": "Confirmar senha",
    "login.saveAndEnter": "Salvar e entrar",
    "login.contestant.title": "Acesso do participante",
    "login.contestant.subtitle": "Entre com seu e-mail e senha.",
    "login.contestant.help": "Problemas para acessar? Fale com o aplicador da sua prova.",
    "sessionAuth.title": "Acesso à prova",
    "sessionAuth.subtitle": "Informe o token de sessão recebido para iniciar sua prova.",
    "sessionAuth.token": "Token de sessão",
    "sessionAuth.token.placeholder": "Cole o seu token de sessão",
    "sessionAuth.submit": "Entrar",
    "sessionAuth.invalid": "Token de sessão inválido ou expirado.",
    "sessionAuth.help": "Problemas para acessar? Fale com o aplicador da sua prova.",
    "login.setPassword.title": "Defina uma nova senha",
    "login.setPassword.subtitle": "É necessário alterar a senha no primeiro acesso.",
    "login.system.title": "Acessar o sistema",
    "login.system.emailSubtitle": "Entre com o e-mail cadastrado no sistema.",
    "login.system.emailHelp": "Caso não lembre seu e-mail cadastrado entre em contato pelo nosso e-mail",
    "login.system.passwordSubtitle": "Informe a senha da sua conta para continuar.",
    "login.oidc": "Entrar com Office 365",
    "login.mfa.subtitle": "Digite o código de 6 dígitos enviado ao seu e-mail.",
    "login.mfa.submit": "Validar código",
    "login.mfa.notReceived": "Não recebeu o código?",
    "login.mfa.resend": "Reenviar",
    "login.change.title": "Alterar senha",
    "login.change.subtitle": "Sua senha precisa ser alterada antes de continuar.",
    "login.change.newPlaceholder": "Digite a nova senha",
    "login.change.confirmPlaceholder": "Confirme a nova senha",
    "login.pw.min8": "Mínimo 8 caracteres",
    "login.pw.upper": "Letra maiúscula",
    "login.pw.lower": "Letra minúscula",
    "login.pw.special": "Caractere especial",
    "login.pw.match": "Senhas coincidem",
    "error.invalidCredentials": "Credenciais inválidas.",
    "error.wrongPassword": "Senha incorreta. Tente novamente.",
    "error.passwordsMismatch": "As senhas não coincidem.",
    "error.changePassword": "Erro ao alterar a senha.",
    "error.mfaIncomplete": "Digite o código completo de 6 dígitos.",
    "nav.dashboard": "Dashboard",
    "nav.console": "Console",
    "nav.admin": "Admin",
    "nav.contestants": "Participantes",
    "nav.accounts": "Contas",
    "nav.clientApps": "Aplicativos",
    "nav.verifications": "Verificações",
    "nav.people": "Pessoas",
    "nav.biometrics": "Biometria",
    "bio.title": "Identità biometriche",
    "bio.subtitle": "Persone biometriche globali, identità collegate, consenso per azienda, registrazione e LGPD.",
    "bio.search": "Cerca per nome o identità…",
    "bio.name": "Nome",
    "bio.identities": "Identità",
    "bio.enrolled": "Registrato",
    "bio.companies": "Aziende",
    "bio.status": "Stato",
    "bio.yes": "Sì",
    "bio.no": "No",
    "bio.purged": "Rimosso (LGPD)",
    "bio.empty": "Nessuna persona biometrica ancora.",
    "bio.add": "Aggiungi",
    "bio.identityValue": "valore",
    "bio.consentOn": "Consenso concesso",
    "bio.consentOff": "Nessun consenso",
    "bio.enrollments": "Registrazioni",
    "bio.encrypted": "cifrato",
    "bio.plaintext": "testo in chiaro",
    "bio.sessions": "Sessioni recenti",
    "bio.deenroll": "Annulla registrazione (rimuovi template)",
    "bio.lgpd": "Rimuovi (LGPD)",
    "bio.lgpdTitle": "Rimozione LGPD",
    "bio.lgpdBody": "Questo cifra e conserva un record minimo, invia la chiave di recupero al soggetto via e-mail e poi elimina definitivamente la chiave dal server. Irreversibile.",
    "bio.escrowEmail": "E-mail del soggetto (chiave di recupero)",
    "bio.cancel": "Annulla",
    "bio.confirm": "Conferma",
    "bio.error": "Errore",
    "bio.newPerson": "Nuovo link di registrazione",
    "bio.company": "Seleziona azienda…",
    "bio.createLink": "Crea link",
    "bio.creating": "Creazione…",
    "bio.linkReady": "Condividi questo link con la persona per registrare la biometria:",
    "bio.copy": "Copia",
    "bio.copied": "Copiato!",
    "bio.openLink": "Apri",
    "bio.done": "Fatto",
    "bio.sendEmail": "Invia all'e-mail…",
    "bio.send": "Invia",
    "bio.sent": "Inviato!",
    "bio.title": "Identidades biométricas",
    "bio.subtitle": "Pessoas biométricas globais, identidades vinculadas, consentimento por empresa, cadastro e LGPD.",
    "bio.search": "Buscar por nome ou identidade…",
    "bio.name": "Nome",
    "bio.identities": "Identidades",
    "bio.enrolled": "Cadastrado",
    "bio.companies": "Empresas",
    "bio.status": "Status",
    "bio.yes": "Sim",
    "bio.no": "Não",
    "bio.purged": "Removido (LGPD)",
    "bio.empty": "Nenhuma pessoa biométrica ainda.",
    "bio.add": "Adicionar",
    "bio.identityValue": "valor",
    "bio.consentOn": "Consentimento concedido",
    "bio.consentOff": "Sem consentimento",
    "bio.enrollments": "Cadastros",
    "bio.encrypted": "criptografado",
    "bio.plaintext": "texto claro",
    "bio.sessions": "Sessões recentes",
    "bio.deenroll": "Descadastrar (remover template)",
    "bio.lgpd": "Remover (LGPD)",
    "bio.lgpdTitle": "Remoção por LGPD",
    "bio.lgpdBody": "Isto criptografa e retém um registro mínimo, envia a chave de recuperação ao titular por e-mail e então apaga permanentemente a chave do servidor. Irreversível.",
    "bio.escrowEmail": "E-mail do titular (chave de recuperação)",
    "bio.cancel": "Cancelar",
    "bio.confirm": "Confirmar",
    "bio.error": "Erro",
    "bio.newPerson": "Novo link de cadastro",
    "bio.company": "Selecionar empresa…",
    "bio.createLink": "Criar link",
    "bio.creating": "Criando…",
    "bio.linkReady": "Compartilhe este link com a pessoa para cadastrar a biometria:",
    "bio.copy": "Copiar",
    "bio.copied": "Copiado!",
    "bio.openLink": "Abrir",
    "bio.done": "Concluído",
    "bio.sendEmail": "Enviar para e-mail…",
    "bio.send": "Enviar",
    "bio.sent": "Enviado!",
    "nav.global": "Global",
    "account.listSubtitle": "Usuários do sistema (admins da instituição e livenesss).",
    "account.empty": "Nenhuma conta ainda.",
    "account.new": "Nova conta",
    "account.edit": "Editar conta",
    "account.newSubtitle": "Crie ou edite um usuário do sistema (admin / liveness).",
    "account.removeTitle": "Remover conta",
    "account.registered": "Conta criada",
    "account.role": "Papel",
    "account.role.institution_admin": "Admin da instituição",
    "account.role.liveness": "Liveness",
    "account.role.super": "Super Admin",
    "account.loadError": "Não foi possível carregar a conta.",
    "account.saveError": "Não foi possível salvar a conta.",
    "nav.exams": "Provas",
    "nav.events": "Eventos",
    "nav.examsEvents": "Provas / Eventos",
    "nav.configuration": "Configuração",
    "nav.companies": "Empresas",
    "nav.settings": "Configurações",
    "nav.ai": "IA",
    "nav.jobs": "Jobs",
    "ai.title": "IA",
    "ai.subtitle": "Servidor Ollama para refinamento das detecções",
    "ai.ollamaUrl": "URL do Ollama",
    "ai.visionModel": "Modelo de visão",
    "ai.enabled": "Refinamento por Ollama",
    "ai.enabledHelp": "Quando desligado, as detecções usam só os modelos locais (sem refinamento por LLM).",
    "ai.testConnectivity": "Testar conexão",
    "ai.testOk": "Conexão OK",
    "ai.testFailed": "Falha na conexão",
    "ai.modelsFound": "Modelos disponíveis",
    "ai.modelPresent": "O modelo selecionado está instalado",
    "ai.modelMissing": "Modelo selecionado NÃO encontrado no servidor",
    "common.close": "Fechar",
    "common.saved": "Salvo",
    "nav.logout": "Sair",
    "dash.title": "Dashboard",
    "dash.subtitle": "Analytics ao vivo das sessões da sua instituição.",
    "dash.realtime": "Tempo real",
    "dash.now": "agora",
    "dash.activeSessions": "Sessões ativas",
    "dash.sessionsByTarget": "Sessões por evento / exame",
    "dash.modeExam": "Exame",
    "dash.modeEvent": "Evento",
    "dash.noSessions": "Nenhuma sessão ao vivo no momento.",
    "dash.liveOrigin": "Visitantes ao vivo",
    "dash.cities": "cidade(s)",
    "dash.sessions": "Sessões",
    "dash.byProfile": "pela cidade do perfil",
    "dash.withoutCoords": "sem coordenadas",
    "dash.devices": "Devices",
    "dash.throughput": "Throughput",
    "dash.throughputHint": "média · último 1 min",
    "dash.traffic": "Tráfego do servidor",
    "dash.perMinute": "Por minuto · últimos 30 min",
    "dash.perSecond": "Por segundo · últimos 60s",
    "dash.healthTitle": "Saúde das sessões",
    "dash.healthHint": "top 10 conectados · problemas primeiro",
    "dash.participant": "Participante",
    "dash.target": "Evento / exame",
    "dash.status": "Status",
    "dash.healthy": "Saudável",
    "dash.unhealthy": "Com problema",
    "dash.recordingFailure": "Falha de gravação",
    "dash.rate": "Taxa",
    "dash.total": "Total",
    "dash.source.screen": "Tela",
    "dash.source.camera": "Câmera",
    "dash.source.audio": "Áudio",
    "dash.sourceOk": "Transmitindo",
    "dash.sourceBad": "Sem transmissão",
    "dash.sourceNa": "Não exigido",
    "dash.countriesCities": "Países e cidades",
    "dash.countryCity": "País / cidade",
    "dash.noCountryData": "Sem dados de país no momento.",
    "dash.topIps": "Top IPs",
    "dash.ip": "IP",
    "dash.location": "Localização",
    "dash.noIps": "Sem IPs no momento.",
    "common.name": "Nome",
    "common.firstName": "Nome",
    "common.lastName": "Sobrenome",
    "common.phone": "Telefone",
    "common.language": "Idioma",
    "common.country": "País",
    "common.company": "Empresa",
    "common.selectCompany": "Selecione a empresa...",
    "common.actions": "Ações",
    "common.edit": "Editar",
    "common.remove": "Remover",
    "common.cancel": "Cancelar",
    "common.save": "Salvar",
    "common.create": "Criar",
    "common.back": "Voltar",
    "common.add": "Adicionar",
    "common.confirmRemove": "Tem certeza que deseja remover",
    "contestant.new": "Novo Participante",
    "contestant.listSubtitle": "Cadastre e gerencie os participantes da sua instituição.",
    "contestant.edit": "Editar Participante",
    "contestant.empty": "Nenhum participante cadastrado.",
    "contestant.removeTitle": "Remover participante?",
    "contestant.newSubtitle": "Cadastre um participante. Uma senha inicial será gerada e exibida uma única vez.",
    "contestant.editSubtitle": "Altere os dados do participante. A senha não é alterada aqui.",
    "contestant.registered": "Participante cadastrado",
    "contestant.saveNote": "Anote a senha inicial — ela não será exibida novamente.",
    "contestant.initialPassword": "Senha inicial",
    "contestant.copy": "Copiar",
    "contestant.copied": "Copiado!",
    "contestant.done": "Concluir",
    "contestant.password": "Senha",
    "contestant.policy.blocked": "Senha bloqueada",
    "contestant.policy.mustChange": "Trocar no acesso",
    "contestant.policy.free": "Livre",
    "contestant.mustChange": "Obrigar troca de senha no primeiro acesso",
    "contestant.cannotChange": "Não permitir que o participante troque a senha",
    "contestant.exclusive": "As duas opções são mutuamente exclusivas.",
    "contestant.policyLabel": "Política de senha",
    "contestant.emailPlaceholder": "participante@exemplo.com",
    "error.loadContestant": "Não foi possível carregar o participante.",
    "error.saveContestant": "Não foi possível salvar o participante. Verifique os dados.",
    "recording.empty": "Nada cadastrado.",
    "recording.start": "Início",
    "recording.scope": "Escopo",
    "recording.scope.national": "Nacional",
    "recording.scope.international": "Internacional",
    "common.state": "Estado",
    "common.state.placeholder": "Estado / região",
    "common.city": "Cidade",
    "common.city.placeholder": "Cidade",
    "recording.end": "Conclusão",
    "recording.duration": "Duração",
    "duration.day": "dia",
    "duration.days": "dias",
    "duration.hour": "hora",
    "duration.hours": "horas",
    "duration.minute": "minuto",
    "duration.minutes": "minutos",
    "duration.and": "e",
    "console.title": "Console do Liveness",
    "console.subtitle": "Sessões monitoradas da sua instituição.",
    "console.all": "Todas",
    "console.onlyLive": "Só ao vivo",
    "console.refresh": "Atualizar",
    "console.empty": "Nenhuma sessão no momento.",
    "console.emptyLive": "Nenhuma sessão ao vivo no momento.",
    "console.participant": "Participante",
    "console.event": "Evento",
    "console.system": "Sistema",
    "console.status": "Status",
    "console.start": "Início",
    "console.examTime": "Tempo de exame",
    "console.traffic": "Tráfego",
    "console.trafficHint": "Total transferido pelos streams de ingestão da sessão",
    "console.trafficRateHint": "Taxa atual",
    "console.files": "Arquivos",
    "console.filesHint": "Tamanho total dos arquivos gravados (câmera, tela, áudio)",
    "console.live": "Ao vivo",
    "console.reconnect": "Forçar reconexão do cliente",
    "console.telemetry": "Telemetria (console do cliente + eventos internos)",
    "console.review": "Revisar",
    "console.reviewLiveness": "Revisão de vivacidade",
    "console.noLiveness": "Sem captura de vivacidade nesta sessão",
    "console.disconnected": "Desconectado",
    "console.waitingStart": "Aguardando início",
    "console.recordingFailure": "Falha de gravação",
    "console.warning": "Aviso",
    "console.transportWebrtc": "WebRTC (LiveKit, legado)",
    "console.transportWebcodecs": "WebCodecs sobre WebSocket",
    "console.reconnectTitle": "Forçar reconexão",
    "console.reconnectBody": "O cliente de {name} irá reconectar silenciosamente (readquire microfone/câmera e reinicia os envios). Ocorre um breve corte de ~1–2s na gravação. Continuar?",
    "console.reconnectConfirm": "Reconectar",
    "console.reconnectError": "Não foi possível solicitar a reconexão.",
    "console.reconnectRequested": "Reconexão solicitada — o cliente reconecta em instantes.",
    "console.participantFallback": "participante",
    "console.sessionScope": "sessão",
    "console.kindClientDisconnected": "conexão do participante caiu",
    "console.kindStorageStalled": "gravação não está sendo armazenada",
    "console.kindStreamMissing": "stream obrigatório não iniciado",
    "console.kindVideoFrozen": "vídeo congelado (imagem parada)",
    "console.kindNoInput": "sem envio de mídia do participante",
    "recording.requirements": "Requisitos",
    "recording.camera": "Câmera",
    "recording.audio": "Áudio",
    "recording.screen": "Tela",
    "recording.requirementsLabel": "Requisitos de gravação",
    "recording.requiresCamera": "Exige câmera",
    "recording.requiresAudio": "Exige áudio",
    "recording.requireLiveness": "Exigir liveness (captura de identidade)",
    "recording.requireLivenessHint": "Antes de compartilhar tela/áudio o contestant deve passar por uma captura de liveness na câmera (gravada), independentemente de a câmera ser exigida.",
    "recording.livenessAllowNoGeo": "Permitir que o contestant não conceda a geolocalização",
    "recording.livenessAiThreshold": "Limiar da IA do liveness (%)",
    "recording.livenessAiThresholdHint": "Probabilidade da IA a partir da qual o liveness e o gesto são aceitos. Separado do limiar de anti-cheat.",
    "recording.requiresScreen": "Exige tela",
    "recording.allowExternalCamera": "Permitir câmera externa (celular)",
    "recording.requiresExternalCamera": "Exige câmera externa",
    "recording.antiCheat": "Análise anti-cola",
    "recording.analyzeRecordings": "Analisar gravações (pessoa extra, ausência, IA na tela)",
    "recording.detectExtraPerson": "Pessoa extra",
    "recording.detectAbsence": "Ausência",
    "recording.detectAiOnScreen": "IA na tela",
    "recording.maxCameras": "Máx. câmeras (exceto externas)",
    "recording.monitorTabSwitch": "Sinalizar troca de aba/janela (prova em aba única)",
    "recording.sectionRecord": "O que gravar",
    "recording.sectionMonitor": "O que monitorar / analisar",
    "recording.absenceSeconds": "Limiar de ausência (segundos fora da câmera antes de sinalizar)",
    "recording.aiThreshold": "Limiar de confirmação da IA (%)",
    "recording.aiThresholdHint": "Probabilidade da IA a partir da qual a detecção é confirmada automaticamente; abaixo, aguarda revisão do liveness. 0 confirma tudo.",
    "capture.addCamera": "Adicionar câmera",
    "capture.noMoreCameras": "Nenhuma câmera adicional detectada neste dispositivo.",
    "review.findings.title": "Análise automática",
    "review.findings.empty": "Nenhum achado automático.",
    "review.finding.multi_person": "Mais de uma pessoa na câmera",
    "review.finding.absent": "Aluno se ausentou da câmera",
    "review.finding.returned": "Aluno retornou à câmera",
    "review.finding.ai_on_screen": "IA na tela",
    "review.finding.tab_switch": "Trocou de aba/janela durante a prova",
    "review.finding.confidence": "confiança",
    "recording.durationLabel": "Duração (minutos) — 0 = indefinido",
    "recording.maxScreens": "Máx. de telas",
    "recording.logo": "Logo (redimensionada automaticamente para 200×200, fundo transparente)",
    "recording.formSubtitle": "Configure os dados e os requisitos de gravação.",
    "recording.allowedIps": "IPs / sub-redes permitidos",
    "recording.allowedIps.placeholder": "Ex: 192.168.0.0/24",
    "recording.allowedIps.hint": "Deixe vazio para permitir qualquer endereço. O participante só poderá acessar a partir destes.",
    "recording.removeTitle": "Remover?",
    "recording.loadError": "Não foi possível carregar o registro.",
    "recording.saveError": "Não foi possível salvar. Verifique os dados.",
    "recording.contestants": "Participantes",
    "recording.contestants.empty": "Ninguém matriculado ainda.",
    "recording.selectContestant": "Selecione um participante...",
    "recording.enroll": "Matricular",
    "recording.enrollment.expired": "expirada",
    "recording.enrollment.renew": "Renovar",
    "recording.schedule.title": "Horários de acesso",
    "recording.schedule.add": "Adicionar horário",
    "recording.schedule.empty": "Sem horários — o acesso vale por todo o período do evento.",
    "recording.schedule.hint": "Sem horários: o acesso fica liberado durante todo o período do evento. Com horários: o acesso abre 15 minutos antes de cada horário e encerra exatamente no fim dele.",
    "recording.profile": "Perfil de gravação",
    "recording.profile.default": "Padrão da empresa",
    "nav.profiles": "Perfis de gravação",
    "nav.recording": "Recording",
    "nav.simulation": "Simulação",
    "sim.title": "Simulação de capacidade",
    "sim.subtitle": "Quanto uma turma custa num perfil de gravação — medido, não estimado.",
    "sim.profile": "Perfil de gravação",
    "sim.clients": "Participantes",
    "sim.minutes": "Tempo de gravação (minutos)",
    "sim.run": "Simular",
    "sim.measuring": "Codificando uma amostra com os parâmetros deste perfil…",
    "sim.idle": "Ocioso",
    "sim.busy": "Ocupado",
    "sim.idleHint": "tela parada — o que as sessões reais mais se parecem",
    "sim.busyHint": "imagem mudando a cada frame — o pior caso a planejar",
    "sim.uplink": "Banda de ingestão",
    "sim.storage": "Armazenamento",
    "sim.perClient": "por participante",
    "sim.total": "total",
    "sim.perHour": "por participante-hora",
    "sim.sockets": "WebSockets",
    "sim.sources": "Fontes por participante",
    "sim.measured": "Medido neste servidor",
    "sim.notMeasured": "Não foi possível medir — números indisponíveis",
    "sim.rangeWhy": "Tudo é um intervalo porque o tráfego é decidido pelo que a tela do participante mostra, e nenhuma medição aqui pode saber isso. As sessões reais medidas ficam perto do extremo ocioso.",
    "sim.detail": "Medido por fonte",
    "sim.uplinkCol": "Ingestão",
    "sim.storedCol": "Armazenado",
    "sim.error": "Não foi possível simular.",
    "nav.apiTokens": "Tokens de API",
    "nav.agents": "Agentes",
    "agent.title": "Agentes",
    "agent.subtitle": "Máquinas que servem esta instalação.",
    "agent.name": "Agente",
    "agent.status.label": "Status",
    "agent.status.online": "Online",
    "agent.status.offline": "Offline",
    "agent.status.draining": "Drenando",
    "agent.kind.websocket": "WebSocket (ingestão)",
    "agent.kind.encoder": "Encoder",
    "agent.kind.all_in_one": "Máquina única",
    "agent.ip": "IP",
    "agent.cpu": "CPU",
    "agent.memory": "Memória",
    "agent.disk": "Disco livre",
    "agent.sessions": "Sessões",
    "agent.traffic": "Tráfego",
    "agent.heartbeat": "Heartbeat",
    "agent.empty": "Nenhum agente registrado.",
    "agent.error": "Não foi possível carregar os agentes.",
    "agent.secondsAgo": "há {n}s",
    "agent.minutesAgo": "há {n}min",
    "nav.webhooks": "Webhooks",
    "webhook.title": "Webhooks",
    "webhook.subtitle": "Envie alertas de eventos (online/offline, inicio/fim de sessao, saude, marcadores) para sistemas externos.",
    "webhook.new": "Novo webhook",
    "webhook.edit": "Editar webhook",
    "webhook.empty": "Nenhum webhook ainda.",
    "webhook.events": "Eventos",
    "webhook.allEvents": "Todos os eventos",
    "webhook.eventsHint": "Deixe todos desmarcados para receber todos os eventos.",
    "webhook.secret": "Segredo de assinatura",
    "webhook.secretHint": "Cada envio e assinado com HMAC-SHA256 (cabecalho X-Webhook-Signature).",
    "webhook.urlHint": "Destino do POST. Payload: {event, email, session_id, timestamp, session_health}.",
    "webhook.enabled": "Ativo",
    "webhook.create": "Criar webhook",
    "webhook.rotate": "Rotacionar segredo",
    "webhook.rotateConfirm": "Rotacionar o segredo de assinatura? O atual para de funcionar imediatamente.",
    "webhook.test": "Enviar evento de teste",
    "webhook.testOk": "Entregue",
    "webhook.testFail": "Falhou",
    "webhook.namePlaceholder": "ex.: Gateway VPN",
    "webhook.nameRequired": "O nome e obrigatorio.",
    "webhook.urlRequired": "A URL e obrigatoria.",
    "webhook.loadError": "Nao foi possivel carregar o webhook.",
    "webhook.saveError": "Nao foi possivel salvar o webhook.",
    "common.copy": "Copiar",
    "apiToken.title": "Tokens de API",
    "apiToken.subtitle": "Credenciais para sistemas externos chamarem a API pública (X-Api-Token).",
    "apiToken.new": "Novo token",
    "apiToken.edit": "Editar token",
    "apiToken.create": "Criar token",
    "apiToken.empty": "Nenhum token de API ainda.",
    "apiToken.namePlaceholder": "Ex: Sistema de liveness",
    "apiToken.nameRequired": "Informe um nome.",
    "apiToken.token": "Token (X-Api-Token)",
    "apiToken.tokenHint": "Envie no header X-Api-Token. Mantenha em segredo.",
    "apiToken.show": "Mostrar",
    "apiToken.hide": "Ocultar",
    "apiToken.ipAcl": "ACL por IP de origem",
    "apiToken.ipAclHint": "IPs ou CIDRs separados por vírgula. Vazio = qualquer IP.",
    "apiToken.anyIp": "qualquer IP",
    "apiToken.rateLimit": "Rate-limit (requisições por minuto)",
    "apiToken.rateLimitHint": "0 = sem limite.",
    "apiToken.noLimit": "sem limite",
    "apiToken.enabled": "Ativo",
    "apiToken.permissions": "Permissões",
    "apiToken.permissionsHint": "Quais famílias de endpoints de integração este token pode chamar.",
    "apiToken.permExam": "API de Exames (/api/integration/exam/*)",
    "apiToken.permEvent": "API de Eventos (/api/integration/event/*)",
    "apiToken.usage": "Uso — add_marker",
    "apiToken.usageHint": "Adiciona um marcador no timestamp (uma flag, uma anotação, qualquer coisa) e cria uma exportação mosaico de 60s antes até 60s depois.",
    "apiToken.rotate": "Rotacionar",
    "apiToken.rotateConfirm": "Gerar um novo token? O atual deixará de funcionar imediatamente.",
    "apiToken.loadError": "Erro ao carregar o token.",
    "apiToken.saveError": "Erro ao salvar.",
    "apiToken.examplesTitle": "API de integração de exames — exemplos de requisição",
    "apiToken.examplesIntro": "Autentique cada requisição com o header X-Api-Token. URL base:",
    "apiToken.eventsExamplesTitle": "API de integração de Eventos — exemplos de requisição",
    "apiToken.markerExamplesTitle": "API de integração de Marcadores — exemplos de requisição",
    "apiToken.markerExamplesIntro": "Autentique com o header X-Api-Token. Endpoint:",
    "apiToken.exampleListDesc": "Lista os exames disponíveis desta empresa.",
    "apiToken.exampleStartDesc": "Inicia a sessão de um exame para o aluno. Cria o aluno se necessário e retorna um token de sessão — o aluno acessa em /session_auth apenas com esse token (sem e-mail/senha). A senha de um aluno existente nunca é alterada.",
    "apiToken.exampleStatusDesc": "Consulta o status da sessão de exame do aluno pelo e-mail.",
    "apiToken.exampleStopDesc": "Encerra uma sessão de exame aberta pelo e-mail (ou session_id).",
    "apiToken.copy": "Copiar",
    "apiToken.copied": "Copiado!",
    "apiToken.parameters": "Parâmetros",
    "apiToken.responses": "Respostas",
    "apiToken.request": "Requisição",
    "apiToken.required": "obrigatório",
    "apiToken.paramName": "Nome",
    "apiToken.paramDesc": "Descrição",
    "apiToken.opListSummary": "Listar exames disponíveis",
    "apiToken.opStartSummary": "Iniciar sessão de exame",
    "apiToken.opStatusSummary": "Status da sessão do aluno",
    "apiToken.opStopSummary": "Encerrar sessão de exame",
    "apiToken.opMarkerSummary": "Adicionar um marcador (+ exportação de mosaico ±60s)",
    "apiToken.pMarkerTarget": "A sessão alvo, pelo seu UUID ou pelo e-mail do participante (resolve a sessão ativa naquele momento).",
    "apiToken.pMarkerTimestamp": "Instante ISO-8601 do marcador (ex.: 2026-07-08T20:58:45Z).",
    "apiToken.pMarkerDescription": "Nota em texto livre exibida no marcador.",
    "apiToken.pToken": "Token de API emitido para a sua empresa.",
    "apiToken.pEmail": "E-mail do aluno.",
    "apiToken.pName": "Nome completo do aluno (ou use first_name / last_name).",
    "apiToken.pExam": "O exame a ser realizado — seu id (exam_id) OU seu nome (exam_name).",
    "apiToken.pStatusEmail": "E-mail do aluno a consultar.",
    "apiToken.pStopTarget": "session_id, ou o e-mail do aluno (opcionalmente restrito por exam_id / exam_name).",
    "apiToken.rOk": "Sucesso.",
    "apiToken.rCreated": "Sessão criada (200 se uma sessão aberta foi reaproveitada).",
    "apiToken.rBadRequest": "Campos obrigatórios ausentes.",
    "apiToken.rExamNotFound": "Exame não encontrado para a empresa deste token.",
    "apiToken.rUnauthorized": "Token ausente ou inválido.",
    "apiToken.rSessionNotFound": "Nenhuma sessão de exame aberta encontrada.",
    "profile.new": "Novo perfil",
    "profile.edit": "Editar perfil",
    "profile.subtitle": "Perfis de gravação reutilizados por provas e eventos.",
    "profile.empty": "Nenhum perfil cadastrado ainda.",
    "profile.maxMonitors": "Máx. de monitores",
    "profile.maxCameras": "Máx. de câmeras",
    "profile.audioEnabled": "Áudio habilitado",
    "profile.allowExternalCamera": "Permitir câmera externa (celular)",
    "profile.videoFps": "FPS de vídeo",
    "profile.sampleRate": "Taxa de amostragem de áudio (kHz)",
    "profile.cameraRes": "Resolução máx. da câmera",
    "profile.screenRes": "Resolução máx. da tela",
    "profile.segment": "Duração do segmento (minutos)",
    "recording.exam.singular": "Prova",
    "recording.exam.new": "Nova Prova",
    "recording.exam.edit": "Editar Prova",
    "recording.exam.listSubtitle": "Cadastre provas e seus requisitos de gravação.",
    "recording.event.singular": "Evento",
    "recording.event.new": "Novo Evento",
    "recording.event.edit": "Editar Evento",
    "recording.event.listSubtitle": "Cadastre eventos e seus requisitos de gravação.",
    "company.listSubtitle": "Gerencie as empresas cadastradas no sistema.",
    "company.new": "Nova Empresa",
    "company.edit": "Editar Empresa",
    "company.newSubtitle": "Preencha os dados para cadastrar uma nova empresa.",
    "company.editSubtitle": "Altere os dados e configurações da empresa.",
    "company.empty": "Nenhuma empresa cadastrada.",
    "company.deleteTitle": "Excluir empresa?",
    "company.namePlaceholder": "Nome da empresa",
    "company.canSetLang": "Participante pode escolher o idioma",
    "company.canSetLang.desc": "Se desativado, o idioma do participante será sempre o da empresa.",
    "company.createdAt": "Criado em",
    "company.tab.data": "Dados",
    "company.tab.policy": "Política de Senha",
    "error.loadCompany": "Erro ao carregar empresa.",
    "error.saveCompany": "Erro ao salvar empresa.",
    "policy.title": "Política de Senha",
    "policy.minLength": "Comprimento Mínimo",
    "policy.requireUpper": "Exigir letra maiúscula",
    "policy.requireLower": "Exigir letra minúscula",
    "policy.requireSpecial": "Exigir caractere especial",
    "policy.blacklist": "Palavras Bloqueadas",
    "policy.blacklistPlaceholder": "Ex: admin",
    "policy.saved": "Política de senha salva com sucesso.",
    "error.savePolicy": "Erro ao salvar política de senha.",
    "settings.saved": "Configurações salvas com sucesso.",
    "error.saveSettings": "Erro ao salvar configurações.",
    "settings.saving": "Salvando...",
    "settings.save": "Salvar Configurações",
    "settings.title": "Configurações Gerais",
    "settings.subtitle": "Configure os parâmetros gerais do sistema",
    "common.loading": "Carregando...",
    "oidc.completing": "Concluindo login...",
    "oidc.failed": "Falha no login",
    "oidc.wait": "Aguarde, validando autenticação SSO.",
    "oidc.backToLogin": "Voltar ao login",
    "error.oidcInvalid": "Resposta OIDC inválida.",
    "error.oidcFailed": "Falha ao concluir o login SSO.",
    "contestant.home.title": "Suas provas e eventos",
    "contestant.home.subtitle": "Selecione um para começar.",
    "contestant.home.empty": "Nenhuma prova ou evento disponível no momento.",
    "capture.consent": "Li e concordo em ser monitorado",
    "capture.start": "Iniciar Gravação",
    "capture.recording": "Gravando…",
    "capture.reconnecting": "Reconectando…",
    "capture.audioAlertTitle": "Ativar alertas de áudio",
    "capture.audioAlertBody": "Esta tela toca um alarme sonoro caso alguma das suas mídias (tela, câmera ou microfone) seja desconectada durante a prova. O navegador precisa da sua permissão para reproduzir som.",
    "capture.audioAlertEnable": "Ativar áudio",
    "capture.audioAlertLater": "Agora não",
    "capture.finish": "Encerrar gravação",
    "capture.ending": "Encerrando…",
    "capture.pause": "Pausar gravação",
    "capture.pausing": "Pausando…",
    "capture.addScreen": "Adicionar tela",
    "capture.enable": "Ativar",
    "capture.active": "Ativo",
    "capture.micActive": "Microfone ativo",
    "capture.required": "Obrigatório",
    "capture.gate": "Adicione todos os recursos exigidos e aceite o monitoramento para iniciar.",
    "watchdog.restartTitle": "Recompartilhe para retomar a gravação",
    "watchdog.restartBody": "Sua tela ou câmera parou de enviar ao servidor (o navegador não consegue mais ler a fonte). Clique abaixo para readquirir as fontes e retomar — abrirá o seletor de compartilhamento de tela. Não é preciso recarregar a página.",
    "watchdog.restartNow": "Recompartilhar e retomar",
    "watchdog.dismiss": "Dispensar",
    "capture.externalCamera": "Câmera externa",
    "capture.addExternalCamera": "Adicionar câmera externa",
    "capture.extCamDown": "A câmera externa está desconectada. Reconecte-a para continuar sendo monitorado.",
    "capture.extCamRequiredDown": "Esta prova EXIGE uma câmera externa (celular) e ela não está conectada. Conecte agora.",
    "capture.extCamReconnect": "Reconectar câmera",
    "capture.externalHint": "Use seu celular como câmera extra escaneando um QR code.",
    "capture.externalNeedRecording": "Inicie a gravação para adicionar uma câmera externa.",
    "capture.externalChoose": "Como a câmera do celular será usada?",
    "capture.externalPrimary": "Câmera principal",
    "capture.externalSecondary": "Câmera secundária",
    "capture.externalScan": "Escaneie este QR code com o celular e permita o acesso à câmera.",
    "capture.externalWaiting": "Aguardando o celular conectar…",
    "capture.externalConnected": "Câmera externa conectada",
    "capture.close": "Fechar",
    "pair.title": "Câmera externa",
    "pair.live": "Ao vivo",
    "pair.connecting": "Conectando…",
    "pair.streaming": "Sua câmera está transmitindo para a sessão.",
    "pair.switch": "Trocar câmera",
    "pair.keepOpen": "Mantenha esta página aberta durante a prova.",
    "pair.denied": "Permissão de câmera negada. Permita e tente novamente.",
    "pair.retry": "Tentar novamente",
    "pair.expired": "Este link é inválido ou expirou. Peça um novo QR code.",
    "pair.error": "Não foi possível conectar. Tente novamente.",
    "pair.unsupported": "O navegador deste celular não pode ser usado como câmera. iPhones não são suportados (todos os navegadores no iOS, inclusive o Chrome, não têm a captura necessária). Use um celular Android com o Google Chrome e leia o QR code novamente.",
    "pair.ended": "Sessão encerrada — você pode fechar esta página.",
    "error.captureLoad": "Não foi possível carregar esta prova/evento.",
    "error.mediaDenied": "Permissão negada ou dispositivo indisponível.",
    "capture.unsupportedTitle": "Navegador não compatível",
    "capture.unsupportedBody": "Este navegador não suporta o mecanismo de vídeo necessário para a captura. Use o Google Chrome ou o Microsoft Edge mais recente para realizar esta prova.",
    // --- added: SecFace liveness/admin screens ---
    "biometric.title": "API Biométrica — pessoas e fotos",
    "biometric.introAuth": "Autentique com o header",
    "biometric.introAt": "em",
    "biometric.introScopePre": "Requer o escopo",
    "biometric.scopeName": "API biométrica",
    "biometric.introScopePost": "no token; allowlist de IP e rate limit são aplicados, e toda chamada é registrada na trilha de auditoria.",
    "biometric.addSummary": "Cadastrar/atualizar uma pessoa",
    "biometric.addDesc": "Upsert: procura por documento (document_type + document) e depois por interseção de e-mails; se não achar, cria. Campos são mesclados (e-mails viram união; campos vazios nunca apagam valores). Exige ao menos um e-mail ou um documento.",
    "biometric.pEmails": "Lista de e-mails da pessoa (aceita também \"email\" único).",
    "biometric.pDocumentType": "Tipo do documento (ex.: cpf, rg, passport). Obrigatório quando document é enviado.",
    "biometric.pDocument": "Número do documento.",
    "biometric.pMobilePhone": "Telefone celular.",
    "biometric.rCreated": "Pessoa criada.",
    "biometric.rUpdated": "Pessoa já existia — dados mesclados/atualizados.",
    "biometric.rBadRequest": "Sem e-mail e sem documento, ou document sem document_type.",
    "biometric.rForbidden": "Token sem o escopo biométrico, ou IP fora da allowlist.",
    "biometric.rRateLimited": "Limite de requisições por minuto atingido.",
    "biometric.photoSummary": "Adicionar foto de referência",
    "biometric.photoDesc": "Envie a foto em \"photo\" (arquivo multipart ou base64/data-URI no JSON). A imagem geralmente vem de um documento (RG, CNH…): o rosto é detectado e SOMENTE o recorte da área da foto (3:4, com margens de cabelo/ombros) é armazenado — nunca o documento completo. Foto que a pessoa já possui (idêntica ou quase idêntica) retorna 204 e nada é gravado.",
    "biometric.pPersonId": "O id da pessoa (retornado por /people/add).",
    "biometric.pPhoto": "Arquivo (multipart/form-data) ou string base64/data-URI (JSON).",
    "biometric.rPhotoStored": "Foto recortada e armazenada.",
    "biometric.rPhotoDuplicate": "A pessoa já possui esta foto (duplicada) — nada gravado.",
    "biometric.rNoFace": "Nenhum rosto encontrado na imagem (reason: no_face).",
    "biometric.rInvalidImage": "Imagem inválida/corrompida ou campo photo ausente.",
    "biometric.rPersonNotFound": "Pessoa não encontrada (ou de outra empresa).",
    "apiTokenForm.biometricScope": "API biométrica (/biometric/*)",
    "apiTokenForm.biometricScopeAria": "API biométrica",
    "account.resetMfa": "Redefinir MFA",
    "common.country.placeholder": "BR, US, ES, IT...",
    "clientApps.title": "Aplicativos cliente",
    "clientApps.subtitle": "Sistemas que integram a verificação de liveness via API (client_id / client_secret).",
    "clientApps.new": "Novo cliente",
    "clientApps.empty": "Nenhum cliente cadastrado.",
    "clientApps.clientId": "Client ID",
    "clientApps.active": "Ativo",
    "clientApps.inactive": "Inativo",
    "clientApps.deleteTitle": "Remover cliente",
    "clientApps.deleteBodyPrefix": "Deseja remover",
    "clientApps.deleteBodySuffix": "? As chamadas com estas credenciais deixarão de funcionar.",
    "clientAppForm.credentialsTitle": "Credenciais do cliente",
    "clientAppForm.secretWarnPrefix": "Guarde o",
    "clientAppForm.secretWarnSuffix": "agora — ele é exibido apenas uma vez e não pode ser recuperado.",
    "clientAppForm.clientSecret": "Client Secret",
    "clientAppForm.done": "Concluído",
    "clientAppForm.loadError": "Não foi possível carregar o cliente.",
    "clientAppForm.saveError": "Falha ao salvar.",
    "clientAppForm.rotateError": "Falha ao rotacionar o segredo.",
    "clientAppForm.editTitle": "Editar cliente",
    "clientAppForm.newTitle": "Novo cliente",
    "clientAppForm.rotateSecret": "Rotacionar segredo",
    "clientAppForm.webhookUrl": "URL do webhook",
    "clientAppForm.webhookUrlHelpPrefix": "Recebe o evento",
    "clientAppForm.webhookUrlHelpSuffix": "(assinado). Vazio desativa o push (use polling).",
    "clientAppForm.webhookSecret": "Webhook Secret (HMAC)",
    "clientAppForm.webhookSecretPlaceholder": "mínimo 16 caracteres",
    "clientAppForm.webhookSecretHelpPrefix": "Chave usada para assinar o webhook:",
    "clientAppForm.webhookSecretHelpCode": "X-SecFace-Signature: sha256=<HMAC-SHA256 do corpo>",
    "clientAppForm.webhookSecretHelpSuffix": "Configure este mesmo valor no sistema cliente para validar a assinatura. Vazio mantém o atual.",
    "clientAppForm.redirectUris": "Redirect URIs permitidas",
    "clientAppForm.redirectUrisPlaceholder": "https://app.exemplo.com/callback https://…",
    "clientAppForm.redirectUrisHelp": "Uma por linha. O redirect_uri do /start deve começar com uma delas.",
    "clientAppForm.emailReports": "Enviar reports por e-mail ao cliente",
    "clientAppForm.emailReportsHelp": "Quando ativo, a cada sessão de liveness aprovada o PDF assinado é enviado aos destinatários abaixo e à pessoa validada.",
    "clientAppForm.reportEmails": "E-mails destinatários",
    "clientAppForm.reportEmailsPlaceholder": "um por linha ou separados por vírgula",
    "clientAppForm.reportEmailsHelp": "Destinatários que receberão o report de cada verificação aprovada.",
    "clientAppForm.policyNotePrefix": "Política padrão da empresa. Deixe em",
    "clientAppForm.policyNoteInherit": "Herdar",
    "clientAppForm.policyNoteMiddle": "/ vazio para usar o padrão global. O cliente pode sobrescrever por sessão no",
    "clientAppForm.aiThreshold": "Limiar de IA (%)",
    "clientAppForm.inheritGlobal": "Herdar global",
    "clientAppForm.requireGeo": "Exigir geolocalização",
    "clientAppForm.requireGesture": "Exigir gesto",
    "clientAppForm.yes": "Sim",
    "clientAppForm.no": "Não",
    "globalConfig.loadError": "Não foi possível carregar a configuração global.",
    "globalConfig.saveError": "Falha ao salvar.",
    "globalConfig.title": "Configuração global",
    "globalConfig.subtitle": "Padrões globais da política de liveness (nível mais baixo de precedência).",
    "globalConfig.precedence": "cliente > empresa (ClientApp) > global",
    "globalConfig.aiThreshold": "Limiar de IA (%)",
    "globalConfig.aiThresholdHelp": "Corte de identificação/vivacidade quando nem o cliente nem o ClientApp definem.",
    "globalConfig.sessionTtl": "TTL da sessão (segundos)",
    "globalConfig.sessionTtlHelp": "Validade de uma sessão após o /start.",
    "globalConfig.requireGeo": "Exigir geolocalização por padrão",
    "globalConfig.requireGeoAria": "Exigir geolocalização",
    "globalConfig.requireGesture": "Exigir desafio de gesto por padrão",
    "globalConfig.requireGestureAria": "Exigir gesto",
    "liveness.title": "Verificação de identidade",
    "liveness.intro": "Este exame exige uma verificação de identidade (liveness) antes de você compartilhar a tela. Conclua os dois passos abaixo para continuar.",
    "liveness.stepLocation": "Localização",
    "liveness.geoRequiredHint": "Obrigatória para continuar.",
    "liveness.geoOptionalHint": "Será solicitada; você pode recusar.",
    "liveness.geoNotProvided": "Localização não informada",
    "liveness.geoEnabled": "Localização habilitada",
    "liveness.requesting": "Solicitando…",
    "liveness.enableGeo": "Habilitar geolocalização",
    "liveness.declineGeo": "Não informar localização",
    "liveness.faceCapture": "Captura facial",
    "liveness.captureHint": "Aproxime o rosto do círculo, olhe para a câmera e mantenha os olhos abertos. Todo o processo é gravado.",
    "liveness.startCapture": "Iniciar captura facial",
    "liveness.unsupportedTitle": "Navegador não suportado",
    "liveness.unsupportedBody": "Este navegador não suporta a captura de vídeo necessária (WebCodecs). Copie o link abaixo e abra em outro navegador atualizado (Chrome ou Edge, no computador ou Android).",
    "common.copied": "Copiado",
    "liveness.declineTitle": "Não informar localização?",
    "liveness.declineBody": "Você tem certeza que não deseja informar sua localização? A recusa fica registrada na sua verificação.",
    "liveness.cancel": "Cancelar",
    "liveness.confirmDecline": "Sim, não informar",
    "liveness.geoRequired": "É necessário permitir sua localização exata para continuar. Conceda a permissão e tente novamente.",
    "liveness.geoValidateFailed": "Não foi possível validar a localização.",
    "liveness.geoNoContinue": "Não foi possível continuar sem a localização.",
    "liveness.cannotContinue": "Não foi possível continuar.",
    "liveness.startingCamera": "Iniciando a câmera…",
    "liveness.cameraDenied": "Permita o acesso à câmera para continuar.",
    "liveness.cameraFailed": "Não foi possível iniciar a câmera.",
    "liveness.tooManyInterruptions": "Muitas interrupções na conexão. Verifique sua internet e tente novamente.",
    "liveness.connectionInterrupted": "Conexão interrompida — reiniciando a verificação…",
    "liveness.hdrGesture": "Desafio de gesto",
    "liveness.hdrMotion": "Aproximação",
    "liveness.hdrFlash": "Verificação de luz",
    "liveness.altCapture": "captura",
    "liveness.retry": "Tentar novamente",
    "liveness.checking": "Validando…",
    "liveness.verifying": "Verificando…",
    "liveness.completeFailed": "Falha ao concluir a verificação.",
    "liveness.gestureHold": "Perfeito! Mantenha o gesto…",
    "liveness.gesturePrompt": "Faça o gesto pedido",
    "liveness.lookAtScreen": "Olhe para a tela",
    "liveness.fitFaceInCircle": "Encaixe o rosto no círculo",
    "liveness.fitFaceInSmallerCircle": "Agora encaixe o rosto no círculo menor",
    "liveness.holdStill": "Segure o rosto parado… {n}s",
    "liveness.guidance.no_face": "Posicione seu rosto dentro do círculo",
    "liveness.guidance.multiple_faces": "Apenas você deve aparecer na câmera",
    "liveness.guidance.too_far": "Aproxime o rosto da câmera",
    "liveness.guidance.fill_oval": "Aproxime o rosto para preencher o círculo",
    "liveness.guidance.too_close": "Afaste um pouco o rosto",
    "liveness.guidance.not_frontal": "Olhe diretamente para a câmera",
    "liveness.guidance.off_center": "Centralize seu rosto no círculo",
    "liveness.guidance.blurry": "Melhore a iluminação e fique parado — a imagem está pouco nítida",
    "liveness.guidance.low_confidence": "Rosto não detectado com clareza",
    "liveness.guidance.ok": "Perfeito! Mantendo o rosto…",
    "liveness.guidance.detector_unavailable": "Verificando…",
    "liveness.guidance.decode_failed": "Ajustando a câmera…",
    "liveness.guidance.flash_fill_oval": "Aproxime-se e encaixe o rosto no círculo maior",
    "liveness.guidance.flash_hold_fit": "Encaixou! Aguarde parado…",
    "liveness.guidance.flash_hold": "Mantenha o rosto no círculo até os flashes pararem",
    "gesture.instr.v_over_eye": "Faça o \"V\" (dedos indicador e médio) e leve a mão à frente do rosto, com os dedos sobre um dos olhos.",
    "gesture.instr.open_palm": "Levante uma das mãos abertas ao lado do rosto, com os dedos bem afastados (espalmada).",
    "gesture.instr.thumbs_up": "Faça o gesto de \"joia\" (polegar para cima) próximo ao rosto.",
    "gesture.instr.hand_on_cheek": "Apoie a palma de uma das mãos sobre uma das bochechas.",
    "people.title": "Pessoas",
    "people.matchCount": "{n} correspondência(s) por similaridade",
    "people.peopleCount": "{n} pessoa(s)",
    "people.searchPlaceholder": "Nome, documento, e-mail…",
    "people.searchByPhoto": "Buscar por foto",
    "people.errNoFace": "Nenhum rosto utilizável na foto enviada.",
    "people.errSearchFailed": "Falha na busca por foto.",
    "people.sortedBySimilarity": "Resultados ordenados por similaridade facial.",
    "people.facesMatchCount": "{f} rosto(s) detectado(s) · {n} correspondência(s)",
    "people.extractedFaces": "Rostos extraídos da imagem",
    "people.faceHint": "Rosto {i} — {n} correspondência(s)",
    "people.nMatches": "{n} match",
    "people.faceNoMatch": "Nenhuma correspondência para o rosto selecionado.",
    "people.identity": "Identidade",
    "people.createdAt": "Cadastrado em",
    "people.noPhotos": "Sem fotos de referência.",
    "people.linkedSessions": "Verificações vinculadas",
    "people.noSessions": "Nenhuma verificação vinculada.",
    "common.email": "E-mail",
    "people.clear": "limpar",
    "people.empty": "Nenhuma pessoa encontrada.",
    "people.colSimilarity": "Similaridade",
    "people.colPerson": "Pessoa",
    "people.colDocument": "Documento",
    "people.colPhotos": "Fotos",
    "people.colValidations": "Validações",
    "status.passed": "Aprovado",
    "status.failed": "Negado",
    "status.pending": "Pendente",
    "status.expired": "Expirado",
    "sessions.title": "Verificações",
    "sessions.refresh": "Atualizar",
    "sessions.loadedCount": "{n} carregado(s)",
    "sessions.filterAll": "Todos",
    "sessions.searchPlaceholder": "Nome, e-mail, sessão…",
    "sessions.empty": "Nenhuma verificação encontrada.",
    "sessions.colDate": "Data",
    "sessions.colParticipant": "Participante",
    "sessions.colSession": "Sessão",
    "sessions.colStatus": "Status",
    "sessions.colApproved": "Aprovado",
    "sessions.yes": "Sim",
    "sessions.no": "Não",
    "sessions.deepFlaggedTip": "Deep PAD sinalizou esta sessão",
    "sessionDetail.title": "Liveness",
    "sessionDetail.notFound": "Verificação não encontrada.",
    "sessionDetail.loadFailed": "Falha ao carregar a verificação.",
    "sessionDetail.padLabel": "PAD",
    "sessionDetail.padOk": "OK",
    "sessionDetail.padFlagged": "SINALIZADO",
    "sessionDetail.padError": "erro",
    "sessionDetail.padAnalyzing": "em análise",
    "sessionDetail.photoFace": "Rosto",
    "sessionDetail.photoFull": "Quadro completo",
    "sessionDetail.photoGesture": "Gesto",
    "sessionDetail.completedAt": "Concluído em",
    "sessionDetail.geolocation": "Geolocalização",
    "sessionDetail.geoNotProvided": "não informada",
    "sessionDetail.location": "Localização",
    "sessionDetail.viaGeo": "via geolocalização",
    "sessionDetail.viaIp": "via IP",
    "sessionDetail.localDetection": "Detecção local",
    "sessionDetail.detShort": "det",
    "sessionDetail.frontality": "frontalidade",
    "sessionDetail.depth": "Profundidade",
    "sessionDetail.flashmark": "Flashmark",
    "sessionDetail.aiLiveness": "IA Vivacidade",
    "sessionDetail.aiProbability": "Vivacidade (IA)",
    "sessionDetail.aiVerdict": "Parecer da IA",
    "sessionDetail.padAnalysis": "Análise PAD",
    "sessionDetail.aiGesture": "IA Gesto",
    "sessionDetail.gestureChallenge": "Desafio de gesto",
    "sessionDetail.aiProbabilityGesture": "Gesto correto (IA)",
    "sessionDetail.samePerson": "mesma pessoa",
    "sessionDetail.aiVerdictGesture": "Parecer da IA gesto",
    "sessionDetail.padAnalysisGesture": "Análise PAD gesto",
    "sessionDetail.session": "Sessão",
    "sessionDetail.client": "Empresa",
    "sessionDetail.created": "Criada",
    "sessionDetail.attempts": "Tentativas",
    "sessionDetail.language": "Idioma",
    "reason.REAL_3D": "3D — paralaxe de face viva",
    "reason.FLAT_SPOOF": "superfície plana — possível spoof",
    "reason.LIVE": "face refletiu o padrão de luz",
    "reason.SPOOF": "face não refletiu o flash",
    "reason.inconclusive": "inconclusivo",
    "reason.geo_required": "geolocalização obrigatória",
    "reason.local:no_face": "nenhum rosto detectado",
    "reason.local:multiple_faces": "múltiplos rostos detectados",
    "reason.local:not_frontal": "rosto não frontal",
    "reason.local:too_close": "rosto muito próximo",
    "reason.local:fill_oval": "rosto pequeno demais no oval",
    "reason.local:off_center": "rosto descentralizado",
    "reason.local:blurry": "imagem borrada",
    "reason.local:low_confidence": "baixa confiança de detecção",
    "reason.local:decode_failed": "falha ao decodificar imagem",
    "reason.local:detector_unavailable": "detector indisponível",
    "reason.local:ok": "ok",
    // --- added: SecFace liveness/admin screens ---
    "report.download": "Baixar relatório PDF assinado",
    // --- added: SecFace liveness/admin screens ---
    "video.watch": "Ver vídeo",
    "video.download": "Baixar vídeo",
    "video.hide": "Ocultar vídeo",
    "video.title": "Sessão de liveness gravada",
    "video.unavailable": "Gravação indisponível para esta sessão.",
    // --- added: SecFace liveness/admin screens ---
    "sessions.colReport": "Relatório",
    // --- added: SecFace liveness/admin screens ---
    "sessions.colSigned": "Assinado",
    // --- added: SecFace liveness/admin screens ---
    "sessions.filterStatus": "Status",
    // --- added: SecFace liveness/admin screens ---
    "sessions.signedWaiting": "Aguardando PAD",
    "sessions.signedError": "Erro",
    "sessions.copyId": "Copiar ID da sessão",
  },
  es: {
    "oidc.signingIn": "Accediendo a {app}…",
    "pub.login.continue": "Continuar",
    "pub.login.change": "cambiar",
    "pub.login.badCode": "Código inválido.",
    "pub.login.expired": "La sesión de inicio expiró. Empieza de nuevo.",
    "pub.signOut": "Salir",
    "pub.verified": "Verificado",
    "pub.unverified": "No verificado",
    "pub.email": "E-mail",
    "pub.phone": "Móvil",
    "pub.biometric": "Mi biometría",
    "pub.enrolled": "Registrada",
    "pub.home.title": "Mis datos",
    "pub.home.subtitle": "Los datos que probamos que te pertenecen.",
    "pub.login.title": "Entrar",
    "pub.login.subtitle": "Accede a tus datos y tu biometría.",
    "pub.login.face": "Entrar con mi rostro",
    "pub.login.faceWaiting": "Aguardando a captura…",
    "pub.login.or": "ou",
    "pub.login.email": "E-mail",
    "pub.login.password": "Contraseña",
    "pub.login.mfa": "Código del autenticador",
    "pub.login.submit": "Entrar",
    "pub.login.register": "Crear mi cuenta",
    "pub.login.invalid": "Correo, contraseña o código inválidos.",
    "pub.login.faceUnavailable": "Login facial indisponível no momento.",
    "pub.login.faceFailed": "Não foi possível identificar você. Tente novamente.",
    "pub.login.notPortal": "Este rosto não pertence a uma conta do portal.",
    "pub.reg.title": "Crear mi cuenta",
    "pub.reg.subtitle": "Confirmamos seu e-mail e seu celular, você define a senha e o MFA, e por fim cadastra seu rosto.",
    "pub.reg.back": "Voltar ao login",
    "pub.reg.stepData": "Dados",
    "pub.reg.stepCodes": "Verificação",
    "pub.reg.stepPassword": "Senha",
    "pub.reg.stepMfa": "MFA",
    "pub.reg.firstName": "Nombre",
    "pub.reg.lastName": "Apellido",
    "pub.reg.email": "E-mail",
    "pub.reg.phone": "Móvil (WhatsApp)",
    "pub.reg.sendCodes": "Enviar códigos",
    "pub.reg.codesHelp": "Enviamos um código diferente para cada canal. Confirme os dois.",
    "pub.reg.codeSent": "Código enviado para {to}",
    "pub.reg.codeNotSent": "Não foi possível enviar para {to}",
    "pub.reg.confirm": "Confirmar",
    "pub.reg.password": "Contraseña",
    "pub.reg.password2": "Repite la contraseña",
    "pub.reg.setPassword": "Definir contraseña",
    "pub.reg.mfaHelp": "Escaneie o QR no seu app autenticador e digite o código gerado.",
    "pub.reg.finish": "Finalizar y registrar mi rostro",
    "pub.reg.emailTaken": "Este e-mail já tem conta.",
    "pub.reg.badPhone": "Telefone inválido.",
    "pub.reg.rate": "Muitas tentativas. Aguarde alguns minutos.",
    "pub.reg.startFailed": "Não foi possível iniciar o cadastro.",
    "pub.reg.codeWrong": "Código incorreto.",
    "pub.reg.codeExpired": "Código expirado.",
    "pub.reg.codeFailed": "Não foi possível confirmar.",
    "pub.reg.mismatch": "As senhas não conferem.",
    "pub.reg.passwordFailed": "Senha recusada pela política.",
    "pub.reg.mfaWrong": "Código do autenticador inválido.",
    "pub.enroll.title": "Registra tu rostro",
    "pub.enroll.body": "Sua conta só fica ativa depois do cadastro facial. Abra a captura, siga as instruções na tela e volte aqui.",
    "pub.enroll.cta": "Abrir la captura",
    "pub.enroll.again": "Abrir a captura novamente",
    "pub.enroll.waiting": "Aguardando a conclusão da captura…",
    "pub.enroll.failed": "Não foi possível iniciar a captura.",
    "bio.via.admin": "Verificada por el admin",
    "bio.via.document": "Verificada por documento",
    "bio.via.code": "Verificada por código",
    "bio.via.legacy": "Verificada (heredada — anterior a la regla)",
    "bio.identVerified": "Verificada",
    "bio.identUnverified": "No verificada — no se expone a los consumidores",
    "profile.title": "Mis datos",
    "profile.subtitle": "Confirma que tu correo y teléfono son tuyos. Cada cambio exige un código enviado al propio contacto.",
    "profile.email": "Correo",
    "profile.phone": "Teléfono (WhatsApp)",
    "profile.verified": "Verificado",
    "profile.unverified": "No verificado",
    "profile.verify": "Verificar",
    "profile.change": "Cambiar",
    "profile.sendCode": "Enviar código",
    "profile.confirm": "Confirmar",
    "profile.resend": "Reenviar",
    "profile.codeSent": "Código enviado a {to}. Expira en {ttl} minutos.",
    "profile.emailHelp": "Enviaremos un código a este correo. Solo tendrá efecto después de que confirmes.",
    "profile.phoneHelp": "Enviaremos un código por WhatsApp. Solo tendrá efecto después de que confirmes.",
    "profile.codeWrong": "Código incorrecto.",
    "profile.codeExpired": "Código expirado — envía otro.",
    "profile.codeBlocked": "Demasiados intentos. Envía un código nuevo.",
    "profile.sendFailed": "No se pudo enviar el código.",
    "profile.verifyFailed": "No se pudo confirmar.",
    "profile.notSent": "No se pudo entregar el código por este canal.",
    "search.title": "Búsqueda",
    "search.placeholder": "Buscar en todo el sistema…",
    "search.hint": "Nombre, correo, CPF, teléfono, empresa, app o id de sesión. Esc para cerrar.",
    "search.enter": "Enter",
    "search.found": "{n} resultado(s) para «{q}»",
    "search.empty": "Nada encontrado. Los valores sensibles (correo, CPF, teléfono) están cifrados y solo coinciden por su valor exacto.",
    "search.type.biometric": "Biometrías",
    "search.type.account": "Cuentas",
    "search.type.session": "Verificaciones",
    "search.type.company": "Empresas",
    "search.type.client_app": "Client apps",
    "search.type.person": "Personas",
    "search.type.alert": "Alertas",
    "globalConfig.docPhotoMatch": "Foto impresa × foto firmada",
    "globalConfig.docPhotoMatchHelp": "La foto del QR está firmada (a prueba de manipulación) pero es diminuta (~45x61), lo que degrada el reconocimiento. El PDF también trae una copia en alta resolución, pero sin firma. Este es el mínimo de correlación de píxeles entre ambas para aceptar la foto impresa y usarla en el match facial. Mayor = más estricto (una foto cambiada nunca pasa); menor = tolera variaciones de impresión/compresión.",
    "bio.docPhotoSrc": "Foto utilizada",
    "bio.docPhotoVisible": "impresa en alta resolución (validada contra la firmada)",
    "bio.docPhotoQr": "del QR (firmada)",
    "globalConfig.change": "Cambiar",
    "globalConfig.modelTitle": "Cambiar el modelo de reconocimiento",
    "globalConfig.modelWarn": "Este cambio invalida TODAS las biometrías registradas.",
    "globalConfig.modelWarnBody": "El modelo genera la firma facial: cambiarlo cambia el espacio vectorial, así que ninguna plantilla existente podrá compararse. Todos deberán registrarse de nuevo, el prefiltro (ANN) tendrá que reentrenarse y las autenticaciones fallarán hasta entonces.",
    "globalConfig.modelCurrent": "Modelo actual",
    "globalConfig.modelNew": "Nuevo modelo",
    "globalConfig.modelEnrollments": "Registros invalidados",
    "globalConfig.modelPeople": "Personas afectadas",
    "globalConfig.modelGold": "Biometrías Oro",
    "globalConfig.modelType": "Para confirmar, escribe",
    "globalConfig.modelApply": "Cambiar modelo",
    "globalConfig.modelFailed": "No se pudo cambiar el modelo.",
    "bio.removeIdentity": "Eliminar identidad",
    "bio.removeIdentityBody": "¿Eliminar {id} de esta biometría? La persona dejará de ser encontrada por esta identidad.",
    "bio.docSigner": "Firmado por",
    "bio.docCert": "Certificado",
    "bio.docThumb": "Thumbprint",
    "bio.docPubKey": "Clave pública",
    "bio.downloadDoc": "Descargar documento",
    "bio.reactivate": "Restaurar registro anterior",
    "bio.newEnrollLink": "Generar enlace de registro",
    "bio.enrollLinkHelp": "Abre este enlace (o escanea el QR) en el móvil para rehacer el registro biométrico.",
    "bio.inactive": "inactivo",
    "bio.reviewTitle": "Documento en espera de revisión",
    "bio.reviewBody": "La similitud entre la foto del documento y el rostro registrado quedó en la banda de revisión.",
    "bio.approve": "Aprobar",
    "bio.reject": "Rechazar",
    "globalConfig.docBandsHelp": "Bandas de decisión de la similitud entre la FOTO del documento y la biometría registrada: por debajo del 1er umbral se rechaza; entre ambos pasa a revisión manual de un admin; por encima del 2º concede el nivel Oro automáticamente.",
    "globalConfig.bandDeny": "Rechazar",
    "globalConfig.bandReview": "Revisar",
    "globalConfig.bandAllow": "Permitir",
    "doc.reason.reviewPending": "Enviado a revisión de un admin — la coincidencia facial no fue concluyente.",
    "alerts.document_review": "Documento en espera de revisión manual",
    "bio.typeToConfirm": "Para confirmar, escribe",
    "bio.deenrollTitle": "Eliminar registro biométrico",
    "bio.deenrollBody": "Elimina la plantilla facial de esta persona — deja de autenticar hasta registrarse de nuevo.",
    "bio.addIdentity": "Añadir identidad",
    "bio.addIdentityHelp": "Vincula un correo, CPF, teléfono o id externo a esta biometría. Cada identidad es única en todo el sistema.",
    "sessions.bioMatch": "Coincidencia biométrica",
    "sessions.bioIdentified": "Identificado",
    "alerts.duplicate_identity": "Misma identidad en dos biometrías",
    "doc.upload": "Subir un documento...",
    "bio.docPhoto": "Foto del documento",
    "bio.noDocPhoto": "Sin foto",
    "bio.docName": "Nombre completo",
    "bio.docCpf": "CPF",
    "bio.docBirth": "Fecha de nacimiento",
    "bio.revealData": "Ver datos completos",
    "bio.hideData": "Ocultar datos",
    "bio.docAttempts": "Intentos de lectura de documento",
    "bio.date": "Fecha",
    "bio.docFile": "Archivo",
    "bio.docResult": "Resultado",
    "bio.docSim": "Similitud",
    "bio.docBy": "Por",
    "globalConfig.docFace": "Documento × rostro (Oro)",
    "globalConfig.docFaceHelp": "Similitud mínima entre la FOTO del documento y la biometría registrada para conceder el nivel Oro. Mayor = más estricto (evita el documento de otra persona), pero puede rechazar fotos de documento antiguas/de baja calidad.",
    "doc.reason.faceMismatch": "La foto del documento no coincide con el rostro registrado.",
    "doc.reason.photoUnavailable": "No se pudo leer la foto del documento.",
    "doc.reason.docNoFace": "Ningún rostro utilizable en la foto del documento.",
    "doc.reason.noEnrollment": "Registra el rostro antes de verificar un documento.",
    "clientAppForm.genConfig": "Generar config de ejemplo (.env)",
    "clientAppForm.genConfigTitle": "Configuración de ejemplo (RP)",
    "clientAppForm.genConfigHint": "Completa SEC_FACE_OIDC_CLIENT_SECRET con el secreto de la app (mostrado al crear/rotar).",
    "clientAppForm.cfgError": "No se pudo generar la configuración.",
    "clientAppForm.copy": "Copiar",
    "clientAppForm.copied": "¡Copiado!",
    "common.close": "Cerrar",
    "clientAppForm.minTier": "Nivel mínimo (biometría)",
    "clientAppForm.minTierHelp": "Nivel de confianza mínimo requerido para autenticar por biometría en esta app.",
    "oidc.tierTitle": "Nivel de verificación insuficiente",
    "oidc.tierBody": "Esta app requiere el nivel {req}, pero tu biometría está en {cur}.",
    "oidc.tierHow": "Cómo subir de nivel",
    "oidc.tierSilver": "Plata: pide a un administrador que confirme tu biometría.",
    "oidc.tierGold": "Oro: sube un documento nacional válido (licencia) en tu cuenta para verificación.",
    "bio.tier": "Nivel de confianza",
    "bio.tierHelp": "Bronce: inicial. Plata: confirmada por un humano. Oro: documento nacional válido verificado.",
    "bio.bronze": "Bronce",
    "bio.silver": "Plata",
    "bio.gold": "Oro",
    "bio.confirmSilver": "Confirmar (Plata)",
    "bio.revertBronze": "Volver a Bronce",
    "bio.goldDoc": "Documento",
    "bio.goldExpiry": "Validez",
    "doc.verifyGold": "Verificar documento (Oro)",
    "doc.hint": "Sube la licencia/documento digital (PDF o imagen del QR). Verificación offline; acepta documentos auténticos vencidos hace máximo 6 meses.",
    "doc.gold": "Documento verificado — nivel Oro concedido.",
    "doc.reason.notAuthentic": "El documento no es auténtico (falló la firma).",
    "doc.reason.sandbox": "Documento de prueba/sandbox — no aceptado.",
    "doc.reason.expired": "El documento venció hace más de 6 meses.",
    "doc.reason.noExpiry": "No se pudo leer la validez.",
    "doc.reason.parseFailed": "No se pudo leer el documento.",
    "doc.reason.unavailable": "La verificación de documentos no está disponible.",
    "doc.reason.empty": "Archivo vacío.",
    "nav.alerts": "Alertas",
    "globalConfig.dupAlert": "Alerta de biometría duplicada",
    "globalConfig.dupAlertHelp": "Por encima de este valor dos biometrías REGISTRADAS de personas distintas generan una alerta al Super Admin (posiblemente la misma persona en dos registros). Mayor = menos alertas (solo dobles casi idénticos).",
    "alerts.title": "Alertas de seguridad",
    "alerts.subtitle": "Intentos de fraude por cuenta y posibles biometrías duplicadas.",
    "alerts.tab.open": "Abiertos",
    "alerts.tab.dismissed": "Descartados",
    "alerts.tab.resolved": "Resueltos",
    "alerts.tab.all": "Todos",
    "alerts.empty": "Sin alertas.",
    "alerts.error": "Error",
    "alerts.account": "Cuenta",
    "alerts.kind.fraud": "Intento de fraude",
    "alerts.kind.duplicate": "Posible duplicado",
    "alerts.kind.blacklist": "Uso en lista negra",
    "alerts.blockTitle": "Bloquear cuenta",
    "alerts.blockBody": "La cuenta se desactivará y no podrá iniciar sesión. ¿Confirmar?",
    "alerts.block": "Bloquear cuenta",
    "alerts.notify": "Avisar al propietario",
    "alerts.mergeTitle": "Combinar biometrías",
    "alerts.mergeKeepA": "¿Mantener {a} y eliminar {b}?",
    "alerts.mergeKeep": "Mantener",
    "alerts.dismiss": "Descartar",
    "alerts.cancel": "Cancelar",
    "alerts.confirm": "Confirmar",
    "bio.governance": "Gobernanza",
    "bio.enabledLabel": "Biometría habilitada",
    "bio.enabledHelp": "Deshabilita para bloquear el uso en autenticación sin borrar el registro.",
    "bio.enabled": "Habilitada",
    "bio.disabled": "Deshabilitada",
    "bio.blacklist": "Lista negra",
    "bio.blacklistHelp": "Denegar todo uso, o solo alertar al Super Admin en cada uso.",
    "bio.blNone": "Normal",
    "bio.blDeny": "Denegar todo uso",
    "bio.blAlert": "Solo alertar",
    "bio.hardDeleteTitle": "Eliminar biometría",
    "bio.hardDeleteBody": "Elimina permanentemente esta biometría no utilizada (sin registro ni historial de uso). Irreversible.",
    "bio.hardDelete": "Eliminar (hard-delete)",
    "account.faceHelp2": "Genera un enlace para que esta persona registre su rostro, o vincula la cuenta a una biometría existente. Luego podrá iniciar sesión con su rostro.",
    "face.link.linkedTo": "Vinculado a",
    "face.link.enrolled": "registrado",
    "face.link.notEnrolled": "sin plantilla",
    "face.link.unlink": "Desvincular",
    "face.link.none": "Ninguna biometría vinculada a esta cuenta.",
    "face.link.pickCta": "Vincular a biometría existente",
    "face.link.pickTitle": "Vincular a biometría existente",
    "face.link.searchPh": "Buscar por nombre o identidad…",
    "face.link.noResults": "No se encontraron personas.",
    "face.link.failed": "La operación falló.",
    "account.faceTitle": "Biometría facial",
    "account.faceHelp": "Genera un enlace (con QR) para que esta persona registre su rostro. Luego podrá iniciar sesión con su rostro en la pantalla de acceso.",
    "face.enroll.generate": "Generar enlace de registro facial",
    "face.enroll.regenerate": "Actualizar registro facial",
    "login.mfaInvalid": "Código inválido. Inténtalo de nuevo.",
    "globalConfig.secOidc": "Acceso facial OIDC — confirmación por e-mail",
    "globalConfig.oidcNote": "En el acceso facial de apps externas (OIDC), cuando la coincidencia 1:N es AMBIGUA exigimos una confirmación por e-mail (código). Estos dos valores definen qué se considera 'ambiguo'.",
    "globalConfig.oidcConf": "Margen de confianza",
    "globalConfig.oidcConfHelp": "Cuánto debe superar la mejor coincidencia el umbral de autenticación para aceptarse SIN confirmación por e-mail. Mayor = pide e-mail con más frecuencia (más seguro, menos cómodo).",
    "globalConfig.oidcSep": "Separación 1º–2º",
    "globalConfig.oidcSepHelp": "Distancia mínima entre los dos rostros más parecidos. Si dos candidatos están demasiado cerca, es ambiguo → se pide e-mail. Mayor = más estricto contra dobles.",
    "oidc.scope.openid": "Identidad (identificador único)",
    "oidc.scope.profile": "Nombre del perfil",
    "oidc.scope.email": "Dirección de e-mail",
    "oidc.loadError": "No se pudo cargar la solicitud.",
    "oidc.invalidRequest": "Solicitud inválida.",
    "oidc.noEmail": "Sin e-mail registrado para la confirmación.",
    "oidc.otpSendFailed": "No se pudo enviar el código.",
    "oidc.otpInvalid": "Código inválido o expirado.",
    "oidc.unexpected": "Respuesta inesperada del servidor.",
    "oidc.confirmFirst": "Confirma tu identidad por e-mail primero.",
    "oidc.completeFailed": "No se pudo completar.",
    "oidc.failedTitle": "Autenticación no completada",
    "oidc.failedBody": "La verificación facial no fue aprobada. Puedes volver a la aplicación e intentarlo de nuevo.",
    "oidc.backToApp": "Volver a la aplicación",
    "oidc.title": "Autorizar acceso",
    "oidc.intro": "la aplicación",
    "oidc.client": "cliente",
    "oidc.introTail": "quiere acceder a tu identidad verificada por biometría.",
    "oidc.confirmTitle": "Confirmación de identidad",
    "oidc.confirmBody": "Por tu seguridad, necesitamos confirmar tu identidad por e-mail",
    "oidc.sending": "Enviando…",
    "oidc.sendCode": "Enviar código por e-mail",
    "oidc.confirm": "Confirmar",
    "oidc.confirmed": "Identidad confirmada por e-mail.",
    "oidc.willShare": "Se compartirán",
    "oidc.deny": "Rechazar",
    "oidc.authorize": "Autorizar",
    "oidc.alreadyConsented": "Ya autorizaste esta aplicación anteriormente.",
    "oidc.revokeNote": "Puedes revocar este acceso en cualquier momento.",
    "globalConfig.defaultIs": "predeterminado",
    "globalConfig.secLiveness": "Vivacidad (liveness)",
    "globalConfig.secMatch": "Reconocimiento facial (umbrales de coincidencia)",
    "globalConfig.secAnn": "Prefiltro de búsqueda 1:N (ANN)",
    "globalConfig.flashCut": "Gate de Flashmark",
    "globalConfig.flashCutHelp": "Correlación mínima (0–1) entre los destellos de color de la pantalla y el reflejo en el rostro para considerar VIVO. Por debajo la sesión se rechaza como spoof (foto/pantalla). Mayor = más estricto contra pantallas, pero más sensible en ambientes muy claros.",
    "globalConfig.cosineNote": "Valores de similitud de coseno (0 a 1). Mayor = más estricto (menos falsos positivos, pero más rechazos de personas legítimas). Deja en blanco para usar el valor predeterminado.",
    "globalConfig.authSim": "Acceso facial (1:1 y 1:N)",
    "globalConfig.authSimHelp": "Umbral para autenticar por biometría — tanto tu propio acceso facial (1:N entre usuarios del sistema) como la autenticación 1:1 de aplicaciones. Es el parámetro más sensible de seguridad: subirlo reduce el riesgo de aceptar a la persona equivocada (FAR); bajarlo facilita el acceso.",
    "globalConfig.kycSim": "KYC — selfie × documento",
    "globalConfig.kycSimHelp": "Umbral para considerar que la selfie en vivo es la misma persona de la foto del documento. Suele ser MENOR que el acceso, pues comparar una foto impresa/antigua con un rostro en vivo es más difícil (impresión, edad, iluminación).",
    "globalConfig.samePerson": "Gate 'misma persona' (captura)",
    "globalConfig.samePersonHelp": "Durante la captura, exige que el rostro recortado, el fotograma completo y la foto del gesto sean la MISMA persona. Por debajo la sesión se rechaza (cambio de rostro / personas distintas en el vídeo). Subirlo demasiado puede rechazar capturas legítimas con ángulos variados.",
    "globalConfig.matchSim": "Vinculación automática (registro de personas)",
    "globalConfig.matchSimHelp": "En el registro de Personas, umbral para vincular automáticamente una nueva captura a una persona existente de la misma empresa. Mayor = crea más personas separadas; menor = agrupa más (riesgo de unir personas distintas).",
    "globalConfig.dupSim": "Foto duplicada",
    "globalConfig.dupSimHelp": "Por encima de este valor dos fotos se tratan como la MISMA imagen (no solo la misma persona) y la duplicada no se almacena. Alto a propósito; bajarlo puede descartar fotos distintas válidas de la misma persona.",
    "globalConfig.recognizer": "Modelo de reconocimiento (ArcFace)",
    "globalConfig.recognizerDefault": "predeterminado (buffalo_l)",
    "globalConfig.recognizerL": "más preciso (autenticación)",
    "globalConfig.recognizerSc": "más ligero/rápido",
    "globalConfig.recognizerHelp": "Modelo que genera la firma facial. CAMBIARLO INVALIDA todos los registros existentes (cambia el espacio vectorial) — habrá que volver a registrar a todos y reentrenar el prefiltro. Cámbialo solo con un plan de migración.",
    "globalConfig.annNote": "Acelera la búsqueda 1:N filtrando la base por un índice grueso antes de comparar (y descifrar) registro por registro. No afecta la decisión de coincidencia, solo el rendimiento y la cobertura de la búsqueda.",
    "globalConfig.nprobe": "Centroides consultados (nprobe)",
    "globalConfig.nprobeHelp": "Cuántos 'cubos' del índice abre la búsqueda. Mayor = más candidatos comparados (mayor recall, pero más descifrados y más lento); menor = más rápido, con riesgo de saltar la coincidencia verdadera.",
    "globalConfig.annMin": "Mínimo de registros para entrenar",
    "globalConfig.annMinHelp": "Por debajo de esta cantidad el prefiltro NO se entrena y la búsqueda hace un escaneo completo (seguro para recall). Entrenar el índice solo tiene sentido cuando la base es lo bastante grande.",
    "globalConfig.retrainGrowth": "Crecimiento para reentrenar",
    "globalConfig.retrainGrowthHelp": "Fracción de crecimiento de la base (p. ej. 0.25 = +25%) desde el último entrenamiento para que se dispare el reentrenamiento automático (en el reaper). Mayor = reentrena con menos frecuencia.",
    "globalConfig.retrainDelta": "Nuevos registros para reentrenar",
    "globalConfig.retrainDeltaHelp": "Además del porcentaje, exige al menos esta cantidad de nuevos templates desde el último entrenamiento antes de reentrenar. Evita reentrenamientos costosos por cambios pequeños.",
    "login.face.button": "Entrar con tu rostro",
    "login.face.starting": "Iniciando…",
    "login.face.failed": "La verificación facial no fue aprobada.",
    "login.face.unavailable": "Inicio facial no disponible por ahora.",
    "face.enroll.title": "Biometría facial",
    "face.enroll.cta": "Registrar mi rostro",
    "face.enroll.manage": "Mi rostro",
    "face.enroll.hint": "Abre el enlace (o escanea el QR) para registrar tu rostro. Luego podrás iniciar sesión con tu rostro en la pantalla de acceso.",
    "face.enroll.reHint": "Abre el enlace para actualizar el registro de tu rostro. Luego podrás iniciar sesión con tu rostro.",
    "face.enroll.generating": "Generando enlace…",
    "face.enroll.failed": "No se pudo generar el enlace de registro.",
    "face.enroll.open": "Abrir registro",
    "bio.prefilterOn": "Prefiltro",
    "bio.analyzed": "analizados",
    "bio.fewer": "menos comparaciones exactas",
    "bio.prefilterOff": "Escaneo completo",
    "bio.records": "registros",
    "bio.prefilterUntrained": "prefiltro aún no entrenado",
    "bio.notFound": "Persona no encontrada.",
    "bio.loadFailed": "Error al cargar.",
    "bio.back": "Volver a biometría",
    "bio.notEnrolled": "Sin registro",
    "bio.authCount": "Autenticaciones",
    "bio.readings": "Lecturas",
    "bio.lastAuth": "Última",
    "bio.authentications": "Autenticaciones recientes",
    "bio.noSessions": "Aún no hay sesiones.",
    "bio.session": "Sesión",
    "bio.date": "Fecha",
    "bio.mode": "Modo",
    "bio.result": "Resultado",
    "bio.score": "Score",
    "bio.match": "Coincidencia",
    "bio.noMatch": "Sin coincidencia",
    "bio.dangerZone": "Zona de riesgo",
    "bio.noActions": "No hay acciones disponibles.",
    "bio.searchByPhoto": "Buscar por foto",
    "bio.searching": "Buscando…",
    "bio.errNoFace": "Ningún rostro utilizable en la foto enviada.",
    "bio.errSearchFailed": "Error en la búsqueda por foto.",
    "bio.sortedBySimilarity": "Ordenado por similitud facial",
    "bio.matches": "coincidencia(s)",
    "bio.clear": "limpiar",
    "bio.similarity": "Similitud",
    "bio.noMatches": "No se encontraron personas similares.",
    // Mural en vivo (video wall del liveness)
    "nav.wall": "Mural",
    "wall.title": "Mural en vivo",
    "wall.screens": "Pantallas",
    "wall.cameras": "Cámaras",
    "wall.both": "Pantallas + Cámaras",
    "wall.emptyBoth": "No hay sesiones en vivo.",
    "nav.eventWall": "Mural del evento",
    "nav.health": "Salud",
    "nav.jobsQueue": "Cola de trabajos",
    "nav.reviewQueue": "Revisión",
    "nav.coldSync": "Sincronización",
    "nav.coldStorage": "Almacenamiento frío",
    "health.title": "Salud",
    "health.subtitle": "Salud de la captura en vivo por participante.",
    "health.problems": "{n} con problemas",
    "health.refresh": "Actualizar",
    "health.loading": "Cargando…",
    "health.empty": "No hay sesiones en vivo.",
    "health.audio": "Audio",
    "eventwall.title": "Mural del evento",
    "eventwall.event": "Evento",
    "eventwall.noEvents": "No hay eventos en vivo",
    "eventwall.presets": "Presets",
    "eventwall.presetTop": "Top 10 (posición)",
    "eventwall.presetCombo": "Top 8 (Pantalla + Cámara)",
    "eventwall.presetAll": "Todos",
    "eventwall.presetsHint": "Presets personalizados próximamente.",
    "eventwall.empty": "No hay participantes en vivo en este evento.",
    "eventwall.countries": "Países",
    "eventwall.participants": "Participantes",
    "eventwall.performance": "DESEMPEÑO",
    "eventwall.live": "(EN VIVO)",
    "eventwall.score": "Puntuación",
    "eventwall.solved": "Retos Resueltos",
    "eventwall.lastSubmit": "Último Envío",
    "eventwall.points": "PUNTOS",
    "eventwall.challenges": "RETOS",
    "eventwall.overallProgress": "PROGRESO GENERAL",
    "eventwall.officialTime": "HORA OFICIAL",
    "eventwall.category": "Categoría del último envío",
    "eventwall.ago": "atrás",
    "eventwall.pts": "pts",
    "eventwall.castObs": "Mostrar esto en la salida de OBS",
    "eventwall.castObsActive": "En vivo en OBS",
    "eventwall.castHint": "El botón de transmitir envía el preset (con la opción actual Pantallas/Cámaras) a la salida de OBS en tiempo real.",
    "recording.obsEnable": "Habilitar URL de OBS",
    "recording.obsHint": "Salida pública del Mural del evento para OBS Browser — sin inicio de sesión, restringida a la(s) IP(s) del cliente abajo.",
    "recording.obsIps": "IP(s) del cliente OBS",
    "recording.obsUrl": "URL de OBS Browser",
    "recording.obsUrlHint": "Pega en una fuente 'Navegador' de OBS. Añade ?kind=camera o ?preset=all para cambiar la vista.",
    "wall.screen": "Pantalla",
    "wall.camera": "Cámara",
    "wall.live": "En vivo",
    "wall.offline": "Sin conexión",
    "wall.listen": "Escuchar",
    "wall.mute": "Silenciar",
    "wall.expand": "Abrir en pantalla completa",
    "wall.refresh": "Actualizar",
    "wall.loading": "Cargando…",
    "wall.participant": "participante",
    "wall.liveCount": "{n} en vivo",
    "wall.emptyScreens": "No hay sesiones en vivo compartiendo pantalla.",
    "wall.emptyCameras": "No hay sesiones en vivo compartiendo cámara.",
    "wall.unsupported": "Este navegador no puede decodificar el mural en vivo. Usa Chrome o Edge.",
    "login.email": "Correo electrónico",
    "login.email.placeholder": "usted@ejemplo.com",
    "login.password": "Contraseña",
    "login.password.placeholder": "Ingrese su contraseña",
    "login.submit": "Ingresar",
    "login.continue": "Continuar",
    "login.back": "← Volver",
    "login.or": "o",
    "login.newPassword": "Nueva contraseña",
    "login.confirmPassword": "Confirmar contraseña",
    "login.saveAndEnter": "Guardar y entrar",
    "login.contestant.title": "Acceso del participante",
    "login.contestant.subtitle": "Ingrese con su correo y contraseña.",
    "login.contestant.help": "¿Problemas para acceder? Contacte al supervisor de su examen.",
    "sessionAuth.title": "Acceso al examen",
    "sessionAuth.subtitle": "Introduce el token de sesión recibido para iniciar tu examen.",
    "sessionAuth.token": "Token de sesión",
    "sessionAuth.token.placeholder": "Pega tu token de sesión",
    "sessionAuth.submit": "Entrar",
    "sessionAuth.invalid": "Token de sesión inválido o expirado.",
    "sessionAuth.help": "¿Problemas para acceder? Contacte al supervisor de su examen.",
    "login.setPassword.title": "Defina una nueva contraseña",
    "login.setPassword.subtitle": "Debe cambiar la contraseña en el primer acceso.",
    "login.system.title": "Acceder al sistema",
    "login.system.emailSubtitle": "Ingrese el correo registrado en el sistema.",
    "login.system.emailHelp": "Si no recuerda su correo registrado, contáctenos en",
    "login.system.passwordSubtitle": "Ingrese la contraseña de su cuenta para continuar.",
    "login.oidc": "Iniciar sesión con Office 365",
    "login.mfa.subtitle": "Ingrese el código de 6 dígitos enviado a su correo.",
    "login.mfa.submit": "Validar código",
    "login.mfa.notReceived": "¿No recibió el código?",
    "login.mfa.resend": "Reenviar",
    "login.change.title": "Cambiar contraseña",
    "login.change.subtitle": "Su contraseña debe cambiarse antes de continuar.",
    "login.change.newPlaceholder": "Ingrese la nueva contraseña",
    "login.change.confirmPlaceholder": "Confirme la nueva contraseña",
    "login.pw.min8": "Mínimo 8 caracteres",
    "login.pw.upper": "Letra mayúscula",
    "login.pw.lower": "Letra minúscula",
    "login.pw.special": "Carácter especial",
    "login.pw.match": "Las contraseñas coinciden",
    "error.invalidCredentials": "Credenciales inválidas.",
    "error.wrongPassword": "Contraseña incorrecta. Intente de nuevo.",
    "error.passwordsMismatch": "Las contraseñas no coinciden.",
    "error.changePassword": "No se pudo cambiar la contraseña.",
    "error.mfaIncomplete": "Ingrese el código completo de 6 dígitos.",
    "nav.dashboard": "Panel",
    "nav.console": "Consola",
    "nav.admin": "Admin",
    "nav.contestants": "Participantes",
    "nav.accounts": "Cuentas",
    "nav.clientApps": "Aplicaciones",
    "nav.verifications": "Verificaciones",
    "nav.people": "Personas",
    "nav.biometrics": "Biometría",
    "bio.title": "Identidades biométricas",
    "bio.subtitle": "Personas biométricas globales, identidades vinculadas, consentimiento por empresa, registro y LGPD.",
    "bio.search": "Buscar por nombre o identidad…",
    "bio.name": "Nombre",
    "bio.identities": "Identidades",
    "bio.enrolled": "Registrado",
    "bio.companies": "Empresas",
    "bio.status": "Estado",
    "bio.yes": "Sí",
    "bio.no": "No",
    "bio.purged": "Eliminado (LGPD)",
    "bio.empty": "Aún no hay personas biométricas.",
    "bio.add": "Añadir",
    "bio.identityValue": "valor",
    "bio.consentOn": "Consentimiento otorgado",
    "bio.consentOff": "Sin consentimiento",
    "bio.enrollments": "Registros",
    "bio.encrypted": "cifrado",
    "bio.plaintext": "texto plano",
    "bio.sessions": "Sesiones recientes",
    "bio.deenroll": "Dar de baja (eliminar plantilla)",
    "bio.lgpd": "Eliminar (LGPD)",
    "bio.lgpdTitle": "Eliminación por LGPD",
    "bio.lgpdBody": "Esto cifra y retiene un registro mínimo, envía la clave de recuperación al titular por correo y luego elimina permanentemente la clave del servidor. Irreversible.",
    "bio.escrowEmail": "Correo del titular (clave de recuperación)",
    "bio.cancel": "Cancelar",
    "bio.confirm": "Confirmar",
    "bio.error": "Error",
    "nav.global": "Global",
    "account.listSubtitle": "Usuarios del sistema (admins de la institución y livenesss).",
    "account.empty": "Aún no hay cuentas.",
    "account.new": "Nueva cuenta",
    "account.edit": "Editar cuenta",
    "account.newSubtitle": "Crea o edita un usuario del sistema (admin / liveness).",
    "account.removeTitle": "Eliminar cuenta",
    "account.registered": "Cuenta creada",
    "account.role": "Rol",
    "account.role.institution_admin": "Admin de institución",
    "account.role.liveness": "Liveness",
    "account.role.super": "Super Admin",
    "account.loadError": "No se pudo cargar la cuenta.",
    "account.saveError": "No se pudo guardar la cuenta.",
    "nav.exams": "Exámenes",
    "nav.events": "Eventos",
    "nav.examsEvents": "Exámenes / Eventos",
    "nav.configuration": "Configuración",
    "nav.companies": "Empresas",
    "nav.settings": "Configuración",
    "nav.ai": "IA",
    "nav.jobs": "Jobs",
    "ai.title": "IA",
    "ai.subtitle": "Servidor Ollama para refinar las detecciones",
    "ai.ollamaUrl": "URL de Ollama",
    "ai.visionModel": "Modelo de visión",
    "ai.enabled": "Refinamiento con Ollama",
    "ai.enabledHelp": "Cuando está apagado, las detecciones usan solo los modelos locales (sin refinamiento por LLM).",
    "ai.testConnectivity": "Probar conexión",
    "ai.testOk": "Conexión OK",
    "ai.testFailed": "Error de conexión",
    "ai.modelsFound": "Modelos disponibles",
    "ai.modelPresent": "El modelo seleccionado está instalado",
    "ai.modelMissing": "Modelo seleccionado NO encontrado en el servidor",
    "common.close": "Cerrar",
    "common.saved": "Guardado",
    "nav.logout": "Salir",
    "dash.title": "Panel",
    "dash.subtitle": "Analítica en vivo de las sesiones de su institución.",
    "dash.realtime": "Tiempo real",
    "dash.now": "ahora",
    "dash.activeSessions": "Sesiones activas",
    "dash.sessionsByTarget": "Sesiones por evento / examen",
    "dash.modeExam": "Examen",
    "dash.modeEvent": "Evento",
    "dash.noSessions": "Ninguna sesión en vivo en este momento.",
    "dash.liveOrigin": "Visitantes en vivo",
    "dash.cities": "ciudad(es)",
    "dash.sessions": "Sesiones",
    "dash.byProfile": "por la ciudad del perfil",
    "dash.withoutCoords": "sin coordenadas",
    "dash.devices": "Devices",
    "dash.throughput": "Throughput",
    "dash.throughputHint": "promedio · último 1 min",
    "dash.traffic": "Tráfico del servidor",
    "dash.perMinute": "Por minuto · últimos 30 min",
    "dash.perSecond": "Por segundo · últimos 60s",
    "dash.healthTitle": "Salud de las sesiones",
    "dash.healthHint": "top 10 conectados · problemas primero",
    "dash.participant": "Participante",
    "dash.target": "Evento / examen",
    "dash.status": "Estado",
    "dash.healthy": "Saludable",
    "dash.unhealthy": "Con problema",
    "dash.recordingFailure": "Fallo de grabación",
    "dash.rate": "Tasa",
    "dash.total": "Total",
    "dash.source.screen": "Pantalla",
    "dash.source.camera": "Cámara",
    "dash.source.audio": "Audio",
    "dash.sourceOk": "Transmitiendo",
    "dash.sourceBad": "Sin transmisión",
    "dash.sourceNa": "No requerido",
    "dash.countriesCities": "Países y ciudades",
    "dash.countryCity": "País / ciudad",
    "dash.noCountryData": "Sin datos de país por ahora.",
    "dash.topIps": "Top IPs",
    "dash.ip": "IP",
    "dash.location": "Ubicación",
    "dash.noIps": "Sin IPs por ahora.",
    "common.name": "Nombre",
    "common.firstName": "Nombre",
    "common.lastName": "Apellido",
    "common.phone": "Teléfono",
    "common.language": "Idioma",
    "common.country": "País",
    "common.company": "Empresa",
    "common.selectCompany": "Seleccione la empresa...",
    "common.actions": "Acciones",
    "common.edit": "Editar",
    "common.remove": "Eliminar",
    "common.cancel": "Cancelar",
    "common.save": "Guardar",
    "common.create": "Crear",
    "common.back": "Volver",
    "common.add": "Agregar",
    "common.confirmRemove": "¿Está seguro de que desea eliminar",
    "contestant.new": "Nuevo Participante",
    "contestant.listSubtitle": "Registre y gestione los participantes de su institución.",
    "contestant.edit": "Editar Participante",
    "contestant.empty": "Ningún participante registrado.",
    "contestant.removeTitle": "¿Eliminar participante?",
    "contestant.newSubtitle": "Registre un participante. Se generará una contraseña inicial que se muestra una sola vez.",
    "contestant.editSubtitle": "Edite los datos del participante. La contraseña no se cambia aquí.",
    "contestant.registered": "Participante registrado",
    "contestant.saveNote": "Anote la contraseña inicial — no se mostrará de nuevo.",
    "contestant.initialPassword": "Contraseña inicial",
    "contestant.copy": "Copiar",
    "contestant.copied": "¡Copiado!",
    "contestant.done": "Finalizar",
    "contestant.password": "Contraseña",
    "contestant.policy.blocked": "Contraseña bloqueada",
    "contestant.policy.mustChange": "Cambiar al acceder",
    "contestant.policy.free": "Libre",
    "contestant.mustChange": "Obligar cambio de contraseña en el primer acceso",
    "contestant.cannotChange": "No permitir que el participante cambie la contraseña",
    "contestant.exclusive": "Las dos opciones son mutuamente excluyentes.",
    "contestant.policyLabel": "Política de contraseña",
    "contestant.emailPlaceholder": "participante@ejemplo.com",
    "error.loadContestant": "No se pudo cargar el participante.",
    "error.saveContestant": "No se pudo guardar el participante. Verifique los datos.",
    "recording.empty": "Nada registrado.",
    "recording.start": "Inicio",
    "recording.scope": "Alcance",
    "recording.scope.national": "Nacional",
    "recording.scope.international": "Internacional",
    "common.state": "Estado",
    "common.state.placeholder": "Estado / región",
    "common.city": "Ciudad",
    "common.city.placeholder": "Ciudad",
    "recording.end": "Fin",
    "recording.duration": "Duración",
    "duration.day": "día",
    "duration.days": "días",
    "duration.hour": "hora",
    "duration.hours": "horas",
    "duration.minute": "minuto",
    "duration.minutes": "minutos",
    "duration.and": "y",
    "console.title": "Consola del Liveness",
    "console.subtitle": "Sesiones monitoreadas de su institución.",
    "console.all": "Todas",
    "console.onlyLive": "Solo en vivo",
    "console.refresh": "Actualizar",
    "console.empty": "Ninguna sesión en este momento.",
    "console.emptyLive": "Ninguna sesión en vivo en este momento.",
    "console.participant": "Participante",
    "console.event": "Evento",
    "console.system": "Sistema",
    "console.status": "Estado",
    "console.start": "Inicio",
    "console.examTime": "Tiempo de examen",
    "console.traffic": "Tráfico",
    "console.trafficHint": "Total transferido por los streams de ingesta de la sesión",
    "console.trafficRateHint": "Tasa actual",
    "console.files": "Archivos",
    "console.filesHint": "Tamaño total de los archivos grabados (cámara, pantalla, audio)",
    "console.live": "En vivo",
    "console.reconnect": "Forzar reconexión del cliente",
    "console.telemetry": "Telemetría (consola del cliente + eventos internos)",
    "console.review": "Revisar",
    "console.reviewLiveness": "Revisión de vivacidad",
    "console.noLiveness": "Sin captura de vivacidad en esta sesión",
    "console.disconnected": "Desconectado",
    "console.waitingStart": "Esperando el inicio",
    "console.recordingFailure": "Fallo de grabación",
    "console.warning": "Aviso",
    "console.transportWebrtc": "WebRTC (LiveKit, heredado)",
    "console.transportWebcodecs": "WebCodecs sobre WebSocket",
    "console.reconnectTitle": "Forzar reconexión",
    "console.reconnectBody": "El cliente de {name} se reconectará silenciosamente (readquiere micrófono/cámara y reinicia los envíos). Ocurre un breve corte de ~1–2s en la grabación. ¿Continuar?",
    "console.reconnectConfirm": "Reconectar",
    "console.reconnectError": "No se pudo solicitar la reconexión.",
    "console.reconnectRequested": "Reconexión solicitada — el cliente se reconectará en breve.",
    "console.participantFallback": "participante",
    "console.sessionScope": "sesión",
    "console.kindClientDisconnected": "se cayó la conexión del participante",
    "console.kindStorageStalled": "la grabación no se está almacenando",
    "console.kindStreamMissing": "stream obligatorio no iniciado",
    "console.kindVideoFrozen": "vídeo congelado (imagen fija)",
    "console.kindNoInput": "sin envío de medios del participante",
    "recording.requirements": "Requisitos",
    "recording.camera": "Cámara",
    "recording.audio": "Audio",
    "recording.screen": "Pantalla",
    "recording.requirementsLabel": "Requisitos de grabación",
    "recording.requiresCamera": "Requiere cámara",
    "recording.requiresAudio": "Requiere audio",
    "recording.requireLiveness": "Exigir liveness (captura de identidad)",
    "recording.requireLivenessHint": "Antes de compartir pantalla/audio el participante debe pasar una captura de liveness en cámara (grabada), independientemente de si se requiere cámara.",
    "recording.livenessAllowNoGeo": "Permitir que el participante no conceda la geolocalización",
    "recording.livenessAiThreshold": "Umbral de IA del liveness (%)",
    "recording.livenessAiThresholdHint": "Probabilidad de IA a partir de la cual el liveness y el gesto se aceptan. Separado del umbral anti-cheat.",
    "recording.requiresScreen": "Requiere pantalla",
    "recording.allowExternalCamera": "Permitir cámara externa (teléfono)",
    "recording.requiresExternalCamera": "Exige cámara externa",
    "recording.antiCheat": "Análisis anti-trampa",
    "recording.analyzeRecordings": "Analizar grabaciones (persona extra, ausencia, IA en pantalla)",
    "recording.detectExtraPerson": "Persona extra",
    "recording.detectAbsence": "Ausencia",
    "recording.detectAiOnScreen": "IA en pantalla",
    "recording.maxCameras": "Máx. cámaras (excepto externas)",
    "recording.monitorTabSwitch": "Señalar cambio de pestaña/ventana (examen de una sola pestaña)",
    "recording.sectionRecord": "Qué grabar",
    "recording.sectionMonitor": "Qué monitorear / analizar",
    "recording.absenceSeconds": "Umbral de ausencia (segundos fuera de cámara antes de señalar)",
    "recording.aiThreshold": "Umbral de confirmación de la IA (%)",
    "recording.aiThresholdHint": "Probabilidad de la IA a partir de la cual una detección se confirma automáticamente; por debajo, espera revisión del liveness. 0 confirma todo.",
    "capture.addCamera": "Agregar cámara",
    "capture.noMoreCameras": "No se detectó ninguna cámara adicional en este dispositivo.",
    "review.findings.title": "Análisis automático",
    "review.findings.empty": "Sin hallazgos automáticos.",
    "review.finding.multi_person": "Más de una persona en la cámara",
    "review.finding.absent": "El estudiante se ausentó de la cámara",
    "review.finding.returned": "El estudiante volvió a la cámara",
    "review.finding.ai_on_screen": "IA en pantalla",
    "review.finding.tab_switch": "Cambió de pestaña/ventana durante el examen",
    "review.finding.confidence": "confianza",
    "recording.durationLabel": "Duración (minutos) — 0 = indefinido",
    "recording.maxScreens": "Máx. de pantallas",
    "recording.logo": "Logo (redimensionada automáticamente a 200×200, fondo transparente)",
    "recording.formSubtitle": "Configure los datos y los requisitos de grabación.",
    "recording.allowedIps": "IPs / subredes permitidos",
    "recording.allowedIps.placeholder": "Ej: 192.168.0.0/24",
    "recording.allowedIps.hint": "Deje vacío para permitir cualquier dirección. El participante solo podrá acceder desde estas.",
    "recording.removeTitle": "¿Eliminar?",
    "recording.loadError": "No se pudo cargar el registro.",
    "recording.saveError": "No se pudo guardar. Verifique los datos.",
    "recording.contestants": "Participantes",
    "recording.contestants.empty": "Nadie matriculado aún.",
    "recording.selectContestant": "Seleccione un participante...",
    "recording.enroll": "Matricular",
    "recording.enrollment.expired": "expirada",
    "recording.enrollment.renew": "Renovar",
    "recording.schedule.title": "Horarios de acceso",
    "recording.schedule.add": "Agregar horario",
    "recording.schedule.empty": "Sin horarios — el acceso abarca todo el período del evento.",
    "recording.schedule.hint": "Sin horarios: el acceso está disponible durante todo el período del evento. Con horarios: el acceso abre 15 minutos antes de cada franja y termina exactamente al final de la misma.",
    "recording.profile": "Perfil de grabación",
    "recording.profile.default": "Predeterminado de la empresa",
    "nav.profiles": "Perfiles de grabación",
    "nav.recording": "Recording",
    "nav.simulation": "Simulación",
    "sim.title": "Simulación de capacidad",
    "sim.subtitle": "Cuánto cuesta un grupo en un perfil de grabación — medido, no estimado.",
    "sim.profile": "Perfil de grabación",
    "sim.clients": "Participantes",
    "sim.minutes": "Tiempo de grabación (minutos)",
    "sim.run": "Simular",
    "sim.measuring": "Codificando una muestra con los parámetros de este perfil…",
    "sim.idle": "Inactivo",
    "sim.busy": "Ocupado",
    "sim.idleHint": "pantalla quieta — a lo que más se parecen las sesiones reales",
    "sim.busyHint": "imagen cambiando en cada frame — el peor caso a planificar",
    "sim.uplink": "Ancho de banda de ingesta",
    "sim.storage": "Almacenamiento",
    "sim.perClient": "por participante",
    "sim.total": "total",
    "sim.perHour": "por participante-hora",
    "sim.sockets": "WebSockets",
    "sim.sources": "Fuentes por participante",
    "sim.measured": "Medido en este servidor",
    "sim.notMeasured": "No se pudo medir — cifras no disponibles",
    "sim.rangeWhy": "Todo es un rango porque el tráfico lo decide lo que muestra la pantalla del participante, y ninguna medición aquí puede saberlo. Las sesiones reales medidas están cerca del extremo inactivo.",
    "sim.detail": "Medido por fuente",
    "sim.uplinkCol": "Ingesta",
    "sim.storedCol": "Almacenado",
    "sim.error": "No se pudo simular.",
    "nav.apiTokens": "Tokens de API",
    "nav.agents": "Agentes",
    "agent.title": "Agentes",
    "agent.subtitle": "Máquinas que sirven esta instalación.",
    "agent.name": "Agente",
    "agent.status.label": "Estado",
    "agent.status.online": "En línea",
    "agent.status.offline": "Desconectado",
    "agent.status.draining": "Drenando",
    "agent.kind.websocket": "WebSocket (ingesta)",
    "agent.kind.encoder": "Codificador",
    "agent.kind.all_in_one": "Máquina única",
    "agent.ip": "IP",
    "agent.cpu": "CPU",
    "agent.memory": "Memoria",
    "agent.disk": "Disco libre",
    "agent.sessions": "Sesiones",
    "agent.traffic": "Tráfico",
    "agent.heartbeat": "Heartbeat",
    "agent.empty": "Ningún agente registrado.",
    "agent.error": "No se pudieron cargar los agentes.",
    "agent.secondsAgo": "hace {n}s",
    "agent.minutesAgo": "hace {n}min",
    "nav.webhooks": "Webhooks",
    "webhook.title": "Webhooks",
    "webhook.subtitle": "Envie alertas de eventos (online/offline, inicio/fin de sesion, salud, marcadores) a sistemas externos.",
    "webhook.new": "Nuevo webhook",
    "webhook.edit": "Editar webhook",
    "webhook.empty": "Aun no hay webhooks.",
    "webhook.events": "Eventos",
    "webhook.allEvents": "Todos los eventos",
    "webhook.eventsHint": "Deje todo sin marcar para recibir todos los eventos.",
    "webhook.secret": "Secreto de firma",
    "webhook.secretHint": "Cada envio se firma con HMAC-SHA256 (cabecera X-Webhook-Signature).",
    "webhook.urlHint": "Destino del POST. Payload: {event, email, session_id, timestamp, session_health}.",
    "webhook.enabled": "Activo",
    "webhook.create": "Crear webhook",
    "webhook.rotate": "Rotar secreto",
    "webhook.rotateConfirm": "Rotar el secreto de firma? El actual deja de funcionar de inmediato.",
    "webhook.test": "Enviar evento de prueba",
    "webhook.testOk": "Entregado",
    "webhook.testFail": "Fallo",
    "webhook.namePlaceholder": "p. ej. Gateway VPN",
    "webhook.nameRequired": "El nombre es obligatorio.",
    "webhook.urlRequired": "La URL es obligatoria.",
    "webhook.loadError": "No se pudo cargar el webhook.",
    "webhook.saveError": "No se pudo guardar el webhook.",
    "common.copy": "Copiar",
    "apiToken.title": "Tokens de API",
    "apiToken.subtitle": "Credenciales para que sistemas externos llamen a la API pública (X-Api-Token).",
    "apiToken.new": "Nuevo token",
    "apiToken.edit": "Editar token",
    "apiToken.create": "Crear token",
    "apiToken.empty": "Aún no hay tokens de API.",
    "apiToken.namePlaceholder": "Ej: Sistema de liveness",
    "apiToken.nameRequired": "Ingresa un nombre.",
    "apiToken.token": "Token (X-Api-Token)",
    "apiToken.tokenHint": "Envíalo en el header X-Api-Token. Manténlo en secreto.",
    "apiToken.show": "Mostrar",
    "apiToken.hide": "Ocultar",
    "apiToken.ipAcl": "Lista de IP de origen",
    "apiToken.ipAclHint": "IPs o CIDRs separados por comas. Vacío = cualquier IP.",
    "apiToken.anyIp": "cualquier IP",
    "apiToken.rateLimit": "Límite (solicitudes por minuto)",
    "apiToken.rateLimitHint": "0 = sin límite.",
    "apiToken.noLimit": "sin límite",
    "apiToken.enabled": "Activo",
    "apiToken.permissions": "Permisos",
    "apiToken.permissionsHint": "Qué familias de endpoints de integración puede llamar este token.",
    "apiToken.permExam": "API de Exámenes (/api/integration/exam/*)",
    "apiToken.permEvent": "API de Eventos (/api/integration/event/*)",
    "apiToken.usage": "Uso — add_marker",
    "apiToken.usageHint": "Agrega un marcador en el timestamp (una bandera, una nota, cualquier cosa) y crea una exportación mosaico de 60s antes hasta 60s después.",
    "apiToken.rotate": "Rotar",
    "apiToken.rotateConfirm": "¿Generar un nuevo token? El actual dejará de funcionar de inmediato.",
    "apiToken.loadError": "Error al cargar el token.",
    "apiToken.saveError": "Error al guardar.",
    "apiToken.examplesTitle": "API de integración de exámenes — ejemplos de solicitud",
    "apiToken.examplesIntro": "Autentica cada solicitud con la cabecera X-Api-Token. URL base:",
    "apiToken.eventsExamplesTitle": "API de integración de Eventos — ejemplos de solicitud",
    "apiToken.markerExamplesTitle": "API de integración de Marcadores — ejemplos de solicitud",
    "apiToken.markerExamplesIntro": "Autentica con la cabecera X-Api-Token. Endpoint:",
    "apiToken.exampleListDesc": "Lista los exámenes disponibles de esta empresa.",
    "apiToken.exampleStartDesc": "Inicia la sesión de un examen para un alumno. Crea el alumno si es necesario y devuelve un token de sesión — el alumno accede en /session_auth solo con ese token (sin e-mail/contraseña). La contraseña de un alumno existente nunca se cambia.",
    "apiToken.exampleStatusDesc": "Consulta el estado de la sesión de examen del alumno por e-mail.",
    "apiToken.exampleStopDesc": "Finaliza una sesión de examen abierta por e-mail (o session_id).",
    "apiToken.copy": "Copiar",
    "apiToken.copied": "¡Copiado!",
    "apiToken.parameters": "Parámetros",
    "apiToken.responses": "Respuestas",
    "apiToken.request": "Solicitud",
    "apiToken.required": "obligatorio",
    "apiToken.paramName": "Nombre",
    "apiToken.paramDesc": "Descripción",
    "apiToken.opListSummary": "Listar exámenes disponibles",
    "apiToken.opStartSummary": "Iniciar sesión de examen",
    "apiToken.opStatusSummary": "Estado de la sesión del alumno",
    "apiToken.opStopSummary": "Finalizar sesión de examen",
    "apiToken.opMarkerSummary": "Añadir un marcador (+ exportación de mosaico ±60s)",
    "apiToken.pMarkerTarget": "La sesión objetivo, por su UUID o el correo del participante (resuelve la sesión activa en ese momento).",
    "apiToken.pMarkerTimestamp": "Instante ISO-8601 del marcador (p. ej. 2026-07-08T20:58:45Z).",
    "apiToken.pMarkerDescription": "Nota de texto libre mostrada en el marcador.",
    "apiToken.pToken": "Token de API emitido para tu empresa.",
    "apiToken.pEmail": "E-mail del alumno.",
    "apiToken.pName": "Nombre completo del alumno (o usa first_name / last_name).",
    "apiToken.pExam": "El examen a realizar — su id (exam_id) O su nombre (exam_name).",
    "apiToken.pStatusEmail": "E-mail del alumno a consultar.",
    "apiToken.pStopTarget": "session_id, o el e-mail del alumno (opcionalmente acotado por exam_id / exam_name).",
    "apiToken.rOk": "Éxito.",
    "apiToken.rCreated": "Sesión creada (200 si se reutilizó una sesión abierta).",
    "apiToken.rBadRequest": "Faltan campos obligatorios.",
    "apiToken.rExamNotFound": "Examen no encontrado para la empresa de este token.",
    "apiToken.rUnauthorized": "Token ausente o inválido.",
    "apiToken.rSessionNotFound": "No se encontró ninguna sesión de examen abierta.",
    "profile.new": "Nuevo perfil",
    "profile.edit": "Editar perfil",
    "profile.subtitle": "Perfiles de grabación reutilizados por exámenes y eventos.",
    "profile.empty": "Ningún perfil registrado aún.",
    "profile.maxMonitors": "Máx. de monitores",
    "profile.maxCameras": "Máx. de cámaras",
    "profile.audioEnabled": "Audio habilitado",
    "profile.allowExternalCamera": "Permitir cámara externa (teléfono)",
    "profile.videoFps": "FPS de video",
    "profile.sampleRate": "Frecuencia de muestreo de audio (kHz)",
    "profile.cameraRes": "Resolución máx. de cámara",
    "profile.screenRes": "Resolución máx. de pantalla",
    "profile.segment": "Duración del segmento (minutos)",
    "recording.exam.singular": "Examen",
    "recording.exam.new": "Nuevo Examen",
    "recording.exam.edit": "Editar Examen",
    "recording.exam.listSubtitle": "Registre exámenes y sus requisitos de grabación.",
    "recording.event.singular": "Evento",
    "recording.event.new": "Nuevo Evento",
    "recording.event.edit": "Editar Evento",
    "recording.event.listSubtitle": "Registre eventos y sus requisitos de grabación.",
    "company.listSubtitle": "Gestione las empresas registradas en el sistema.",
    "company.new": "Nueva Empresa",
    "company.edit": "Editar Empresa",
    "company.newSubtitle": "Complete los datos para registrar una nueva empresa.",
    "company.editSubtitle": "Modifique los datos y la configuración de la empresa.",
    "company.empty": "Ninguna empresa registrada.",
    "company.deleteTitle": "¿Eliminar empresa?",
    "company.namePlaceholder": "Nombre de la empresa",
    "company.canSetLang": "El participante puede elegir el idioma",
    "company.canSetLang.desc": "Si se desactiva, el idioma del participante será siempre el de la empresa.",
    "company.createdAt": "Creado el",
    "company.tab.data": "Datos",
    "company.tab.policy": "Política de Contraseña",
    "error.loadCompany": "Error al cargar la empresa.",
    "error.saveCompany": "Error al guardar la empresa.",
    "policy.title": "Política de Contraseña",
    "policy.minLength": "Longitud Mínima",
    "policy.requireUpper": "Exigir letra mayúscula",
    "policy.requireLower": "Exigir letra minúscula",
    "policy.requireSpecial": "Exigir carácter especial",
    "policy.blacklist": "Palabras Bloqueadas",
    "policy.blacklistPlaceholder": "Ej: admin",
    "policy.saved": "Política de contraseña guardada con éxito.",
    "error.savePolicy": "Error al guardar la política de contraseña.",
    "settings.saved": "Configuración guardada con éxito.",
    "error.saveSettings": "Error al guardar la configuración.",
    "settings.saving": "Guardando...",
    "settings.save": "Guardar Configuración",
    "settings.title": "Configuración General",
    "settings.subtitle": "Configure los parámetros generales del sistema",
    "common.loading": "Cargando...",
    "oidc.completing": "Completando inicio de sesión...",
    "oidc.failed": "Error de inicio de sesión",
    "oidc.wait": "Espere, validando autenticación SSO.",
    "oidc.backToLogin": "Volver al inicio de sesión",
    "error.oidcInvalid": "Respuesta OIDC inválida.",
    "error.oidcFailed": "No se pudo completar el inicio de sesión SSO.",
    "contestant.home.title": "Sus exámenes y eventos",
    "contestant.home.subtitle": "Seleccione uno para comenzar.",
    "contestant.home.empty": "Ningún examen o evento disponible en este momento.",
    "capture.consent": "He leído y acepto ser monitoreado",
    "capture.start": "Iniciar Grabación",
    "capture.recording": "Grabando…",
    "capture.reconnecting": "Reconectando…",
    "capture.audioAlertTitle": "Activar alertas de audio",
    "capture.audioAlertBody": "Esta pantalla reproduce una alarma sonora si alguno de tus medios (pantalla, cámara o micrófono) se desconecta durante el examen. El navegador necesita tu permiso para reproducir sonido.",
    "capture.audioAlertEnable": "Activar audio",
    "capture.audioAlertLater": "Ahora no",
    "capture.finish": "Finalizar grabación",
    "capture.ending": "Finalizando…",
    "capture.pause": "Pausar grabación",
    "capture.pausing": "Pausando…",
    "capture.addScreen": "Agregar pantalla",
    "capture.enable": "Activar",
    "capture.active": "Activo",
    "capture.micActive": "Micrófono activo",
    "capture.required": "Obligatorio",
    "capture.gate": "Agregue todos los recursos requeridos y acepte el monitoreo para iniciar.",
    "watchdog.restartTitle": "Vuelva a compartir para reanudar la grabación",
    "watchdog.restartBody": "Su pantalla o cámara dejó de enviar al servidor (el navegador ya no puede leer la fuente). Haga clic abajo para readquirir las fuentes y reanudar — aparecerá el selector de pantalla. No es necesario recargar la página.",
    "watchdog.restartNow": "Volver a compartir y reanudar",
    "watchdog.dismiss": "Descartar",
    "capture.externalCamera": "Cámara externa",
    "capture.addExternalCamera": "Agregar cámara externa",
    "capture.extCamDown": "La cámara externa está desconectada. Vuelve a conectarla para seguir siendo monitoreado.",
    "capture.extCamRequiredDown": "Este examen REQUIERE una cámara externa (teléfono) y no está conectada. Conéctala ahora.",
    "capture.extCamReconnect": "Reconectar cámara",
    "capture.externalHint": "Usa tu teléfono como cámara extra escaneando un código QR.",
    "capture.externalNeedRecording": "Inicia la grabación para agregar una cámara externa.",
    "capture.externalChoose": "¿Cómo se usará la cámara del teléfono?",
    "capture.externalPrimary": "Cámara principal",
    "capture.externalSecondary": "Cámara secundaria",
    "capture.externalScan": "Escanea este código QR con tu teléfono y permite el acceso a la cámara.",
    "capture.externalWaiting": "Esperando que el teléfono se conecte…",
    "capture.externalConnected": "Cámara externa conectada",
    "capture.close": "Cerrar",
    "pair.title": "Cámara externa",
    "pair.live": "En vivo",
    "pair.connecting": "Conectando…",
    "pair.streaming": "Tu cámara está transmitiendo a la sesión.",
    "pair.switch": "Cambiar cámara",
    "pair.keepOpen": "Mantén esta página abierta durante el examen.",
    "pair.denied": "Permiso de cámara denegado. Permítelo e inténtalo de nuevo.",
    "pair.retry": "Intentar de nuevo",
    "pair.expired": "Este enlace no es válido o ha caducado. Pide un nuevo código QR.",
    "pair.error": "No se pudo conectar. Inténtalo de nuevo.",
    "pair.unsupported": "El navegador de este teléfono no puede usarse como cámara. Los iPhone no son compatibles (ningún navegador en iOS, incluido Chrome, tiene la captura necesaria). Usa un teléfono Android con Google Chrome y vuelve a escanear el código QR.",
    "pair.ended": "Sesión finalizada — puedes cerrar esta página.",
    "error.captureLoad": "No se pudo cargar este examen/evento.",
    "error.mediaDenied": "Permiso denegado o dispositivo no disponible.",
    "capture.unsupportedTitle": "Navegador no compatible",
    "capture.unsupportedBody": "Este navegador no admite el motor de vídeo necesario para la captura. Usa la última versión de Google Chrome o Microsoft Edge para realizar este examen.",
    // --- added: SecFace liveness/admin screens ---
    "biometric.title": "API biométrica — personas y fotos",
    "biometric.introAuth": "Autentica con la cabecera",
    "biometric.introAt": "en",
    "biometric.introScopePre": "Requiere el ámbito",
    "biometric.scopeName": "API biométrica",
    "biometric.introScopePost": "en el token; se aplican la lista de IP permitidas y el límite de tasa, y cada llamada se registra en la traza de auditoría.",
    "biometric.addSummary": "Registrar/actualizar una persona",
    "biometric.addDesc": "Upsert: busca por documento (document_type + document) y luego por intersección de e-mails; si no encuentra, crea. Los campos se combinan (los e-mails se unen; los campos vacíos nunca borran valores). Requiere al menos un e-mail o un documento.",
    "biometric.pEmails": "Lista de e-mails de la persona (también acepta un único \"email\").",
    "biometric.pDocumentType": "Tipo de documento (p. ej. cpf, rg, passport). Obligatorio cuando se envía document.",
    "biometric.pDocument": "Número del documento.",
    "biometric.pMobilePhone": "Teléfono móvil.",
    "biometric.rCreated": "Persona creada.",
    "biometric.rUpdated": "La persona ya existía — datos combinados/actualizados.",
    "biometric.rBadRequest": "Sin e-mail y sin documento, o document sin document_type.",
    "biometric.rForbidden": "Token sin el ámbito biométrico, o IP fuera de la allowlist.",
    "biometric.rRateLimited": "Límite de solicitudes por minuto alcanzado.",
    "biometric.photoSummary": "Agregar foto de referencia",
    "biometric.photoDesc": "Envía la foto en \"photo\" (archivo multipart o base64/data-URI en el JSON). La imagen suele provenir de un documento (DNI, licencia de conducir…): se detecta el rostro y SOLO se almacena el recorte del área de la foto (3:4, con márgenes de cabello/hombros) — nunca el documento completo. Una foto que la persona ya tiene (idéntica o casi idéntica) devuelve 204 y no se guarda nada.",
    "biometric.pPersonId": "El id de la persona (devuelto por /people/add).",
    "biometric.pPhoto": "Archivo (multipart/form-data) o cadena base64/data-URI (JSON).",
    "biometric.rPhotoStored": "Foto recortada y almacenada.",
    "biometric.rPhotoDuplicate": "La persona ya tiene esta foto (duplicada) — no se guardó nada.",
    "biometric.rNoFace": "No se encontró ningún rostro en la imagen (reason: no_face).",
    "biometric.rInvalidImage": "Imagen inválida/corrupta o campo photo ausente.",
    "biometric.rPersonNotFound": "Persona no encontrada (o de otra empresa).",
    "apiTokenForm.biometricScope": "API biométrica (/biometric/*)",
    "apiTokenForm.biometricScopeAria": "API biométrica",
    "account.resetMfa": "Restablecer MFA",
    "common.country.placeholder": "BR, US, ES, IT...",
    "clientApps.title": "Aplicaciones cliente",
    "clientApps.subtitle": "Sistemas que integran la verificación de liveness vía API (client_id / client_secret).",
    "clientApps.new": "Nuevo cliente",
    "clientApps.empty": "Ningún cliente registrado.",
    "clientApps.clientId": "Client ID",
    "clientApps.active": "Activo",
    "clientApps.inactive": "Inactivo",
    "clientApps.deleteTitle": "Eliminar cliente",
    "clientApps.deleteBodyPrefix": "¿Desea eliminar",
    "clientApps.deleteBodySuffix": "? Las llamadas con estas credenciales dejarán de funcionar.",
    "clientAppForm.credentialsTitle": "Credenciales del cliente",
    "clientAppForm.secretWarnPrefix": "Guarde el",
    "clientAppForm.secretWarnSuffix": "ahora — se muestra solo una vez y no se puede recuperar.",
    "clientAppForm.clientSecret": "Client Secret",
    "clientAppForm.done": "Listo",
    "clientAppForm.loadError": "No se pudo cargar el cliente.",
    "clientAppForm.saveError": "Error al guardar.",
    "clientAppForm.rotateError": "Error al rotar el secreto.",
    "clientAppForm.editTitle": "Editar cliente",
    "clientAppForm.newTitle": "Nuevo cliente",
    "clientAppForm.rotateSecret": "Rotar secreto",
    "clientAppForm.webhookUrl": "URL del webhook",
    "clientAppForm.webhookUrlHelpPrefix": "Recibe el evento",
    "clientAppForm.webhookUrlHelpSuffix": "(firmado). Vacío desactiva el push (use polling).",
    "clientAppForm.webhookSecret": "Webhook Secret (HMAC)",
    "clientAppForm.webhookSecretPlaceholder": "mínimo 16 caracteres",
    "clientAppForm.webhookSecretHelpPrefix": "Clave usada para firmar el webhook:",
    "clientAppForm.webhookSecretHelpCode": "X-SecFace-Signature: sha256=<HMAC-SHA256 del cuerpo>",
    "clientAppForm.webhookSecretHelpSuffix": "Configure este mismo valor en el sistema cliente para validar la firma. Vacío mantiene el actual.",
    "clientAppForm.redirectUris": "Redirect URIs permitidas",
    "clientAppForm.redirectUrisPlaceholder": "https://app.ejemplo.com/callback https://…",
    "clientAppForm.redirectUrisHelp": "Una por línea. El redirect_uri de /start debe comenzar con una de ellas.",
    "clientAppForm.emailReports": "Enviar informes por correo al cliente",
    "clientAppForm.emailReportsHelp": "Cuando está activo, en cada sesión de vivacidad aprobada el PDF firmado se envía a los destinatarios de abajo y a la persona validada.",
    "clientAppForm.reportEmails": "Correos destinatarios",
    "clientAppForm.reportEmailsPlaceholder": "uno por línea o separados por comas",
    "clientAppForm.reportEmailsHelp": "Destinatarios que reciben el informe de cada verificación aprobada.",
    "clientAppForm.policyNotePrefix": "Política predeterminada de la empresa. Deje en",
    "clientAppForm.policyNoteInherit": "Heredar",
    "clientAppForm.policyNoteMiddle": "/ vacío para usar el valor global. El cliente puede sobrescribir por sesión en",
    "clientAppForm.aiThreshold": "Umbral de IA (%)",
    "clientAppForm.inheritGlobal": "Heredar global",
    "clientAppForm.requireGeo": "Exigir geolocalización",
    "clientAppForm.requireGesture": "Exigir gesto",
    "clientAppForm.yes": "Sí",
    "clientAppForm.no": "No",
    "globalConfig.loadError": "No se pudo cargar la configuración global.",
    "globalConfig.saveError": "Error al guardar.",
    "globalConfig.title": "Configuración global",
    "globalConfig.subtitle": "Valores predeterminados globales de la política de liveness (nivel de precedencia más bajo).",
    "globalConfig.precedence": "cliente > empresa (ClientApp) > global",
    "globalConfig.aiThreshold": "Umbral de IA (%)",
    "globalConfig.aiThresholdHelp": "Corte de identificación/vivacidad cuando ni el cliente ni el ClientApp lo definen.",
    "globalConfig.sessionTtl": "TTL de la sesión (segundos)",
    "globalConfig.sessionTtlHelp": "Validez de una sesión después del /start.",
    "globalConfig.requireGeo": "Exigir geolocalización de forma predeterminada",
    "globalConfig.requireGeoAria": "Exigir geolocalización",
    "globalConfig.requireGesture": "Exigir desafío de gesto de forma predeterminada",
    "globalConfig.requireGestureAria": "Exigir gesto",
    "liveness.title": "Verificación de identidad",
    "liveness.intro": "Este examen requiere una verificación de identidad (liveness) antes de que compartas tu pantalla. Completa los dos pasos siguientes para continuar.",
    "liveness.stepLocation": "Ubicación",
    "liveness.geoRequiredHint": "Obligatoria para continuar.",
    "liveness.geoOptionalHint": "Se solicitará; puedes rechazarla.",
    "liveness.geoNotProvided": "Ubicación no proporcionada",
    "liveness.geoEnabled": "Ubicación habilitada",
    "liveness.requesting": "Solicitando…",
    "liveness.enableGeo": "Habilitar geolocalización",
    "liveness.declineGeo": "No proporcionar ubicación",
    "liveness.faceCapture": "Captura facial",
    "liveness.captureHint": "Acerca el rostro al círculo, mira a la cámara y mantén los ojos abiertos. Todo el proceso se graba.",
    "liveness.startCapture": "Iniciar captura facial",
    "liveness.unsupportedTitle": "Navegador no compatible",
    "liveness.unsupportedBody": "Este navegador no admite la captura de vídeo necesaria (WebCodecs). Copia el enlace de abajo y ábrelo en otro navegador actualizado (Chrome o Edge, en ordenador o Android).",
    "common.copied": "Copiado",
    "liveness.declineTitle": "¿No proporcionar ubicación?",
    "liveness.declineBody": "¿Seguro que no deseas proporcionar tu ubicación? El rechazo queda registrado en tu verificación.",
    "liveness.cancel": "Cancelar",
    "liveness.confirmDecline": "Sí, no proporcionar",
    "liveness.geoRequired": "Debes permitir tu ubicación exacta para continuar. Concede el permiso e inténtalo de nuevo.",
    "liveness.geoValidateFailed": "No se pudo validar la ubicación.",
    "liveness.geoNoContinue": "No se pudo continuar sin la ubicación.",
    "liveness.cannotContinue": "No se pudo continuar.",
    "liveness.startingCamera": "Iniciando la cámara…",
    "liveness.cameraDenied": "Permite el acceso a la cámara para continuar.",
    "liveness.cameraFailed": "No se pudo iniciar la cámara.",
    "liveness.tooManyInterruptions": "Demasiadas interrupciones de conexión. Verifica tu internet e inténtalo de nuevo.",
    "liveness.connectionInterrupted": "Conexión interrumpida: reiniciando la verificación…",
    "liveness.hdrGesture": "Desafío de gesto",
    "liveness.hdrMotion": "Aproximación",
    "liveness.hdrFlash": "Verificación de luz",
    "liveness.altCapture": "captura",
    "liveness.retry": "Intentar de nuevo",
    "liveness.checking": "Validando…",
    "liveness.verifying": "Verificando…",
    "liveness.completeFailed": "Error al completar la verificación.",
    "liveness.gestureHold": "¡Perfecto! Mantén el gesto…",
    "liveness.gesturePrompt": "Haz el gesto solicitado",
    "liveness.lookAtScreen": "Mira a la pantalla",
    "liveness.fitFaceInCircle": "Encaja tu rostro en el círculo",
    "liveness.fitFaceInSmallerCircle": "Ahora encaja tu rostro en el círculo más pequeño",
    "liveness.holdStill": "Mantén el rostro quieto… {n}s",
    "liveness.guidance.no_face": "Coloca tu rostro dentro del círculo",
    "liveness.guidance.multiple_faces": "Solo tú debes aparecer en la cámara",
    "liveness.guidance.too_far": "Acerca el rostro a la cámara",
    "liveness.guidance.fill_oval": "Acerca el rostro para llenar el círculo",
    "liveness.guidance.too_close": "Aleja un poco el rostro",
    "liveness.guidance.not_frontal": "Mira directamente a la cámara",
    "liveness.guidance.off_center": "Centra tu rostro en el círculo",
    "liveness.guidance.blurry": "Mejora la iluminación y quédate quieto: la imagen no está nítida",
    "liveness.guidance.low_confidence": "Rostro no detectado con claridad",
    "liveness.guidance.ok": "¡Perfecto! Mantén el rostro…",
    "liveness.guidance.detector_unavailable": "Verificando…",
    "liveness.guidance.decode_failed": "Ajustando la cámara…",
    "liveness.guidance.flash_fill_oval": "Acércate y encaja el rostro en el círculo más grande",
    "liveness.guidance.flash_hold_fit": "¡Encajado! Espera sin moverte…",
    "liveness.guidance.flash_hold": "Mantén el rostro en el círculo hasta que los destellos paren",
    "gesture.instr.v_over_eye": "Haz la \"V\" (dedos índice y medio) y lleva la mano frente al rostro, con los dedos sobre uno de los ojos.",
    "gesture.instr.open_palm": "Levanta una mano abierta junto al rostro, con los dedos bien separados (extendida).",
    "gesture.instr.thumbs_up": "Haz el gesto de \"pulgar arriba\" (pulgar hacia arriba) cerca del rostro.",
    "gesture.instr.hand_on_cheek": "Apoya la palma de una mano sobre una de tus mejillas.",
    "people.title": "Personas",
    "people.matchCount": "{n} coincidencia(s) por similitud",
    "people.peopleCount": "{n} persona(s)",
    "people.searchPlaceholder": "Nombre, documento, correo…",
    "people.searchByPhoto": "Buscar por foto",
    "people.errNoFace": "Ningún rostro utilizable en la foto enviada.",
    "people.errSearchFailed": "Error en la búsqueda por foto.",
    "people.sortedBySimilarity": "Resultados ordenados por similitud facial.",
    "people.facesMatchCount": "{f} rostro(s) detectado(s) · {n} coincidencia(s)",
    "people.extractedFaces": "Rostros extraídos de la imagen",
    "people.faceHint": "Rostro {i} — {n} coincidencia(s)",
    "people.nMatches": "{n} match",
    "people.faceNoMatch": "Sin coincidencias para el rostro seleccionado.",
    "people.identity": "Identidad",
    "people.createdAt": "Registrado el",
    "people.noPhotos": "Sin fotos de referencia.",
    "people.linkedSessions": "Verificaciones vinculadas",
    "people.noSessions": "Sin verificaciones vinculadas.",
    "common.email": "Correo",
    "people.clear": "limpiar",
    "people.empty": "No se encontraron personas.",
    "people.colSimilarity": "Similitud",
    "people.colPerson": "Persona",
    "people.colDocument": "Documento",
    "people.colPhotos": "Fotos",
    "people.colValidations": "Validaciones",
    "status.passed": "Aprobado",
    "status.failed": "Denegado",
    "status.pending": "Pendiente",
    "status.expired": "Expirado",
    "sessions.title": "Verificaciones",
    "sessions.refresh": "Actualizar",
    "sessions.loadedCount": "{n} cargada(s)",
    "sessions.filterAll": "Todos",
    "sessions.searchPlaceholder": "Nombre, correo, sesión…",
    "sessions.empty": "No se encontró ninguna verificación.",
    "sessions.colDate": "Fecha",
    "sessions.colParticipant": "Participante",
    "sessions.colSession": "Sesión",
    "sessions.colStatus": "Estado",
    "sessions.colApproved": "Aprobado",
    "sessions.yes": "Sí",
    "sessions.no": "No",
    "sessions.deepFlaggedTip": "Deep PAD marcó esta sesión",
    "sessionDetail.title": "Liveness",
    "sessionDetail.notFound": "Verificación no encontrada.",
    "sessionDetail.loadFailed": "Error al cargar la verificación.",
    "sessionDetail.padLabel": "PAD",
    "sessionDetail.padOk": "OK",
    "sessionDetail.padFlagged": "SEÑALADO",
    "sessionDetail.padError": "error",
    "sessionDetail.padAnalyzing": "en análisis",
    "sessionDetail.photoFace": "Rostro",
    "sessionDetail.photoFull": "Cuadro completo",
    "sessionDetail.photoGesture": "Gesto",
    "sessionDetail.completedAt": "Completado en",
    "sessionDetail.geolocation": "Geolocalización",
    "sessionDetail.geoNotProvided": "no informada",
    "sessionDetail.location": "Ubicación",
    "sessionDetail.viaGeo": "vía geolocalización",
    "sessionDetail.viaIp": "vía IP",
    "sessionDetail.localDetection": "Detección local",
    "sessionDetail.detShort": "det",
    "sessionDetail.frontality": "frontalidad",
    "sessionDetail.depth": "Profundidad",
    "sessionDetail.flashmark": "Flashmark",
    "sessionDetail.aiLiveness": "IA Vivacidad",
    "sessionDetail.aiProbability": "Prueba de vida (IA)",
    "sessionDetail.aiVerdict": "Dictamen de la IA",
    "sessionDetail.padAnalysis": "Análisis PAD",
    "sessionDetail.aiGesture": "IA Gesto",
    "sessionDetail.gestureChallenge": "Desafío de gesto",
    "sessionDetail.aiProbabilityGesture": "Gesto correcto (IA)",
    "sessionDetail.samePerson": "misma persona",
    "sessionDetail.aiVerdictGesture": "Dictamen de la IA gesto",
    "sessionDetail.padAnalysisGesture": "Análisis PAD gesto",
    "sessionDetail.session": "Sesión",
    "sessionDetail.client": "Empresa",
    "sessionDetail.created": "Creada",
    "sessionDetail.attempts": "Intentos",
    "sessionDetail.language": "Idioma",
    "reason.REAL_3D": "3D — paralaje de rostro vivo",
    "reason.FLAT_SPOOF": "superficie plana — posible spoof",
    "reason.LIVE": "el rostro reflejó el patrón de luz",
    "reason.SPOOF": "el rostro no reflejó el flash",
    "reason.inconclusive": "no concluyente",
    "reason.geo_required": "geolocalización obligatoria",
    "reason.local:no_face": "ningún rostro detectado",
    "reason.local:multiple_faces": "múltiples rostros detectados",
    "reason.local:not_frontal": "rostro no frontal",
    "reason.local:too_close": "rostro demasiado cerca",
    "reason.local:fill_oval": "rostro demasiado pequeño en el óvalo",
    "reason.local:off_center": "rostro descentrado",
    "reason.local:blurry": "imagen borrosa",
    "reason.local:low_confidence": "baja confianza de detección",
    "reason.local:decode_failed": "error al decodificar la imagen",
    "reason.local:detector_unavailable": "detector no disponible",
    "reason.local:ok": "ok",
    // --- added: SecFace liveness/admin screens ---
    "report.download": "Descargar informe PDF firmado",
    // --- added: SecFace liveness/admin screens ---
    "video.watch": "Ver video",
    "video.download": "Descargar video",
    "video.hide": "Ocultar video",
    "video.title": "Sesión de liveness grabada",
    "video.unavailable": "Grabación no disponible para esta sesión.",
    // --- added: SecFace liveness/admin screens ---
    "sessions.colReport": "Informe",
    // --- added: SecFace liveness/admin screens ---
    "sessions.colSigned": "Firmado",
    // --- added: SecFace liveness/admin screens ---
    "sessions.filterStatus": "Estado",
    // --- added: SecFace liveness/admin screens ---
    "sessions.signedWaiting": "Esperando PAD",
    "sessions.signedError": "Error",
    "sessions.copyId": "Copiar ID de sesión",
  },
  it: {
    "oidc.signingIn": "Accesso a {app}…",
    "pub.login.continue": "Continua",
    "pub.login.change": "cambia",
    "pub.login.badCode": "Codice non valido.",
    "pub.login.expired": "La sessione di accesso è scaduta. Ricomincia.",
    "pub.signOut": "Esci",
    "pub.verified": "Verificato",
    "pub.unverified": "Non verificato",
    "pub.email": "E-mail",
    "pub.phone": "Cellulare",
    "pub.biometric": "La mia biometria",
    "pub.enrolled": "Registrata",
    "pub.home.title": "I miei dati",
    "pub.home.subtitle": "I dati che abbiamo verificato appartenerti.",
    "pub.login.title": "Accedi",
    "pub.login.subtitle": "Accedi ai tuoi dati e alla tua biometria.",
    "pub.login.face": "Accedi con il mio volto",
    "pub.login.faceWaiting": "Aguardando a captura…",
    "pub.login.or": "ou",
    "pub.login.email": "E-mail",
    "pub.login.password": "Password",
    "pub.login.mfa": "Codice autenticatore",
    "pub.login.submit": "Accedi",
    "pub.login.register": "Crea il mio account",
    "pub.login.invalid": "E-mail, password o codice non validi.",
    "pub.login.faceUnavailable": "Login facial indisponível no momento.",
    "pub.login.faceFailed": "Não foi possível identificar você. Tente novamente.",
    "pub.login.notPortal": "Este rosto não pertence a uma conta do portal.",
    "pub.reg.title": "Crea il mio account",
    "pub.reg.subtitle": "Confirmamos seu e-mail e seu celular, você define a senha e o MFA, e por fim cadastra seu rosto.",
    "pub.reg.back": "Voltar ao login",
    "pub.reg.stepData": "Dados",
    "pub.reg.stepCodes": "Verificação",
    "pub.reg.stepPassword": "Senha",
    "pub.reg.stepMfa": "MFA",
    "pub.reg.firstName": "Nome",
    "pub.reg.lastName": "Cognome",
    "pub.reg.email": "E-mail",
    "pub.reg.phone": "Cellulare (WhatsApp)",
    "pub.reg.sendCodes": "Invia i codici",
    "pub.reg.codesHelp": "Enviamos um código diferente para cada canal. Confirme os dois.",
    "pub.reg.codeSent": "Código enviado para {to}",
    "pub.reg.codeNotSent": "Não foi possível enviar para {to}",
    "pub.reg.confirm": "Conferma",
    "pub.reg.password": "Password",
    "pub.reg.password2": "Ripeti la password",
    "pub.reg.setPassword": "Imposta la password",
    "pub.reg.mfaHelp": "Escaneie o QR no seu app autenticador e digite o código gerado.",
    "pub.reg.finish": "Concludi e registra il mio volto",
    "pub.reg.emailTaken": "Este e-mail já tem conta.",
    "pub.reg.badPhone": "Telefone inválido.",
    "pub.reg.rate": "Muitas tentativas. Aguarde alguns minutos.",
    "pub.reg.startFailed": "Não foi possível iniciar o cadastro.",
    "pub.reg.codeWrong": "Código incorreto.",
    "pub.reg.codeExpired": "Código expirado.",
    "pub.reg.codeFailed": "Não foi possível confirmar.",
    "pub.reg.mismatch": "As senhas não conferem.",
    "pub.reg.passwordFailed": "Senha recusada pela política.",
    "pub.reg.mfaWrong": "Código do autenticador inválido.",
    "pub.enroll.title": "Registra il tuo volto",
    "pub.enroll.body": "Sua conta só fica ativa depois do cadastro facial. Abra a captura, siga as instruções na tela e volte aqui.",
    "pub.enroll.cta": "Apri la cattura",
    "pub.enroll.again": "Abrir a captura novamente",
    "pub.enroll.waiting": "Aguardando a conclusão da captura…",
    "pub.enroll.failed": "Não foi possível iniciar a captura.",
    "bio.via.admin": "Verificata dall’admin",
    "bio.via.document": "Verificata da documento",
    "bio.via.code": "Verificata da codice",
    "bio.via.legacy": "Verificata (legacy — precedente alla regola)",
    "bio.identVerified": "Verificata",
    "bio.identUnverified": "Non verificata — non esposta ai consumer",
    "profile.title": "I miei dati",
    "profile.subtitle": "Conferma di possedere la tua e-mail e il telefono. Ogni modifica richiede un codice inviato al contatto stesso.",
    "profile.email": "E-mail",
    "profile.phone": "Telefono (WhatsApp)",
    "profile.verified": "Verificato",
    "profile.unverified": "Non verificato",
    "profile.verify": "Verifica",
    "profile.change": "Modifica",
    "profile.sendCode": "Invia codice",
    "profile.confirm": "Conferma",
    "profile.resend": "Invia di nuovo",
    "profile.codeSent": "Codice inviato a {to}. Scade tra {ttl} minuti.",
    "profile.emailHelp": "Invieremo un codice a questa e-mail. Ha effetto solo dopo la conferma.",
    "profile.phoneHelp": "Invieremo un codice via WhatsApp. Ha effetto solo dopo la conferma.",
    "profile.codeWrong": "Codice errato.",
    "profile.codeExpired": "Codice scaduto — inviane un altro.",
    "profile.codeBlocked": "Troppi tentativi. Invia un nuovo codice.",
    "profile.sendFailed": "Impossibile inviare il codice.",
    "profile.verifyFailed": "Impossibile confermare.",
    "profile.notSent": "Impossibile consegnare il codice su questo canale.",
    "search.title": "Ricerca",
    "search.placeholder": "Cerca in tutto il sistema…",
    "search.hint": "Nome, e-mail, CPF, telefono, azienda, app o id di sessione. Esc per chiudere.",
    "search.enter": "Invio",
    "search.found": "{n} risultato/i per «{q}»",
    "search.empty": "Nessun risultato. I valori sensibili (e-mail, CPF, telefono) sono cifrati e corrispondono solo al valore esatto.",
    "search.type.biometric": "Biometrie",
    "search.type.account": "Account",
    "search.type.session": "Verifiche",
    "search.type.company": "Aziende",
    "search.type.client_app": "Client app",
    "search.type.person": "Persone",
    "search.type.alert": "Avvisi",
    "globalConfig.docPhotoMatch": "Foto stampata × foto firmata",
    "globalConfig.docPhotoMatchHelp": "La foto del QR è firmata (a prova di manomissione) ma minuscola (~45x61), il che degrada il riconoscimento. Il PDF porta anche una copia ad alta risoluzione, ma non firmata. Questa è la correlazione minima di pixel tra le due per accettare la foto stampata e usarla nel match facciale. Più alto = più severo (una foto sostituita non passa mai); più basso = tollera variazioni di stampa/compressione.",
    "bio.docPhotoSrc": "Foto usata",
    "bio.docPhotoVisible": "stampata ad alta risoluzione (validata contro quella firmata)",
    "bio.docPhotoQr": "dal QR (firmata)",
    "globalConfig.change": "Modifica",
    "globalConfig.modelTitle": "Modifica il modello di riconoscimento",
    "globalConfig.modelWarn": "Questa modifica invalida TUTTE le biometrie registrate.",
    "globalConfig.modelWarnBody": "Il modello genera la firma facciale: cambiarlo cambia lo spazio vettoriale, quindi nessun template esistente potrà più essere confrontato. Tutti dovranno registrarsi di nuovo, il pre-filtro (ANN) dovrà essere riaddestrato e le autenticazioni falliranno fino ad allora.",
    "globalConfig.modelCurrent": "Modello attuale",
    "globalConfig.modelNew": "Nuovo modello",
    "globalConfig.modelEnrollments": "Registrazioni invalidate",
    "globalConfig.modelPeople": "Persone interessate",
    "globalConfig.modelGold": "Biometrie Oro",
    "globalConfig.modelType": "Per confermare, digita",
    "globalConfig.modelApply": "Modifica modello",
    "globalConfig.modelFailed": "Impossibile modificare il modello.",
    "bio.removeIdentity": "Rimuovi identità",
    "bio.removeIdentityBody": "Rimuovere {id} da questa biometria? La persona non sarà più trovata tramite questa identità.",
    "bio.docSigner": "Firmato da",
    "bio.docCert": "Certificato",
    "bio.docThumb": "Thumbprint",
    "bio.docPubKey": "Chiave pubblica",
    "bio.downloadDoc": "Scarica documento",
    "bio.reactivate": "Ripristina registrazione precedente",
    "bio.newEnrollLink": "Genera link di registrazione",
    "bio.enrollLinkHelp": "Apri questo link (o scansiona il QR) sul telefono per rifare la registrazione biometrica.",
    "bio.inactive": "inattivo",
    "bio.reviewTitle": "Documento in attesa di revisione",
    "bio.reviewBody": "La similarità tra la foto del documento e il volto registrato è finita nella fascia di revisione.",
    "bio.approve": "Approva",
    "bio.reject": "Rifiuta",
    "globalConfig.docBandsHelp": "Fasce di decisione della similarità tra la FOTO del documento e la biometria registrata: sotto la 1ª soglia il documento è rifiutato; tra le due passa alla revisione manuale di un admin; sopra la 2ª concede il livello Oro automaticamente.",
    "globalConfig.bandDeny": "Rifiuta",
    "globalConfig.bandReview": "Rivedi",
    "globalConfig.bandAllow": "Permetti",
    "doc.reason.reviewPending": "Inviato alla revisione di un admin — la corrispondenza facciale non è stata conclusiva.",
    "alerts.document_review": "Documento in attesa di revisione manuale",
    "bio.typeToConfirm": "Per confermare, digita",
    "bio.deenrollTitle": "Rimuovi registrazione biometrica",
    "bio.deenrollBody": "Rimuove il template facciale di questa persona — non potrà autenticarsi finché non si registra di nuovo.",
    "bio.addIdentity": "Aggiungi identità",
    "bio.addIdentityHelp": "Collega un’e-mail, CPF, telefono o id esterno a questa biometria. Ogni identità è unica in tutto il sistema.",
    "sessions.bioMatch": "Corrispondenza biometrica",
    "sessions.bioIdentified": "Identificato",
    "alerts.duplicate_identity": "Stessa identità su due biometrie",
    "doc.upload": "Carica un documento...",
    "bio.docPhoto": "Foto del documento",
    "bio.noDocPhoto": "Nessuna foto",
    "bio.docName": "Nome completo",
    "bio.docCpf": "CPF",
    "bio.docBirth": "Data di nascita",
    "bio.revealData": "Mostra dati completi",
    "bio.hideData": "Nascondi dati",
    "bio.docAttempts": "Tentativi di lettura del documento",
    "bio.date": "Data",
    "bio.docFile": "File",
    "bio.docResult": "Risultato",
    "bio.docSim": "Similarità",
    "bio.docBy": "Da",
    "globalConfig.docFace": "Documento × volto (Oro)",
    "globalConfig.docFaceHelp": "Similarità minima tra la FOTO del documento e la biometria registrata per concedere il livello Oro. Più alto = più severo (evita il documento di un’altra persona), ma può respingere foto di documenti vecchie/di bassa qualità.",
    "doc.reason.faceMismatch": "La foto del documento non corrisponde al volto registrato.",
    "doc.reason.photoUnavailable": "Impossibile leggere la foto del documento.",
    "doc.reason.docNoFace": "Nessun volto utilizzabile nella foto del documento.",
    "doc.reason.noEnrollment": "Registra il volto prima di verificare un documento.",
    "clientAppForm.genConfig": "Genera config di esempio (.env)",
    "clientAppForm.genConfigTitle": "Configurazione di esempio (RP)",
    "clientAppForm.genConfigHint": "Inserisci SEC_FACE_OIDC_CLIENT_SECRET con il segreto dell’app (mostrato alla creazione/rotazione).",
    "clientAppForm.cfgError": "Impossibile generare la configurazione.",
    "clientAppForm.copy": "Copia",
    "clientAppForm.copied": "Copiato!",
    "common.close": "Chiudi",
    "clientAppForm.minTier": "Livello minimo (biometria)",
    "clientAppForm.minTierHelp": "Livello di fiducia minimo richiesto per autenticarsi con la biometria in questa app.",
    "oidc.tierTitle": "Livello di verifica insufficiente",
    "oidc.tierBody": "Questa app richiede il livello {req}, ma la tua biometria è {cur}.",
    "oidc.tierHow": "Come salire di livello",
    "oidc.tierSilver": "Argento: chiedi a un amministratore di confermare la tua biometria.",
    "oidc.tierGold": "Oro: carica un documento nazionale valido (patente) sul tuo account per la verifica.",
    "bio.tier": "Livello di fiducia",
    "bio.tierHelp": "Bronzo: iniziale. Argento: confermata da un umano. Oro: documento nazionale valido verificato.",
    "bio.bronze": "Bronzo",
    "bio.silver": "Argento",
    "bio.gold": "Oro",
    "bio.confirmSilver": "Conferma (Argento)",
    "bio.revertBronze": "Torna a Bronzo",
    "bio.goldDoc": "Documento",
    "bio.goldExpiry": "Scadenza",
    "doc.verifyGold": "Verifica documento (Oro)",
    "doc.hint": "Carica la patente/documento digitale (PDF o immagine del QR). Verifica offline; accetta documenti autentici scaduti al massimo 6 mesi fa.",
    "doc.gold": "Documento verificato — livello Oro concesso.",
    "doc.reason.notAuthentic": "Il documento non è autentico (firma non valida).",
    "doc.reason.sandbox": "Documento di test/sandbox — non accettato.",
    "doc.reason.expired": "Documento scaduto da più di 6 mesi.",
    "doc.reason.noExpiry": "Impossibile leggere la scadenza.",
    "doc.reason.parseFailed": "Impossibile leggere il documento.",
    "doc.reason.unavailable": "Verifica documento non disponibile.",
    "doc.reason.empty": "File vuoto.",
    "nav.alerts": "Avvisi",
    "globalConfig.dupAlert": "Avviso di biometria duplicata",
    "globalConfig.dupAlertHelp": "Oltre questo valore due biometrie REGISTRATE di persone diverse generano un avviso al Super Admin (possibile stessa persona in due record). Più alto = meno avvisi (solo sosia quasi identici).",
    "alerts.title": "Avvisi di sicurezza",
    "alerts.subtitle": "Tentativi di frode per account e possibili biometrie duplicate.",
    "alerts.tab.open": "Aperti",
    "alerts.tab.dismissed": "Ignorati",
    "alerts.tab.resolved": "Risolti",
    "alerts.tab.all": "Tutti",
    "alerts.empty": "Nessun avviso.",
    "alerts.error": "Errore",
    "alerts.account": "Account",
    "alerts.kind.fraud": "Tentativo di frode",
    "alerts.kind.duplicate": "Possibile duplicato",
    "alerts.kind.blacklist": "Uso in blacklist",
    "alerts.blockTitle": "Blocca account",
    "alerts.blockBody": "L’account verrà disattivato e non potrà più accedere. Confermare?",
    "alerts.block": "Blocca account",
    "alerts.notify": "Avvisa il proprietario",
    "alerts.mergeTitle": "Unisci biometrie",
    "alerts.mergeKeepA": "Mantenere {a} e rimuovere {b}?",
    "alerts.mergeKeep": "Mantieni",
    "alerts.dismiss": "Ignora",
    "alerts.cancel": "Annulla",
    "alerts.confirm": "Conferma",
    "bio.governance": "Governance",
    "bio.enabledLabel": "Biometria abilitata",
    "bio.enabledHelp": "Disabilita per bloccare l’uso nell’autenticazione senza eliminare la registrazione.",
    "bio.enabled": "Abilitata",
    "bio.disabled": "Disabilitata",
    "bio.blacklist": "Blacklist",
    "bio.blacklistHelp": "Negare ogni uso, o solo avvisare il Super Admin a ogni uso.",
    "bio.blNone": "Normale",
    "bio.blDeny": "Nega ogni uso",
    "bio.blAlert": "Solo avvisare",
    "bio.hardDeleteTitle": "Elimina biometria",
    "bio.hardDeleteBody": "Elimina definitivamente questa biometria non utilizzata (senza registrazione né storico d’uso). Irreversibile.",
    "bio.hardDelete": "Elimina (hard-delete)",
    "account.faceHelp2": "Genera un link affinché questa persona registri il volto, o collega l’account a una biometria esistente. Potrà poi accedere con il volto.",
    "face.link.linkedTo": "Collegato a",
    "face.link.enrolled": "registrato",
    "face.link.notEnrolled": "senza template",
    "face.link.unlink": "Scollega",
    "face.link.none": "Nessuna biometria collegata a questo account.",
    "face.link.pickCta": "Collega a biometria esistente",
    "face.link.pickTitle": "Collega a biometria esistente",
    "face.link.searchPh": "Cerca per nome o identità…",
    "face.link.noResults": "Nessuna persona trovata.",
    "face.link.failed": "Operazione non riuscita.",
    "account.faceTitle": "Biometria facciale",
    "account.faceHelp": "Genera un link (con QR) affinché questa persona registri il proprio volto. Potrà poi accedere con il volto nella schermata di login.",
    "face.enroll.generate": "Genera link di registrazione facciale",
    "face.enroll.regenerate": "Aggiorna registrazione facciale",
    "login.mfaInvalid": "Codice non valido. Riprova.",
    "globalConfig.secOidc": "Accesso facciale OIDC — conferma via e-mail",
    "globalConfig.oidcNote": "Nell'accesso facciale delle app esterne (OIDC), quando il match 1:N è AMBIGUO richiediamo una conferma via e-mail (codice). Questi due valori definiscono cosa è 'ambiguo'.",
    "globalConfig.oidcConf": "Margine di confidenza",
    "globalConfig.oidcConfHelp": "Di quanto il match migliore deve superare la soglia di autenticazione per essere accettato SENZA conferma via e-mail. Più alto = richiede l’e-mail più spesso (più sicuro, meno comodo).",
    "globalConfig.oidcSep": "Distacco 1º–2º",
    "globalConfig.oidcSepHelp": "Distanza minima tra i due volti più simili. Se due candidati sono troppo vicini, è ambiguo → serve l’e-mail. Più alto = più severo contro i sosia.",
    "oidc.scope.openid": "Identità (identificatore univoco)",
    "oidc.scope.profile": "Nome del profilo",
    "oidc.scope.email": "Indirizzo e-mail",
    "oidc.loadError": "Impossibile caricare la richiesta.",
    "oidc.invalidRequest": "Richiesta non valida.",
    "oidc.noEmail": "Nessuna e-mail registrata per la conferma.",
    "oidc.otpSendFailed": "Invio del codice non riuscito.",
    "oidc.otpInvalid": "Codice non valido o scaduto.",
    "oidc.unexpected": "Risposta del server inattesa.",
    "oidc.confirmFirst": "Conferma prima la tua identità via e-mail.",
    "oidc.completeFailed": "Impossibile completare.",
    "oidc.failedTitle": "Autenticazione non completata",
    "oidc.failedBody": "La verifica facciale non è stata approvata. Puoi tornare all’app e riprovare.",
    "oidc.backToApp": "Torna all’app",
    "oidc.title": "Autorizza accesso",
    "oidc.intro": "l’app",
    "oidc.client": "client",
    "oidc.introTail": "vuole accedere alla tua identità verificata con la biometria.",
    "oidc.confirmTitle": "Conferma dell’identità",
    "oidc.confirmBody": "Per la tua sicurezza, dobbiamo confermare la tua identità via e-mail",
    "oidc.sending": "Invio…",
    "oidc.sendCode": "Invia codice via e-mail",
    "oidc.confirm": "Conferma",
    "oidc.confirmed": "Identità confermata via e-mail.",
    "oidc.willShare": "Saranno condivisi",
    "oidc.deny": "Rifiuta",
    "oidc.authorize": "Autorizza",
    "oidc.alreadyConsented": "Hai già autorizzato questa app in precedenza.",
    "oidc.revokeNote": "Puoi revocare questo accesso in qualsiasi momento.",
    "globalConfig.defaultIs": "predefinito",
    "globalConfig.secLiveness": "Vivacità (liveness)",
    "globalConfig.secMatch": "Riconoscimento facciale (soglie di match)",
    "globalConfig.secAnn": "Pre-filtro di ricerca 1:N (ANN)",
    "globalConfig.flashCut": "Gate del Flashmark",
    "globalConfig.flashCutHelp": "Correlazione minima (0–1) tra i lampi di colore dello schermo e il riflesso sul volto per considerarlo VIVO. Al di sotto la sessione viene respinta come spoof (foto/schermo). Più alto = più severo contro gli schermi, ma più sensibile in ambienti molto luminosi.",
    "globalConfig.cosineNote": "Valori di similarità del coseno (0 a 1). Più alto = più severo (meno falsi positivi, ma più rifiuti di persone legittime). Lascia vuoto per usare il valore predefinito.",
    "globalConfig.authSim": "Accesso facciale (1:1 e 1:N)",
    "globalConfig.authSimHelp": "Soglia per autenticare con la biometria — sia il proprio accesso facciale (1:N tra gli utenti di sistema) sia l'autenticazione 1:1 delle applicazioni. È il parametro più sensibile per la sicurezza: alzarlo riduce il rischio di accettare la persona sbagliata (FAR), abbassarlo facilita l'accesso.",
    "globalConfig.kycSim": "KYC — selfie × documento",
    "globalConfig.kycSimHelp": "Soglia per considerare il selfie dal vivo la stessa persona della foto del documento. Di solito PIÙ BASSA del login, perché confrontare una foto stampata/vecchia con un volto dal vivo è più difficile (stampa, età, illuminazione).",
    "globalConfig.samePerson": "Gate 'stessa persona' (acquisizione)",
    "globalConfig.samePersonHelp": "Durante l’acquisizione, richiede che il volto ritagliato, il fotogramma completo e la foto del gesto siano la STESSA persona. Al di sotto la sessione viene respinta (scambio di volto / persone diverse nel video). Troppo alto può respingere acquisizioni legittime con angolazioni varie.",
    "globalConfig.matchSim": "Collegamento automatico (registro persone)",
    "globalConfig.matchSimHelp": "Nel registro Persone, soglia per collegare automaticamente una nuova acquisizione a una persona esistente nella stessa azienda. Più alto = crea più persone separate; più basso = raggruppa di più (rischio di unire persone diverse).",
    "globalConfig.dupSim": "Foto duplicata",
    "globalConfig.dupSimHelp": "Sopra questo valore due foto sono trattate come la STESSA immagine (non solo la stessa persona) e la duplicata non viene salvata. Volutamente alto; abbassarlo può scartare foto diverse valide della stessa persona.",
    "globalConfig.recognizer": "Modello di riconoscimento (ArcFace)",
    "globalConfig.recognizerDefault": "predefinito (buffalo_l)",
    "globalConfig.recognizerL": "più preciso (autenticazione)",
    "globalConfig.recognizerSc": "più leggero/veloce",
    "globalConfig.recognizerHelp": "Modello che genera la firma facciale. CAMBIARLO INVALIDA tutte le registrazioni esistenti (cambia lo spazio vettoriale) — sarà necessario ri-registrare tutti e riaddestrare il pre-filtro. Cambialo solo con un piano di migrazione.",
    "globalConfig.annNote": "Accelera la ricerca 1:N filtrando la base tramite un indice grezzo prima di confrontare (e decifrare) record per record. Non incide sulla decisione di match, solo su prestazioni e copertura della ricerca.",
    "globalConfig.nprobe": "Centroidi sondati (nprobe)",
    "globalConfig.nprobeHelp": "Quanti 'secchi' dell'indice apre la ricerca. Più alto = più candidati confrontati (recall maggiore, ma più decifrazioni e più lento); più basso = più veloce, con il rischio di saltare il match vero.",
    "globalConfig.annMin": "Minimo di registrazioni per addestrare",
    "globalConfig.annMinHelp": "Al di sotto di questa quantità il pre-filtro NON viene addestrato e la ricerca fa una scansione completa (sicura per il recall). Addestrare l’indice ha senso solo quando la base è abbastanza grande.",
    "globalConfig.retrainGrowth": "Crescita per riaddestrare",
    "globalConfig.retrainGrowthHelp": "Frazione di crescita della base (es. 0.25 = +25%) dall’ultimo addestramento per far scattare il riaddestramento automatico (nel reaper). Più alto = riaddestra meno spesso.",
    "globalConfig.retrainDelta": "Nuove registrazioni per riaddestrare",
    "globalConfig.retrainDeltaHelp": "Oltre alla percentuale, richiede almeno questa quantità di nuovi template dall’ultimo addestramento prima di riaddestrare. Evita riaddestramenti costosi per piccole variazioni.",
    "login.face.button": "Accedi con il tuo volto",
    "login.face.starting": "Avvio…",
    "login.face.failed": "La verifica facciale non è stata approvata.",
    "login.face.unavailable": "Accesso facciale non disponibile ora.",
    "face.enroll.title": "Biometria facciale",
    "face.enroll.cta": "Registra il mio volto",
    "face.enroll.manage": "Il mio volto",
    "face.enroll.hint": "Apri il link (o inquadra il QR) per registrare il tuo volto. Poi potrai accedere con il volto nella schermata di login.",
    "face.enroll.reHint": "Apri il link per aggiornare la registrazione del tuo volto. Poi potrai accedere con il volto.",
    "face.enroll.generating": "Generazione link…",
    "face.enroll.failed": "Impossibile generare il link di registrazione.",
    "face.enroll.open": "Apri registrazione",
    "bio.prefilterOn": "Pre-filtro",
    "bio.analyzed": "analizzati",
    "bio.fewer": "meno confronti esatti",
    "bio.prefilterOff": "Scansione completa",
    "bio.records": "record",
    "bio.prefilterUntrained": "pre-filtro non ancora addestrato",
    "bio.notFound": "Persona non trovata.",
    "bio.loadFailed": "Caricamento non riuscito.",
    "bio.back": "Torna alla biometria",
    "bio.notEnrolled": "Non registrato",
    "bio.authCount": "Autenticazioni",
    "bio.readings": "Letture",
    "bio.lastAuth": "Ultima",
    "bio.authentications": "Autenticazioni recenti",
    "bio.noSessions": "Nessuna sessione ancora.",
    "bio.session": "Sessione",
    "bio.date": "Data",
    "bio.mode": "Modalità",
    "bio.result": "Risultato",
    "bio.score": "Score",
    "bio.match": "Corrispondenza",
    "bio.noMatch": "Nessuna corrispondenza",
    "bio.dangerZone": "Zona di pericolo",
    "bio.noActions": "Nessuna azione disponibile.",
    "bio.searchByPhoto": "Cerca per foto",
    "bio.searching": "Ricerca…",
    "bio.errNoFace": "Nessun volto utilizzabile nella foto caricata.",
    "bio.errSearchFailed": "Ricerca per foto non riuscita.",
    "bio.sortedBySimilarity": "Ordinato per somiglianza facciale",
    "bio.matches": "corrispondenza/e",
    "bio.clear": "cancella",
    "bio.similarity": "Somiglianza",
    "bio.noMatches": "Nessuna persona simile trovata.",
    // Muro live (video wall del liveness)
    "nav.wall": "Muro",
    "wall.title": "Muro live",
    "wall.screens": "Schermi",
    "wall.cameras": "Telecamere",
    "wall.both": "Schermi + Telecamere",
    "wall.emptyBoth": "Nessuna sessione live.",
    "nav.eventWall": "Muro evento",
    "nav.health": "Salute",
    "nav.jobsQueue": "Coda lavori",
    "nav.reviewQueue": "Revisione",
    "nav.coldSync": "Sincronizzazione",
    "nav.coldStorage": "Cold Storage",
    "health.title": "Salute",
    "health.subtitle": "Salute della cattura live per partecipante.",
    "health.problems": "{n} con problemi",
    "health.refresh": "Aggiorna",
    "health.loading": "Caricamento…",
    "health.empty": "Nessuna sessione live.",
    "health.audio": "Audio",
    "eventwall.title": "Muro evento",
    "eventwall.event": "Evento",
    "eventwall.noEvents": "Nessun evento live",
    "eventwall.presets": "Preset",
    "eventwall.presetTop": "Top 10 (posizione)",
    "eventwall.presetCombo": "Top 8 (Schermo + Telecamera)",
    "eventwall.presetAll": "Tutti",
    "eventwall.presetsHint": "Preset personalizzati in arrivo.",
    "eventwall.empty": "Nessun partecipante live in questo evento.",
    "eventwall.countries": "Paesi",
    "eventwall.participants": "Partecipanti",
    "eventwall.performance": "PRESTAZIONI",
    "eventwall.live": "(LIVE)",
    "eventwall.score": "Punteggio",
    "eventwall.solved": "Sfide Risolte",
    "eventwall.lastSubmit": "Ultimo Invio",
    "eventwall.points": "PUNTI",
    "eventwall.challenges": "SFIDE",
    "eventwall.overallProgress": "PROGRESSO GENERALE",
    "eventwall.officialTime": "ORARIO UFFICIALE",
    "eventwall.category": "Categoria ultimo invio",
    "eventwall.ago": "fa",
    "eventwall.pts": "pts",
    "eventwall.castObs": "Mostra questo nell'output OBS",
    "eventwall.castObsActive": "Live su OBS",
    "eventwall.castHint": "Il pulsante di trasmissione invia il preset (con la scelta attuale Schermi/Telecamere) all'output OBS in tempo reale.",
    "recording.obsEnable": "Abilita URL OBS",
    "recording.obsHint": "Output pubblico del Muro evento per OBS Browser — senza login, limitato agli IP client sotto.",
    "recording.obsIps": "IP client OBS",
    "recording.obsUrl": "URL OBS Browser",
    "recording.obsUrlHint": "Incolla in una sorgente 'Browser' di OBS. Aggiungi ?kind=camera o ?preset=all per cambiare vista.",
    "wall.screen": "Schermo",
    "wall.camera": "Telecamera",
    "wall.live": "Live",
    "wall.offline": "Offline",
    "wall.listen": "Ascolta",
    "wall.mute": "Silenzia",
    "wall.expand": "Apri a schermo intero",
    "wall.refresh": "Aggiorna",
    "wall.loading": "Caricamento…",
    "wall.participant": "partecipante",
    "wall.liveCount": "{n} live",
    "wall.emptyScreens": "Nessuna sessione live che condivide lo schermo.",
    "wall.emptyCameras": "Nessuna sessione live che condivide la telecamera.",
    "wall.unsupported": "Questo browser non può decodificare il muro live. Usa Chrome o Edge.",
    "login.email": "E-mail",
    "login.email.placeholder": "tu@esempio.com",
    "login.password": "Password",
    "login.password.placeholder": "Inserisci la password",
    "login.submit": "Accedi",
    "login.continue": "Continua",
    "login.back": "← Indietro",
    "login.or": "o",
    "login.newPassword": "Nuova password",
    "login.confirmPassword": "Conferma password",
    "login.saveAndEnter": "Salva ed entra",
    "login.contestant.title": "Accesso del partecipante",
    "login.contestant.subtitle": "Accedi con la tua e-mail e password.",
    "login.contestant.help": "Problemi ad accedere? Contatta il supervisore del tuo esame.",
    "sessionAuth.title": "Accesso all'esame",
    "sessionAuth.subtitle": "Inserisci il token di sessione ricevuto per iniziare il tuo esame.",
    "sessionAuth.token": "Token di sessione",
    "sessionAuth.token.placeholder": "Incolla il tuo token di sessione",
    "sessionAuth.submit": "Entra",
    "sessionAuth.invalid": "Token di sessione non valido o scaduto.",
    "sessionAuth.help": "Problemi ad accedere? Contatta il supervisore del tuo esame.",
    "login.setPassword.title": "Imposta una nuova password",
    "login.setPassword.subtitle": "È necessario cambiare la password al primo accesso.",
    "login.system.title": "Accedi al sistema",
    "login.system.emailSubtitle": "Inserisci l'e-mail registrata nel sistema.",
    "login.system.emailHelp": "Se non ricordi la tua e-mail registrata, contattaci a",
    "login.system.passwordSubtitle": "Inserisci la password del tuo account per continuare.",
    "login.oidc": "Accedi con Office 365",
    "login.mfa.subtitle": "Inserisci il codice di 6 cifre inviato alla tua e-mail.",
    "login.mfa.submit": "Convalida codice",
    "login.mfa.notReceived": "Non hai ricevuto il codice?",
    "login.mfa.resend": "Invia di nuovo",
    "login.change.title": "Cambia password",
    "login.change.subtitle": "La password deve essere cambiata prima di continuare.",
    "login.change.newPlaceholder": "Inserisci la nuova password",
    "login.change.confirmPlaceholder": "Conferma la nuova password",
    "login.pw.min8": "Almeno 8 caratteri",
    "login.pw.upper": "Lettera maiuscola",
    "login.pw.lower": "Lettera minuscola",
    "login.pw.special": "Carattere speciale",
    "login.pw.match": "Le password coincidono",
    "error.invalidCredentials": "Credenziali non valide.",
    "error.wrongPassword": "Password errata. Riprova.",
    "error.passwordsMismatch": "Le password non coincidono.",
    "error.changePassword": "Impossibile cambiare la password.",
    "error.mfaIncomplete": "Inserisci il codice completo di 6 cifre.",
    "nav.dashboard": "Dashboard",
    "nav.console": "Console",
    "nav.admin": "Admin",
    "nav.contestants": "Partecipanti",
    "nav.accounts": "Account",
    "nav.clientApps": "App client",
    "nav.verifications": "Verifiche",
    "nav.people": "Persone",
    "nav.biometrics": "Biometria",
    "nav.global": "Globale",
    "account.listSubtitle": "Utenti di sistema (amministratori dell'istituto e liveness).",
    "account.empty": "Ancora nessun account.",
    "account.new": "Nuovo account",
    "account.edit": "Modifica account",
    "account.newSubtitle": "Crea o modifica un utente di sistema (admin / liveness).",
    "account.removeTitle": "Rimuovi account",
    "account.registered": "Account creato",
    "account.role": "Ruolo",
    "account.role.institution_admin": "Admin dell'istituto",
    "account.role.liveness": "Liveness",
    "account.role.super": "Super Admin",
    "account.loadError": "Impossibile caricare l'account.",
    "account.saveError": "Impossibile salvare l'account.",
    "nav.exams": "Esami",
    "nav.events": "Eventi",
    "nav.examsEvents": "Esami / Eventi",
    "nav.configuration": "Configurazione",
    "nav.companies": "Aziende",
    "nav.settings": "Impostazioni",
    "nav.ai": "IA",
    "nav.jobs": "Jobs",
    "ai.title": "IA",
    "ai.subtitle": "Server Ollama per affinare i rilevamenti",
    "ai.ollamaUrl": "URL di Ollama",
    "ai.visionModel": "Modello di visione",
    "ai.enabled": "Affinamento con Ollama",
    "ai.enabledHelp": "Quando è disattivato, i rilevamenti usano solo i modelli locali (nessun affinamento LLM).",
    "ai.testConnectivity": "Prova connessione",
    "ai.testOk": "Connessione OK",
    "ai.testFailed": "Connessione fallita",
    "ai.modelsFound": "Modelli disponibili",
    "ai.modelPresent": "Il modello selezionato è installato",
    "ai.modelMissing": "Modello selezionato NON trovato sul server",
    "common.close": "Chiudi",
    "common.saved": "Salvato",
    "nav.logout": "Esci",
    "dash.title": "Dashboard",
    "dash.subtitle": "Analytics in tempo reale delle sessioni della tua istituzione.",
    "dash.realtime": "Tempo reale",
    "dash.now": "ora",
    "dash.activeSessions": "Sessioni attive",
    "dash.sessionsByTarget": "Sessioni per evento / esame",
    "dash.modeExam": "Esame",
    "dash.modeEvent": "Evento",
    "dash.noSessions": "Nessuna sessione in diretta al momento.",
    "dash.liveOrigin": "Visitatori in diretta",
    "dash.cities": "città",
    "dash.sessions": "Sessioni",
    "dash.byProfile": "dalla città del profilo",
    "dash.withoutCoords": "senza coordinate",
    "dash.devices": "Devices",
    "dash.throughput": "Throughput",
    "dash.throughputHint": "media · ultimo 1 min",
    "dash.traffic": "Traffico del server",
    "dash.perMinute": "Al minuto · ultimi 30 min",
    "dash.perSecond": "Al secondo · ultimi 60s",
    "dash.healthTitle": "Salute delle sessioni",
    "dash.healthHint": "top 10 connessi · problemi per primi",
    "dash.participant": "Partecipante",
    "dash.target": "Evento / esame",
    "dash.status": "Stato",
    "dash.healthy": "In salute",
    "dash.unhealthy": "Con problemi",
    "dash.recordingFailure": "Errore di registrazione",
    "dash.rate": "Velocità",
    "dash.total": "Totale",
    "dash.source.screen": "Schermo",
    "dash.source.camera": "Videocamera",
    "dash.source.audio": "Audio",
    "dash.sourceOk": "In trasmissione",
    "dash.sourceBad": "Nessuna trasmissione",
    "dash.sourceNa": "Non richiesto",
    "dash.countriesCities": "Paesi e città",
    "dash.countryCity": "Paese / città",
    "dash.noCountryData": "Nessun dato sui paesi al momento.",
    "dash.topIps": "Top IPs",
    "dash.ip": "IP",
    "dash.location": "Posizione",
    "dash.noIps": "Nessun IP al momento.",
    "common.name": "Nome",
    "common.firstName": "Nome",
    "common.lastName": "Cognome",
    "common.phone": "Telefono",
    "common.language": "Lingua",
    "common.country": "Paese",
    "common.company": "Azienda",
    "common.selectCompany": "Seleziona l'azienda...",
    "common.actions": "Azioni",
    "common.edit": "Modifica",
    "common.remove": "Rimuovi",
    "common.cancel": "Annulla",
    "common.save": "Salva",
    "common.create": "Crea",
    "common.back": "Indietro",
    "common.add": "Aggiungi",
    "common.confirmRemove": "Sei sicuro di voler rimuovere",
    "contestant.new": "Nuovo Partecipante",
    "contestant.listSubtitle": "Registra e gestisci i partecipanti della tua istituzione.",
    "contestant.edit": "Modifica Partecipante",
    "contestant.empty": "Nessun partecipante registrato.",
    "contestant.removeTitle": "Rimuovere il partecipante?",
    "contestant.newSubtitle": "Registra un partecipante. Una password iniziale verrà generata e mostrata una sola volta.",
    "contestant.editSubtitle": "Modifica i dati del partecipante. La password non viene cambiata qui.",
    "contestant.registered": "Partecipante registrato",
    "contestant.saveNote": "Annota la password iniziale — non sarà mostrata di nuovo.",
    "contestant.initialPassword": "Password iniziale",
    "contestant.copy": "Copia",
    "contestant.copied": "Copiato!",
    "contestant.done": "Fine",
    "contestant.password": "Password",
    "contestant.policy.blocked": "Password bloccata",
    "contestant.policy.mustChange": "Cambia all'accesso",
    "contestant.policy.free": "Libera",
    "contestant.mustChange": "Richiedi il cambio password al primo accesso",
    "contestant.cannotChange": "Non consentire al partecipante di cambiare la password",
    "contestant.exclusive": "Le due opzioni si escludono a vicenda.",
    "contestant.policyLabel": "Politica della password",
    "contestant.emailPlaceholder": "partecipante@esempio.com",
    "error.loadContestant": "Impossibile caricare il partecipante.",
    "error.saveContestant": "Impossibile salvare il partecipante. Verifica i dati.",
    "recording.empty": "Nulla registrato.",
    "recording.start": "Inizio",
    "recording.scope": "Ambito",
    "recording.scope.national": "Nazionale",
    "recording.scope.international": "Internazionale",
    "common.state": "Stato",
    "common.state.placeholder": "Stato / regione",
    "common.city": "Città",
    "common.city.placeholder": "Città",
    "recording.end": "Fine",
    "recording.duration": "Durata",
    "duration.day": "giorno",
    "duration.days": "giorni",
    "duration.hour": "ora",
    "duration.hours": "ore",
    "duration.minute": "minuto",
    "duration.minutes": "minuti",
    "duration.and": "e",
    "console.title": "Console del Liveness",
    "console.subtitle": "Sessioni monitorate della tua istituzione.",
    "console.all": "Tutte",
    "console.onlyLive": "Solo in diretta",
    "console.refresh": "Aggiorna",
    "console.empty": "Nessuna sessione al momento.",
    "console.emptyLive": "Nessuna sessione in diretta al momento.",
    "console.participant": "Partecipante",
    "console.event": "Evento",
    "console.system": "Sistema",
    "console.status": "Stato",
    "console.start": "Inizio",
    "console.examTime": "Tempo d'esame",
    "console.traffic": "Traffico",
    "console.trafficHint": "Totale trasferito dagli stream di ingestione della sessione",
    "console.trafficRateHint": "Velocità attuale",
    "console.files": "File",
    "console.filesHint": "Dimensione totale dei file registrati (camera, schermo, audio)",
    "console.live": "In diretta",
    "console.reconnect": "Forza la riconnessione del client",
    "console.telemetry": "Telemetria (console del client + eventi interni)",
    "console.review": "Rivedi",
    "console.reviewLiveness": "Revisione vivacità",
    "console.noLiveness": "Nessuna acquisizione di vivacità per questa sessione",
    "console.disconnected": "Disconnesso",
    "console.waitingStart": "In attesa di iniziare",
    "console.recordingFailure": "Errore di registrazione",
    "console.warning": "Avviso",
    "console.transportWebrtc": "WebRTC (LiveKit, legacy)",
    "console.transportWebcodecs": "WebCodecs su WebSocket",
    "console.reconnectTitle": "Forza riconnessione",
    "console.reconnectBody": "Il client di {name} si riconnetterà silenziosamente (riacquisisce microfono/fotocamera e riavvia gli invii). Si verifica una breve interruzione di ~1–2s nella registrazione. Continuare?",
    "console.reconnectConfirm": "Riconnetti",
    "console.reconnectError": "Impossibile richiedere la riconnessione.",
    "console.reconnectRequested": "Riconnessione richiesta — il client si riconnetterà a breve.",
    "console.participantFallback": "partecipante",
    "console.sessionScope": "sessione",
    "console.kindClientDisconnected": "connessione del partecipante caduta",
    "console.kindStorageStalled": "la registrazione non viene archiviata",
    "console.kindStreamMissing": "stream obbligatorio non avviato",
    "console.kindVideoFrozen": "video congelato (immagine ferma)",
    "console.kindNoInput": "nessun invio di media dal partecipante",
    "recording.requirements": "Requisiti",
    "recording.camera": "Videocamera",
    "recording.audio": "Audio",
    "recording.screen": "Schermo",
    "recording.requirementsLabel": "Requisiti di registrazione",
    "recording.requiresCamera": "Richiede videocamera",
    "recording.requiresAudio": "Richiede audio",
    "recording.requireLiveness": "Richiedi liveness (acquisizione identità)",
    "recording.requireLivenessHint": "Prima di condividere schermo/audio il partecipante deve superare un'acquisizione di liveness dalla videocamera (registrata), indipendentemente dal fatto che la videocamera sia richiesta.",
    "recording.livenessAllowNoGeo": "Consenti al partecipante di non concedere la geolocalizzazione",
    "recording.livenessAiThreshold": "Soglia IA del liveness (%)",
    "recording.livenessAiThresholdHint": "Probabilità IA a partire dalla quale il liveness e il gesto vengono accettati. Separata dalla soglia anti-cheat.",
    "recording.requiresScreen": "Richiede schermo",
    "recording.allowExternalCamera": "Consenti fotocamera esterna (telefono)",
    "recording.requiresExternalCamera": "Richiede fotocamera esterna",
    "recording.antiCheat": "Analisi anti-imbroglio",
    "recording.analyzeRecordings": "Analizza le registrazioni (persona extra, assenza, IA sullo schermo)",
    "recording.detectExtraPerson": "Persona in più",
    "recording.detectAbsence": "Assenza",
    "recording.detectAiOnScreen": "IA sullo schermo",
    "recording.maxCameras": "Max videocamere (escluse esterne)",
    "recording.monitorTabSwitch": "Segnala cambio scheda/finestra (esame a scheda singola)",
    "recording.sectionRecord": "Cosa registrare",
    "recording.sectionMonitor": "Cosa monitorare / analizzare",
    "recording.absenceSeconds": "Soglia di assenza (secondi fuori dalla videocamera prima di segnalare)",
    "recording.aiThreshold": "Soglia di conferma IA (%)",
    "recording.aiThresholdHint": "Probabilità IA oltre la quale un rilevamento è confermato automaticamente; sotto, attende la revisione del liveness. 0 conferma tutto.",
    "capture.addCamera": "Aggiungi videocamera",
    "capture.noMoreCameras": "Nessuna videocamera aggiuntiva rilevata su questo dispositivo.",
    "review.findings.title": "Analisi automatica",
    "review.findings.empty": "Nessun rilevamento automatico.",
    "review.finding.multi_person": "Più persone davanti alla videocamera",
    "review.finding.absent": "Lo studente si è allontanato dalla videocamera",
    "review.finding.returned": "Lo studente è tornato davanti alla videocamera",
    "review.finding.ai_on_screen": "IA sullo schermo",
    "review.finding.tab_switch": "Ha cambiato scheda/finestra durante l'esame",
    "review.finding.confidence": "affidabilità",
    "recording.durationLabel": "Durata (minuti) — 0 = non definito",
    "recording.maxScreens": "Max schermi",
    "recording.logo": "Logo (ridimensionata automaticamente a 200×200, sfondo trasparente)",
    "recording.formSubtitle": "Configura i dati e i requisiti di registrazione.",
    "recording.allowedIps": "IP / sottoreti consentiti",
    "recording.allowedIps.placeholder": "Es: 192.168.0.0/24",
    "recording.allowedIps.hint": "Lascia vuoto per consentire qualsiasi indirizzo. Il partecipante potrà accedere solo da questi.",
    "recording.removeTitle": "Rimuovere?",
    "recording.loadError": "Impossibile caricare il record.",
    "recording.saveError": "Impossibile salvare. Verifica i dati.",
    "recording.contestants": "Partecipanti",
    "recording.contestants.empty": "Nessuno iscritto ancora.",
    "recording.selectContestant": "Seleziona un partecipante...",
    "recording.enroll": "Iscrivi",
    "recording.enrollment.expired": "scaduta",
    "recording.enrollment.renew": "Rinnova",
    "recording.schedule.title": "Orari di accesso",
    "recording.schedule.add": "Aggiungi orario",
    "recording.schedule.empty": "Nessun orario — l'accesso copre l'intero periodo dell'evento.",
    "recording.schedule.hint": "Senza orari: l'accesso è disponibile per tutto il periodo dell'evento. Con orari: l'accesso apre 15 minuti prima di ogni fascia e termina esattamente alla fine della stessa.",
    "recording.profile": "Profilo di registrazione",
    "recording.profile.default": "Predefinito dell'azienda",
    "nav.profiles": "Profili di registrazione",
    "nav.recording": "Recording",
    "nav.simulation": "Simulazione",
    "sim.title": "Simulazione di capacità",
    "sim.subtitle": "Quanto costa un gruppo su un profilo di registrazione — misurato, non stimato.",
    "sim.profile": "Profilo di registrazione",
    "sim.clients": "Partecipanti",
    "sim.minutes": "Tempo di registrazione (minuti)",
    "sim.run": "Simula",
    "sim.measuring": "Codifica di un campione con i parametri di questo profilo…",
    "sim.idle": "Inattivo",
    "sim.busy": "Occupato",
    "sim.idleHint": "schermo fermo — a cui le sessioni reali somigliano di più",
    "sim.busyHint": "immagine che cambia a ogni frame — il caso peggiore da pianificare",
    "sim.uplink": "Banda di ingestione",
    "sim.storage": "Archiviazione",
    "sim.perClient": "per partecipante",
    "sim.total": "totale",
    "sim.perHour": "per partecipante-ora",
    "sim.sockets": "WebSockets",
    "sim.sources": "Sorgenti per partecipante",
    "sim.measured": "Misurato su questo server",
    "sim.notMeasured": "Impossibile misurare — cifre non disponibili",
    "sim.rangeWhy": "Tutto è un intervallo perché il traffico è deciso da ciò che mostra lo schermo del partecipante, che nessuna misura qui può sapere. Le sessioni reali misurate sono vicine all'estremo inattivo.",
    "sim.detail": "Misurato per sorgente",
    "sim.uplinkCol": "Ingestione",
    "sim.storedCol": "Archiviato",
    "sim.error": "Impossibile simulare.",
    "nav.apiTokens": "Token API",
    "nav.agents": "Agenti",
    "agent.title": "Agenti",
    "agent.subtitle": "Macchine che servono questa installazione.",
    "agent.name": "Agente",
    "agent.status.label": "Stato",
    "agent.status.online": "Online",
    "agent.status.offline": "Offline",
    "agent.status.draining": "In svuotamento",
    "agent.kind.websocket": "WebSocket (ingestione)",
    "agent.kind.encoder": "Encoder",
    "agent.kind.all_in_one": "Macchina unica",
    "agent.ip": "IP",
    "agent.cpu": "CPU",
    "agent.memory": "Memoria",
    "agent.disk": "Disco libero",
    "agent.sessions": "Sessioni",
    "agent.traffic": "Traffico",
    "agent.heartbeat": "Heartbeat",
    "agent.empty": "Nessun agente registrato.",
    "agent.error": "Impossibile caricare gli agenti.",
    "agent.secondsAgo": "{n}s fa",
    "agent.minutesAgo": "{n}min fa",
    "nav.webhooks": "Webhooks",
    "webhook.title": "Webhooks",
    "webhook.subtitle": "Invia avvisi di eventi (online/offline, inizio/fine sessione, salute, marcatori) a sistemi esterni.",
    "webhook.new": "Nuovo webhook",
    "webhook.edit": "Modifica webhook",
    "webhook.empty": "Ancora nessun webhook.",
    "webhook.events": "Eventi",
    "webhook.allEvents": "Tutti gli eventi",
    "webhook.eventsHint": "Lascia tutto deselezionato per ricevere ogni evento.",
    "webhook.secret": "Segreto di firma",
    "webhook.secretHint": "Ogni consegna e firmata con HMAC-SHA256 (intestazione X-Webhook-Signature).",
    "webhook.urlHint": "Destinazione POST. Payload: {event, email, session_id, timestamp, session_health}.",
    "webhook.enabled": "Attivo",
    "webhook.create": "Crea webhook",
    "webhook.rotate": "Ruota segreto",
    "webhook.rotateConfirm": "Ruotare il segreto di firma? Quello attuale smette di funzionare subito.",
    "webhook.test": "Invia evento di test",
    "webhook.testOk": "Consegnato",
    "webhook.testFail": "Fallito",
    "webhook.namePlaceholder": "es. Gateway VPN",
    "webhook.nameRequired": "Il nome e obbligatorio.",
    "webhook.urlRequired": "URL obbligatorio.",
    "webhook.loadError": "Impossibile caricare il webhook.",
    "webhook.saveError": "Impossibile salvare il webhook.",
    "common.copy": "Copia",
    "apiToken.title": "Token API",
    "apiToken.subtitle": "Credenziali per sistemi esterni per chiamare l'API pubblica (X-Api-Token).",
    "apiToken.new": "Nuovo token",
    "apiToken.edit": "Modifica token",
    "apiToken.create": "Crea token",
    "apiToken.empty": "Ancora nessun token API.",
    "apiToken.namePlaceholder": "Es: Sistema di liveness",
    "apiToken.nameRequired": "Inserisci un nome.",
    "apiToken.token": "Token (X-Api-Token)",
    "apiToken.tokenHint": "Invialo nell'header X-Api-Token. Tienilo segreto.",
    "apiToken.show": "Mostra",
    "apiToken.hide": "Nascondi",
    "apiToken.ipAcl": "Elenco IP di origine",
    "apiToken.ipAclHint": "IP o CIDR separati da virgola. Vuoto = qualsiasi IP.",
    "apiToken.anyIp": "qualsiasi IP",
    "apiToken.rateLimit": "Limite (richieste al minuto)",
    "apiToken.rateLimitHint": "0 = nessun limite.",
    "apiToken.noLimit": "nessun limite",
    "apiToken.enabled": "Attivo",
    "apiToken.permissions": "Permessi",
    "apiToken.permissionsHint": "Quali famiglie di endpoint di integrazione può chiamare questo token.",
    "apiToken.permExam": "API Esami (/api/integration/exam/*)",
    "apiToken.permEvent": "API Eventi (/api/integration/event/*)",
    "apiToken.usage": "Uso — add_marker",
    "apiToken.usageHint": "Aggiunge un marcatore al timestamp (un flag, una nota, qualsiasi cosa) e crea un'esportazione mosaico da 60s prima a 60s dopo.",
    "apiToken.rotate": "Ruota",
    "apiToken.rotateConfirm": "Generare un nuovo token? Quello attuale smetterà di funzionare immediatamente.",
    "apiToken.loadError": "Errore nel caricare il token.",
    "apiToken.saveError": "Errore nel salvare.",
    "apiToken.examplesTitle": "API di integrazione esami — esempi di richiesta",
    "apiToken.examplesIntro": "Autentica ogni richiesta con l'header X-Api-Token. URL base:",
    "apiToken.eventsExamplesTitle": "API di integrazione Eventi — esempi di richiesta",
    "apiToken.markerExamplesTitle": "API di integrazione Marcatori — esempi di richiesta",
    "apiToken.markerExamplesIntro": "Autentica con l'header X-Api-Token. Endpoint:",
    "apiToken.exampleListDesc": "Elenca gli esami disponibili di questa azienda.",
    "apiToken.exampleStartDesc": "Avvia la sessione di un esame per uno studente. Crea lo studente se necessario e restituisce un token di sessione — lo studente accede su /session_auth solo con quel token (senza e-mail/password). La password di uno studente esistente non viene mai modificata.",
    "apiToken.exampleStatusDesc": "Ottiene lo stato della sessione d'esame dello studente tramite e-mail.",
    "apiToken.exampleStopDesc": "Termina una sessione d'esame aperta tramite e-mail (o session_id).",
    "apiToken.copy": "Copia",
    "apiToken.copied": "Copiato!",
    "apiToken.parameters": "Parametri",
    "apiToken.responses": "Risposte",
    "apiToken.request": "Richiesta",
    "apiToken.required": "obbligatorio",
    "apiToken.paramName": "Nome",
    "apiToken.paramDesc": "Descrizione",
    "apiToken.opListSummary": "Elenca gli esami disponibili",
    "apiToken.opStartSummary": "Avvia una sessione d'esame",
    "apiToken.opStatusSummary": "Stato della sessione dello studente",
    "apiToken.opStopSummary": "Termina una sessione d'esame",
    "apiToken.opMarkerSummary": "Aggiungi un indicatore (+ esportazione mosaico ±60s)",
    "apiToken.pMarkerTarget": "La sessione di destinazione, tramite UUID o l'e-mail del partecipante (risolve la sessione attiva in quel momento).",
    "apiToken.pMarkerTimestamp": "Istante ISO-8601 dell'indicatore (es. 2026-07-08T20:58:45Z).",
    "apiToken.pMarkerDescription": "Nota di testo libero mostrata sull'indicatore.",
    "apiToken.pToken": "Token API emesso per la tua azienda.",
    "apiToken.pEmail": "E-mail dello studente.",
    "apiToken.pName": "Nome completo dello studente (oppure usa first_name / last_name).",
    "apiToken.pExam": "L'esame da svolgere — il suo id (exam_id) O il suo nome (exam_name).",
    "apiToken.pStatusEmail": "E-mail dello studente da consultare.",
    "apiToken.pStopTarget": "session_id, o l'e-mail dello studente (opzionalmente ristretto con exam_id / exam_name).",
    "apiToken.rOk": "Successo.",
    "apiToken.rCreated": "Sessione creata (200 se è stata riutilizzata una sessione aperta).",
    "apiToken.rBadRequest": "Campi obbligatori mancanti.",
    "apiToken.rExamNotFound": "Esame non trovato per l'azienda di questo token.",
    "apiToken.rUnauthorized": "Token mancante o non valido.",
    "apiToken.rSessionNotFound": "Nessuna sessione d'esame aperta trovata.",
    "profile.new": "Nuovo profilo",
    "profile.edit": "Modifica profilo",
    "profile.subtitle": "Profili di registrazione riutilizzati da esami ed eventi.",
    "profile.empty": "Nessun profilo registrato ancora.",
    "profile.maxMonitors": "Max monitor",
    "profile.maxCameras": "Max videocamere",
    "profile.audioEnabled": "Audio abilitato",
    "profile.allowExternalCamera": "Consenti fotocamera esterna (telefono)",
    "profile.videoFps": "FPS video",
    "profile.sampleRate": "Frequenza di campionamento audio (kHz)",
    "profile.cameraRes": "Risoluzione max videocamera",
    "profile.screenRes": "Risoluzione max schermo",
    "profile.segment": "Durata del segmento (minuti)",
    "recording.exam.singular": "Esame",
    "recording.exam.new": "Nuovo Esame",
    "recording.exam.edit": "Modifica Esame",
    "recording.exam.listSubtitle": "Registra esami e i loro requisiti di registrazione.",
    "recording.event.singular": "Evento",
    "recording.event.new": "Nuovo Evento",
    "recording.event.edit": "Modifica Evento",
    "recording.event.listSubtitle": "Registra eventi e i loro requisiti di registrazione.",
    "company.listSubtitle": "Gestisci le aziende registrate nel sistema.",
    "company.new": "Nuova Azienda",
    "company.edit": "Modifica Azienda",
    "company.newSubtitle": "Compila i dati per registrare una nuova azienda.",
    "company.editSubtitle": "Modifica i dati e le impostazioni dell'azienda.",
    "company.empty": "Nessuna azienda registrata.",
    "company.deleteTitle": "Eliminare l'azienda?",
    "company.namePlaceholder": "Nome dell'azienda",
    "company.canSetLang": "Il partecipante può scegliere la lingua",
    "company.canSetLang.desc": "Se disattivato, la lingua del partecipante sarà sempre quella dell'azienda.",
    "company.createdAt": "Creato il",
    "company.tab.data": "Dati",
    "company.tab.policy": "Politica della Password",
    "error.loadCompany": "Errore nel caricamento dell'azienda.",
    "error.saveCompany": "Errore nel salvataggio dell'azienda.",
    "policy.title": "Politica della Password",
    "policy.minLength": "Lunghezza Minima",
    "policy.requireUpper": "Richiedi lettera maiuscola",
    "policy.requireLower": "Richiedi lettera minuscola",
    "policy.requireSpecial": "Richiedi carattere speciale",
    "policy.blacklist": "Parole Bloccate",
    "policy.blacklistPlaceholder": "Es: admin",
    "policy.saved": "Politica della password salvata con successo.",
    "error.savePolicy": "Errore nel salvataggio della politica della password.",
    "settings.saved": "Impostazioni salvate con successo.",
    "error.saveSettings": "Errore nel salvataggio delle impostazioni.",
    "settings.saving": "Salvataggio...",
    "settings.save": "Salva Impostazioni",
    "settings.title": "Impostazioni Generali",
    "settings.subtitle": "Configura i parametri generali del sistema",
    "common.loading": "Caricamento...",
    "oidc.completing": "Completamento accesso...",
    "oidc.failed": "Accesso non riuscito",
    "oidc.wait": "Attendere, convalida dell'autenticazione SSO.",
    "oidc.backToLogin": "Torna al login",
    "error.oidcInvalid": "Risposta OIDC non valida.",
    "error.oidcFailed": "Impossibile completare l'accesso SSO.",
    "contestant.home.title": "I tuoi esami ed eventi",
    "contestant.home.subtitle": "Selezionane uno per iniziare.",
    "contestant.home.empty": "Nessun esame o evento disponibile al momento.",
    "capture.consent": "Ho letto e accetto di essere monitorato",
    "capture.start": "Avvia Registrazione",
    "capture.recording": "Registrazione…",
    "capture.reconnecting": "Riconnessione…",
    "capture.audioAlertTitle": "Attiva gli avvisi audio",
    "capture.audioAlertBody": "Questa schermata riproduce un allarme sonoro se uno dei tuoi media (schermo, webcam o microfono) si disconnette durante l'esame. Il browser ha bisogno del tuo permesso per riprodurre l'audio.",
    "capture.audioAlertEnable": "Attiva audio",
    "capture.audioAlertLater": "Non ora",
    "capture.finish": "Termina registrazione",
    "capture.ending": "Terminando…",
    "capture.pause": "Metti in pausa la registrazione",
    "capture.pausing": "In pausa…",
    "capture.addScreen": "Aggiungi schermo",
    "capture.enable": "Attiva",
    "capture.active": "Attivo",
    "capture.micActive": "Microfono attivo",
    "capture.required": "Obbligatorio",
    "capture.gate": "Aggiungi tutte le risorse richieste e accetta il monitoraggio per iniziare.",
    "watchdog.restartTitle": "Ricondividi per riprendere la registrazione",
    "watchdog.restartBody": "Lo schermo o la videocamera ha smesso di inviare al server (il browser non riesce più a leggere la sorgente). Fai clic sotto per riacquisire le sorgenti e riprendere — apparirà il selettore dello schermo. Non serve ricaricare la pagina.",
    "watchdog.restartNow": "Ricondividi e riprendi",
    "watchdog.dismiss": "Ignora",
    "capture.externalCamera": "Fotocamera esterna",
    "capture.addExternalCamera": "Aggiungi fotocamera esterna",
    "capture.extCamDown": "La fotocamera esterna è disconnessa. Riconnettila per continuare a essere monitorato.",
    "capture.extCamRequiredDown": "Questo esame RICHIEDE una fotocamera esterna (telefono) e non è connessa. Connettila ora.",
    "capture.extCamReconnect": "Riconnetti fotocamera",
    "capture.externalHint": "Usa il telefono come fotocamera extra scansionando un codice QR.",
    "capture.externalNeedRecording": "Avvia la registrazione per aggiungere una fotocamera esterna.",
    "capture.externalChoose": "Come verrà usata la fotocamera del telefono?",
    "capture.externalPrimary": "Fotocamera principale",
    "capture.externalSecondary": "Fotocamera secondaria",
    "capture.externalScan": "Scansiona questo codice QR col telefono e consenti l'accesso alla fotocamera.",
    "capture.externalWaiting": "In attesa che il telefono si connetta…",
    "capture.externalConnected": "Fotocamera esterna connessa",
    "capture.close": "Chiudi",
    "pair.title": "Fotocamera esterna",
    "pair.live": "Dal vivo",
    "pair.connecting": "Connessione…",
    "pair.streaming": "La tua fotocamera sta trasmettendo alla sessione.",
    "pair.switch": "Cambia fotocamera",
    "pair.keepOpen": "Tieni aperta questa pagina durante l'esame.",
    "pair.denied": "Permesso fotocamera negato. Consentilo e riprova.",
    "pair.retry": "Riprova",
    "pair.expired": "Questo link non è valido o è scaduto. Richiedi un nuovo codice QR.",
    "pair.error": "Impossibile connettersi. Riprova.",
    "pair.unsupported": "Il browser di questo telefono non può essere usato come fotocamera. Gli iPhone non sono supportati (nessun browser su iOS, incluso Chrome, ha la cattura necessaria). Usa un telefono Android con Google Chrome e scansiona di nuovo il codice QR.",
    "pair.ended": "Sessione terminata — puoi chiudere questa pagina.",
    "error.captureLoad": "Impossibile caricare questo esame/evento.",
    "error.mediaDenied": "Autorizzazione negata o dispositivo non disponibile.",
    "capture.unsupportedTitle": "Browser non supportato",
    "capture.unsupportedBody": "Questo browser non supporta il motore video necessario per l'acquisizione. Usa l'ultima versione di Google Chrome o Microsoft Edge per svolgere questo esame.",
    // --- added: SecFace liveness/admin screens ---
    "biometric.title": "API biometrica — persone e foto",
    "biometric.introAuth": "Autentica con l'header",
    "biometric.introAt": "su",
    "biometric.introScopePre": "Richiede l'ambito",
    "biometric.scopeName": "API biometrica",
    "biometric.introScopePost": "nel token; allowlist di IP e rate limit vengono applicati, e ogni chiamata è registrata nel registro di audit.",
    "biometric.addSummary": "Registra/aggiorna una persona",
    "biometric.addDesc": "Upsert: cerca per documento (document_type + document) e poi per intersezione di e-mail; se non trova, crea. I campi vengono uniti (le e-mail vengono unite; i campi vuoti non cancellano mai i valori). Richiede almeno un'e-mail o un documento.",
    "biometric.pEmails": "Elenco delle e-mail della persona (accetta anche un singolo \"email\").",
    "biometric.pDocumentType": "Tipo di documento (es. cpf, rg, passport). Obbligatorio quando viene inviato document.",
    "biometric.pDocument": "Numero del documento.",
    "biometric.pMobilePhone": "Telefono cellulare.",
    "biometric.rCreated": "Persona creata.",
    "biometric.rUpdated": "La persona esisteva già — dati uniti/aggiornati.",
    "biometric.rBadRequest": "Senza e-mail e senza documento, o document senza document_type.",
    "biometric.rForbidden": "Token senza l'ambito biometrico, o IP fuori dalla allowlist.",
    "biometric.rRateLimited": "Limite di richieste al minuto raggiunto.",
    "biometric.photoSummary": "Aggiungi foto di riferimento",
    "biometric.photoDesc": "Invia la foto in \"photo\" (file multipart o base64/data-URI nel JSON). L'immagine di solito proviene da un documento (carta d'identità, patente…): il volto viene rilevato e viene memorizzato SOLO il ritaglio dell'area della foto (3:4, con margini di capelli/spalle) — mai il documento completo. Una foto che la persona possiede già (identica o quasi identica) restituisce 204 e non viene salvato nulla.",
    "biometric.pPersonId": "L'id della persona (restituito da /people/add).",
    "biometric.pPhoto": "File (multipart/form-data) o stringa base64/data-URI (JSON).",
    "biometric.rPhotoStored": "Foto ritagliata e memorizzata.",
    "biometric.rPhotoDuplicate": "La persona possiede già questa foto (duplicata) — nulla salvato.",
    "biometric.rNoFace": "Nessun volto trovato nell'immagine (reason: no_face).",
    "biometric.rInvalidImage": "Immagine non valida/corrotta o campo photo mancante.",
    "biometric.rPersonNotFound": "Persona non trovata (o di un'altra azienda).",
    "apiTokenForm.biometricScope": "API biometrica (/biometric/*)",
    "apiTokenForm.biometricScopeAria": "API biometrica",
    "account.resetMfa": "Reimposta MFA",
    "common.country.placeholder": "BR, US, ES, IT...",
    "clientApps.title": "Applicazioni client",
    "clientApps.subtitle": "Sistemi che integrano la verifica liveness via API (client_id / client_secret).",
    "clientApps.new": "Nuovo client",
    "clientApps.empty": "Nessun client registrato.",
    "clientApps.clientId": "Client ID",
    "clientApps.active": "Attivo",
    "clientApps.inactive": "Inattivo",
    "clientApps.deleteTitle": "Rimuovi client",
    "clientApps.deleteBodyPrefix": "Vuoi rimuovere",
    "clientApps.deleteBodySuffix": "? Le chiamate con queste credenziali smetteranno di funzionare.",
    "clientAppForm.credentialsTitle": "Credenziali del client",
    "clientAppForm.secretWarnPrefix": "Salva il",
    "clientAppForm.secretWarnSuffix": "ora — viene mostrato solo una volta e non può essere recuperato.",
    "clientAppForm.clientSecret": "Client Secret",
    "clientAppForm.done": "Fatto",
    "clientAppForm.loadError": "Impossibile caricare il client.",
    "clientAppForm.saveError": "Salvataggio non riuscito.",
    "clientAppForm.rotateError": "Rotazione del segreto non riuscita.",
    "clientAppForm.editTitle": "Modifica client",
    "clientAppForm.newTitle": "Nuovo client",
    "clientAppForm.rotateSecret": "Ruota segreto",
    "clientAppForm.webhookUrl": "URL del webhook",
    "clientAppForm.webhookUrlHelpPrefix": "Riceve l'evento",
    "clientAppForm.webhookUrlHelpSuffix": "(firmato). Vuoto disattiva il push (usa il polling).",
    "clientAppForm.webhookSecret": "Webhook Secret (HMAC)",
    "clientAppForm.webhookSecretPlaceholder": "minimo 16 caratteri",
    "clientAppForm.webhookSecretHelpPrefix": "Chiave usata per firmare il webhook:",
    "clientAppForm.webhookSecretHelpCode": "X-SecFace-Signature: sha256=<HMAC-SHA256 del corpo>",
    "clientAppForm.webhookSecretHelpSuffix": "Configura questo stesso valore nel sistema client per validare la firma. Vuoto mantiene quello attuale.",
    "clientAppForm.redirectUris": "Redirect URI consentiti",
    "clientAppForm.redirectUrisPlaceholder": "https://app.esempio.com/callback https://…",
    "clientAppForm.redirectUrisHelp": "Uno per riga. Il redirect_uri di /start deve iniziare con uno di essi.",
    "clientAppForm.emailReports": "Invia i rapporti via e-mail al cliente",
    "clientAppForm.emailReportsHelp": "Se attivo, a ogni sessione di vivacità approvata il PDF firmato viene inviato ai destinatari sotto e alla persona validata.",
    "clientAppForm.reportEmails": "E-mail destinatari",
    "clientAppForm.reportEmailsPlaceholder": "uno per riga o separati da virgola",
    "clientAppForm.reportEmailsHelp": "Destinatari che ricevono il rapporto di ogni verifica approvata.",
    "clientAppForm.policyNotePrefix": "Politica predefinita dell'azienda. Lascia su",
    "clientAppForm.policyNoteInherit": "Eredita",
    "clientAppForm.policyNoteMiddle": "/ vuoto per usare il valore globale. Il client può sovrascrivere per sessione su",
    "clientAppForm.aiThreshold": "Soglia IA (%)",
    "clientAppForm.inheritGlobal": "Eredita globale",
    "clientAppForm.requireGeo": "Richiedi geolocalizzazione",
    "clientAppForm.requireGesture": "Richiedi gesto",
    "clientAppForm.yes": "Sì",
    "clientAppForm.no": "No",
    "globalConfig.loadError": "Impossibile caricare la configurazione globale.",
    "globalConfig.saveError": "Salvataggio non riuscito.",
    "globalConfig.title": "Configurazione globale",
    "globalConfig.subtitle": "Impostazioni predefinite globali del criterio di liveness (livello di precedenza più basso).",
    "globalConfig.precedence": "cliente > azienda (ClientApp) > globale",
    "globalConfig.aiThreshold": "Soglia IA (%)",
    "globalConfig.aiThresholdHelp": "Soglia di identificazione/liveness quando né il cliente né il ClientApp la definiscono.",
    "globalConfig.sessionTtl": "TTL della sessione (secondi)",
    "globalConfig.sessionTtlHelp": "Validità di una sessione dopo /start.",
    "globalConfig.requireGeo": "Richiedi la geolocalizzazione per impostazione predefinita",
    "globalConfig.requireGeoAria": "Richiedi geolocalizzazione",
    "globalConfig.requireGesture": "Richiedi la sfida con gesto per impostazione predefinita",
    "globalConfig.requireGestureAria": "Richiedi gesto",
    "liveness.title": "Verifica dell'identità",
    "liveness.intro": "Questo esame richiede una verifica dell'identità (liveness) prima di condividere lo schermo. Completa i due passaggi seguenti per continuare.",
    "liveness.stepLocation": "Posizione",
    "liveness.geoRequiredHint": "Obbligatoria per continuare.",
    "liveness.geoOptionalHint": "Verrà richiesta; puoi rifiutare.",
    "liveness.geoNotProvided": "Posizione non fornita",
    "liveness.geoEnabled": "Posizione abilitata",
    "liveness.requesting": "Richiesta in corso…",
    "liveness.enableGeo": "Abilita geolocalizzazione",
    "liveness.declineGeo": "Non fornire la posizione",
    "liveness.faceCapture": "Acquisizione del volto",
    "liveness.captureHint": "Avvicina il viso al cerchio, guarda la fotocamera e tieni gli occhi aperti. L'intero processo viene registrato.",
    "liveness.startCapture": "Avvia acquisizione del volto",
    "liveness.unsupportedTitle": "Browser non supportato",
    "liveness.unsupportedBody": "Questo browser non supporta l'acquisizione video necessaria (WebCodecs). Copia il link qui sotto e aprilo in un altro browser aggiornato (Chrome o Edge, su computer o Android).",
    "common.copied": "Copiato",
    "liveness.declineTitle": "Non fornire la posizione?",
    "liveness.declineBody": "Sei sicuro di non voler fornire la tua posizione? Il rifiuto viene registrato nella tua verifica.",
    "liveness.cancel": "Annulla",
    "liveness.confirmDecline": "Sì, non fornire",
    "liveness.geoRequired": "Devi consentire la tua posizione esatta per continuare. Concedi l'autorizzazione e riprova.",
    "liveness.geoValidateFailed": "Impossibile convalidare la posizione.",
    "liveness.geoNoContinue": "Impossibile continuare senza la posizione.",
    "liveness.cannotContinue": "Impossibile continuare.",
    "liveness.startingCamera": "Avvio della fotocamera…",
    "liveness.cameraDenied": "Consenti l'accesso alla fotocamera per continuare.",
    "liveness.cameraFailed": "Impossibile avviare la fotocamera.",
    "liveness.tooManyInterruptions": "Troppe interruzioni della connessione. Controlla la tua connessione e riprova.",
    "liveness.connectionInterrupted": "Connessione interrotta — riavvio della verifica…",
    "liveness.hdrGesture": "Sfida del gesto",
    "liveness.hdrMotion": "Avvicinamento",
    "liveness.hdrFlash": "Verifica della luce",
    "liveness.altCapture": "acquisizione",
    "liveness.retry": "Riprova",
    "liveness.checking": "Convalida in corso…",
    "liveness.verifying": "Verifica in corso…",
    "liveness.completeFailed": "Impossibile completare la verifica.",
    "liveness.gestureHold": "Perfetto! Mantieni il gesto…",
    "liveness.gesturePrompt": "Esegui il gesto richiesto",
    "liveness.lookAtScreen": "Guarda lo schermo",
    "liveness.fitFaceInCircle": "Inquadra il viso nel cerchio",
    "liveness.fitFaceInSmallerCircle": "Ora inquadra il viso nel cerchio più piccolo",
    "liveness.holdStill": "Tieni il viso fermo… {n}s",
    "liveness.guidance.no_face": "Posiziona il viso all'interno del cerchio",
    "liveness.guidance.multiple_faces": "Solo tu devi apparire nella fotocamera",
    "liveness.guidance.too_far": "Avvicina il viso alla fotocamera",
    "liveness.guidance.fill_oval": "Avvicina il viso per riempire il cerchio",
    "liveness.guidance.too_close": "Allontana un po' il viso",
    "liveness.guidance.not_frontal": "Guarda direttamente la fotocamera",
    "liveness.guidance.off_center": "Centra il viso nel cerchio",
    "liveness.guidance.blurry": "Migliora l'illuminazione e resta fermo — l'immagine non è nitida",
    "liveness.guidance.low_confidence": "Viso non rilevato chiaramente",
    "liveness.guidance.ok": "Perfetto! Mantieni il viso…",
    "liveness.guidance.detector_unavailable": "Verifica in corso…",
    "liveness.guidance.decode_failed": "Regolazione della fotocamera…",
    "liveness.guidance.flash_fill_oval": "Avvicinati e inquadra il volto nel cerchio più grande",
    "liveness.guidance.flash_hold_fit": "Inquadrato! Resta fermo…",
    "liveness.guidance.flash_hold": "Mantieni il volto nel cerchio finché i flash non si fermano",
    "gesture.instr.v_over_eye": "Fai la \"V\" (dita indice e medio) e porta la mano davanti al viso, con le dita su uno degli occhi.",
    "gesture.instr.open_palm": "Alza una mano aperta accanto al viso, con le dita ben distese (a ventaglio).",
    "gesture.instr.thumbs_up": "Fai il gesto del \"pollice in su\" vicino al viso.",
    "gesture.instr.hand_on_cheek": "Appoggia il palmo di una mano su una delle guance.",
    "people.title": "Persone",
    "people.matchCount": "{n} corrispondenza/e per similarità",
    "people.peopleCount": "{n} persona/e",
    "people.searchPlaceholder": "Nome, documento, e-mail…",
    "people.searchByPhoto": "Cerca per foto",
    "people.errNoFace": "Nessun volto utilizzabile nella foto caricata.",
    "people.errSearchFailed": "Ricerca per foto non riuscita.",
    "people.sortedBySimilarity": "Risultati ordinati per similarità facciale.",
    "people.facesMatchCount": "{f} volto(i) rilevato(i) · {n} corrispondenza(e)",
    "people.extractedFaces": "Volti estratti dall'immagine",
    "people.faceHint": "Volto {i} — {n} corrispondenza(e)",
    "people.nMatches": "{n} match",
    "people.faceNoMatch": "Nessuna corrispondenza per il volto selezionato.",
    "people.identity": "Identità",
    "people.createdAt": "Registrato il",
    "people.noPhotos": "Nessuna foto di riferimento.",
    "people.linkedSessions": "Verifiche collegate",
    "people.noSessions": "Nessuna verifica collegata.",
    "common.email": "E-mail",
    "people.clear": "cancella",
    "people.empty": "Nessuna persona trovata.",
    "people.colSimilarity": "Similarità",
    "people.colPerson": "Persona",
    "people.colDocument": "Documento",
    "people.colPhotos": "Foto",
    "people.colValidations": "Convalide",
    "status.passed": "Approvato",
    "status.failed": "Negato",
    "status.pending": "In sospeso",
    "status.expired": "Scaduto",
    "sessions.title": "Verifiche",
    "sessions.refresh": "Aggiorna",
    "sessions.loadedCount": "{n} caricate",
    "sessions.filterAll": "Tutti",
    "sessions.searchPlaceholder": "Nome, e-mail, sessione…",
    "sessions.empty": "Nessuna verifica trovata.",
    "sessions.colDate": "Data",
    "sessions.colParticipant": "Partecipante",
    "sessions.colSession": "Sessione",
    "sessions.colStatus": "Stato",
    "sessions.colApproved": "Approvato",
    "sessions.yes": "Sì",
    "sessions.no": "No",
    "sessions.deepFlaggedTip": "Deep PAD ha segnalato questa sessione",
    "sessionDetail.title": "Liveness",
    "sessionDetail.notFound": "Verifica non trovata.",
    "sessionDetail.loadFailed": "Impossibile caricare la verifica.",
    "sessionDetail.padLabel": "PAD",
    "sessionDetail.padOk": "OK",
    "sessionDetail.padFlagged": "SEGNALATO",
    "sessionDetail.padError": "errore",
    "sessionDetail.padAnalyzing": "in analisi",
    "sessionDetail.photoFace": "Volto",
    "sessionDetail.photoFull": "Inquadratura completa",
    "sessionDetail.photoGesture": "Gesto",
    "sessionDetail.completedAt": "Completato il",
    "sessionDetail.geolocation": "Geolocalizzazione",
    "sessionDetail.geoNotProvided": "non fornita",
    "sessionDetail.location": "Posizione",
    "sessionDetail.viaGeo": "tramite geolocalizzazione",
    "sessionDetail.viaIp": "tramite IP",
    "sessionDetail.localDetection": "Rilevamento locale",
    "sessionDetail.detShort": "det",
    "sessionDetail.frontality": "frontalità",
    "sessionDetail.depth": "Profondità",
    "sessionDetail.flashmark": "Flashmark",
    "sessionDetail.aiLiveness": "IA Vivacità",
    "sessionDetail.aiProbability": "Vitalità (IA)",
    "sessionDetail.aiVerdict": "Parere dell'IA",
    "sessionDetail.padAnalysis": "Analisi PAD",
    "sessionDetail.aiGesture": "IA Gesto",
    "sessionDetail.gestureChallenge": "Sfida di gesto",
    "sessionDetail.aiProbabilityGesture": "Gesto corretto (IA)",
    "sessionDetail.samePerson": "stessa persona",
    "sessionDetail.aiVerdictGesture": "Parere dell'IA gesto",
    "sessionDetail.padAnalysisGesture": "Analisi PAD gesto",
    "sessionDetail.session": "Sessione",
    "sessionDetail.client": "Azienda",
    "sessionDetail.created": "Creata",
    "sessionDetail.attempts": "Tentativi",
    "sessionDetail.language": "Lingua",
    "reason.REAL_3D": "3D — parallasse di volto vivo",
    "reason.FLAT_SPOOF": "superficie piatta — possibile spoof",
    "reason.LIVE": "il volto ha riflesso il pattern di luce",
    "reason.SPOOF": "il volto non ha riflesso il flash",
    "reason.inconclusive": "non conclusivo",
    "reason.geo_required": "geolocalizzazione obbligatoria",
    "reason.local:no_face": "nessun volto rilevato",
    "reason.local:multiple_faces": "più volti rilevati",
    "reason.local:not_frontal": "volto non frontale",
    "reason.local:too_close": "volto troppo vicino",
    "reason.local:fill_oval": "volto troppo piccolo nell'ovale",
    "reason.local:off_center": "volto non centrato",
    "reason.local:blurry": "immagine sfocata",
    "reason.local:low_confidence": "bassa affidabilità di rilevamento",
    "reason.local:decode_failed": "decodifica immagine non riuscita",
    "reason.local:detector_unavailable": "rilevatore non disponibile",
    "reason.local:ok": "ok",
    // --- added: SecFace liveness/admin screens ---
    "report.download": "Scarica il rapporto PDF firmato",
    // --- added: SecFace liveness/admin screens ---
    "video.watch": "Guarda il video",
    "video.download": "Scarica il video",
    "video.hide": "Nascondi il video",
    "video.title": "Sessione di liveness registrata",
    "video.unavailable": "Registrazione non disponibile per questa sessione.",
    // --- added: SecFace liveness/admin screens ---
    "sessions.colReport": "Rapporto",
    // --- added: SecFace liveness/admin screens ---
    "sessions.colSigned": "Firmato",
    // --- added: SecFace liveness/admin screens ---
    "sessions.filterStatus": "Stato",
    // --- added: SecFace liveness/admin screens ---
    "sessions.signedWaiting": "In attesa del PAD",
    "sessions.signedError": "Errore",
    "sessions.copyId": "Copia ID sessione",
  },
};
